import * as i0 from '@angular/core';
import { InjectionToken, inject, Injectable, ChangeDetectionStrategy, Component, Pipe, DestroyRef, signal, ElementRef, input, HostListener, Input, ViewChild, computed, output } from '@angular/core';
import { filter, withLatestFrom, distinctUntilChanged, switchMap, first, catchError, map as map$1, tap, delay, takeUntil, debounceTime, exhaustMap, takeWhile, skip as skip$1 } from 'rxjs/operators';
import { createAction, props, createReducer, on, createFeature, Store, createSelector } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { skip, share, merge, Subject, interval, map, from, take, fromEvent, timer, of, combineLatest, switchMap as switchMap$1, timeout, retryWhen, tap as tap$1, startWith, combineLatestWith, takeUntil as takeUntil$1, auditTime, EMPTY, debounceTime as debounceTime$1, scan, concatMap, animationFrameScheduler, Observable, BehaviorSubject, first as first$1, distinctUntilChanged as distinctUntilChanged$1, concat } from 'rxjs';
import { concatLatestFrom, mapResponse } from '@ngrx/operators';
import { Falsy, Truthy, Logger, calculateMedian, clampf, Signal, tapLog, generateUuid, COLOR_CODES, where, KeyboardNumericCode, InvertedKeyMap, Semaphore, isEmpty, lerp, getCanvasCached, getSnapshot, whereNot, HEXtoRGB, RGBtoHSV, inverseLerp, HSVtoRGB, RGBtoHEX, fpIsASameAsB, fitIntoRectangle } from '@3dsource/utils';
import { HttpClient } from '@angular/common/http';
import { toSignal, takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { DialogRef, DIALOG_DATA, Dialog } from '@angular/cdk/dialog';
import { ScrollStrategyOptions } from '@angular/cdk/overlay';
import { SourceButtonComponent, SourceIconButtonComponent, SourceLoadingComponent } from '@3dsource/source-ui-native';
import { MetaBoxCommand } from '@3dsource/types-unreal';
import { NgClass, NgOptimizedImage, AsyncPipe, JsonPipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import * as i1 from '@angular/forms';
import { FormsModule } from '@angular/forms';
function ClickableOverlayComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵelement(2, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 5)(4, "h3", 6);
    i0.ɵɵtext(5, "Session will time out soon");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "p");
    i0.ɵɵtext(7, " No activity detected. Press 'Continue' if you wish to keep your session active ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "src-button", 7);
    i0.ɵɵtext(9, " Continue ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", (tmp_2_0 = ctx_r1.state()) == null ? null : tmp_2_0.message, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("colorScheme", "primary")("isFullWidth", true)("size", "large")("data-testid", "continue-session");
  }
}
function ClickableOverlayComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("click", function ClickableOverlayComponent_Conditional_0_Template_div_click_0_listener() {
      let tmp_2_0;
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView((tmp_2_0 = ctx_r1.state()) == null ? null : tmp_2_0.onOverlayClick());
    });
    i0.ɵɵconditionalCreate(1, ClickableOverlayComponent_Conditional_0_Conditional_1_Template, 10, 5, "div", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_1_0;
    let tmp_2_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", (tmp_1_0 = ctx_r1.state()) == null ? null : tmp_1_0.className);
    i0.ɵɵadvance();
    i0.ɵɵconditional(((tmp_2_0 = ctx_r1.state()) == null ? null : tmp_2_0.isActivityDetected) ? 1 : -1);
  }
}
function FreezeFrameComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElement(0, "img", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵdomProperty("src", ctx_r0.combinedFreeze(), i0.ɵɵsanitizeUrl);
  }
}
function FreezeFrameComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 2);
    i0.ɵɵtext(1);
    i0.ɵɵdomElementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.freezeFrameProgressMessageFromVideo(), " ");
  }
}
function AfkRestartScreenLockerComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngSrc", ctx_r0.imageLoadingSrc());
  }
}
function AfkRestartScreenLockerComponent_Conditional_0_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1, " Your stream has been paused due to inactivity ");
    i0.ɵɵelementEnd();
  }
}
function AfkRestartScreenLockerComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵconditionalCreate(2, AfkRestartScreenLockerComponent_Conditional_0_Conditional_3_Conditional_2_Template, 2, 0, "div", 5);
    i0.ɵɵelementStart(3, "src-button", 6);
    i0.ɵɵlistener("onClick", function AfkRestartScreenLockerComponent_Conditional_0_Conditional_3_Template_src_button_onClick_3_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.connect());
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.isSecondStart() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("isFullWidth", true)("size", "large")("colorScheme", "primary")("data-testid", "connect-button");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.isSecondStart() ? "Resume" : "Start", " ");
  }
}
function AfkRestartScreenLockerComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
    i0.ɵɵconditionalCreate(2, AfkRestartScreenLockerComponent_Conditional_0_Conditional_2_Template, 1, 1, "img", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(3, AfkRestartScreenLockerComponent_Conditional_0_Conditional_3_Template, 5, 6, "div", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.imageLoadingSrc() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.showReconnectPopup() ? 3 : -1);
  }
}
const _c0 = ["graph"];
const _forTrack0 = ($index, $item) => $item.key + $index;
function VideoStatsComponent_Conditional_0_Conditional_0_For_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 11);
    i0.ɵɵlistener("click", function VideoStatsComponent_Conditional_0_Conditional_0_For_14_Template_li_click_0_listener($event) {
      const graph_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.toggleGraph($event, graph_r4.key, 0));
    });
    i0.ɵɵelement(1, "app-stat-graph", 12);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const graph_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("label", graph_r4.key)("dataTick", i0.ɵɵpipeBind1(2, 3, graph_r4.stat))("color", graph_r4.color);
  }
}
function VideoStatsComponent_Conditional_0_Conditional_0_For_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵlistener("click", function VideoStatsComponent_Conditional_0_Conditional_0_For_17_Template_div_click_0_listener($event) {
      const el_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.toggleGraph($event, el_r6.key, el_r6.value));
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "json");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const el_r6 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", el_r6.key, ": ");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 2, el_r6.value), " ");
  }
}
function VideoStatsComponent_Conditional_0_Conditional_0_Conditional_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
    i0.ɵɵpipe(1, "safe");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r1.ssInfo(), "html"), i0.ɵɵsanitizeHtml);
  }
}
function VideoStatsComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
    i0.ɵɵlistener("click", function VideoStatsComponent_Conditional_0_Conditional_0_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggle());
    });
    i0.ɵɵtext(2, "Stats");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 2);
    i0.ɵɵlistener("click", function VideoStatsComponent_Conditional_0_Conditional_0_Template_div_click_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggle());
    });
    i0.ɵɵelementStart(4, "div", 3)(5, "div", 4);
    i0.ɵɵlistener("click", function VideoStatsComponent_Conditional_0_Conditional_0_Template_div_click_5_listener($event) {
      i0.ɵɵrestoreView(_r1);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelementStart(6, "li");
    i0.ɵɵelement(7, "app-stat-graph", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "li");
    i0.ɵɵelement(9, "app-stat-graph", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "li");
    i0.ɵɵelement(11, "app-stat-graph", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div");
    i0.ɵɵrepeaterCreate(13, VideoStatsComponent_Conditional_0_Conditional_0_For_14_Template, 3, 5, "li", 8, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵpipe(15, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵrepeaterCreate(16, VideoStatsComponent_Conditional_0_Conditional_0_For_17_Template, 5, 4, "div", 9, _forTrack0);
    i0.ɵɵelementEnd()();
    i0.ɵɵconditionalCreate(18, VideoStatsComponent_Conditional_0_Conditional_0_Conditional_18_Template, 2, 4, "div", 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("min", ctx_r1.collapsed);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("dataTick", ctx_r1.fpsTick());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("dataTick", ctx_r1.videoQP());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("dataTick", ctx_r1.bitrateTick());
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(i0.ɵɵpipeBind1(15, 6, ctx_r1.graphList$));
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r1.videoStatus());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.collapsed ? 18 : -1);
  }
}
function VideoStatsComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, VideoStatsComponent_Conditional_0_Conditional_0_Template, 19, 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.viewportReady() ? 0 : -1);
  }
}
function UnrealStatusComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
    i0.ɵɵelement(2, "src-loading", 2);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("size", 30)("backgroundStrokeColor", "#E5E7EB")("progressStrokeColor", "#1F2937");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.messagePercents$(), "% ");
  }
}
function UnrealStatusComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-video-stats");
  }
}
const _c1 = ["container"];
const _c2 = [[["app-video-locker"]], [["app-pdf"]], [["app-show-case"]], [["app-low-bandwidth-detector"]]];
const _c3 = ["app-video-locker", "app-pdf", "app-show-case", "app-low-bandwidth-detector"];
const _c4 = ["videoPlayerCover"];
function VideoLockerComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "img", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSrc", ctx);
  }
}
function VideoLockerComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 2, 0);
  }
}
function FilterSettingsComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "h3");
    i0.ɵɵtext(2, "LBM Trigger Settings");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "h5");
    i0.ɵɵtext(4, "Data Flow Monitor");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "form")(6, "label");
    i0.ɵɵtext(7, " Monitoring delay: ");
    i0.ɵɵelementStart(8, "input", 3);
    i0.ɵɵtwoWayListener("ngModelChange", function FilterSettingsComponent_Conditional_3_Template_input_ngModelChange_8_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.settings.monitoringDelayTime, $event) || (ctx_r1.settings.monitoringDelayTime = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "label");
    i0.ɵɵtext(10, " Minimum Bitrate (kbit/s): ");
    i0.ɵɵelementStart(11, "input", 4);
    i0.ɵɵtwoWayListener("ngModelChange", function FilterSettingsComponent_Conditional_3_Template_input_ngModelChange_11_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.settings.minimumBitrate, $event) || (ctx_r1.settings.minimumBitrate = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "label");
    i0.ɵɵtext(13, " Yellow Flag (%): ");
    i0.ɵɵelementStart(14, "input", 5);
    i0.ɵɵtwoWayListener("ngModelChange", function FilterSettingsComponent_Conditional_3_Template_input_ngModelChange_14_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.settings.yellowFlag, $event) || (ctx_r1.settings.yellowFlag = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "label");
    i0.ɵɵtext(16, " Red Flag (%): ");
    i0.ɵɵelementStart(17, "input", 6);
    i0.ɵɵtwoWayListener("ngModelChange", function FilterSettingsComponent_Conditional_3_Template_input_ngModelChange_17_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.settings.redFlag, $event) || (ctx_r1.settings.redFlag = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "label");
    i0.ɵɵtext(19, " Minimum FPS: ");
    i0.ɵɵelementStart(20, "input", 7);
    i0.ɵɵtwoWayListener("ngModelChange", function FilterSettingsComponent_Conditional_3_Template_input_ngModelChange_20_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.settings.minimumFps, $event) || (ctx_r1.settings.minimumFps = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(21, "hr");
    i0.ɵɵelementStart(22, "h5");
    i0.ɵɵtext(23, "Kalman Filter");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "label");
    i0.ɵɵtext(25, " Initial Bitrate Estimate (kbit/s): ");
    i0.ɵɵelementStart(26, "input", 8);
    i0.ɵɵtwoWayListener("ngModelChange", function FilterSettingsComponent_Conditional_3_Template_input_ngModelChange_26_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.settings.initialBitrateEstimate, $event) || (ctx_r1.settings.initialBitrateEstimate = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(27, "label");
    i0.ɵɵtext(28, " Initial Error Covariance: ");
    i0.ɵɵelementStart(29, "input", 9);
    i0.ɵɵtwoWayListener("ngModelChange", function FilterSettingsComponent_Conditional_3_Template_input_ngModelChange_29_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.settings.initialErrorCovariance, $event) || (ctx_r1.settings.initialErrorCovariance = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(30, "label");
    i0.ɵɵtext(31, " Process Noise (Q): ");
    i0.ɵɵelementStart(32, "input", 10);
    i0.ɵɵtwoWayListener("ngModelChange", function FilterSettingsComponent_Conditional_3_Template_input_ngModelChange_32_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.settings.processNoise, $event) || (ctx_r1.settings.processNoise = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(33, "label");
    i0.ɵɵtext(34, " Measurement Noise (R): ");
    i0.ɵɵelementStart(35, "input", 11);
    i0.ɵɵtwoWayListener("ngModelChange", function FilterSettingsComponent_Conditional_3_Template_input_ngModelChange_35_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.settings.measurementNoise, $event) || (ctx_r1.settings.measurementNoise = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(36, "br")(37, "br");
    i0.ɵɵelementStart(38, "div", 12)(39, "button", 13);
    i0.ɵɵlistener("click", function FilterSettingsComponent_Conditional_3_Template_button_click_39_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.reset());
    });
    i0.ɵɵtext(40, "Reset");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(41, "button", 13);
    i0.ɵɵlistener("click", function FilterSettingsComponent_Conditional_3_Template_button_click_41_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.saveSettings());
    });
    i0.ɵɵtext(42, "Apply");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.settings.monitoringDelayTime);
    i0.ɵɵproperty("placeholder", ctx_r1.defaultFilterModel.monitoringDelayTime);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.settings.minimumBitrate);
    i0.ɵɵproperty("placeholder", ctx_r1.defaultFilterModel.minimumBitrate);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.settings.yellowFlag);
    i0.ɵɵproperty("placeholder", ctx_r1.defaultFilterModel.yellowFlag);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.settings.redFlag);
    i0.ɵɵproperty("placeholder", ctx_r1.defaultFilterModel.redFlag);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.settings.minimumFps);
    i0.ɵɵproperty("placeholder", ctx_r1.defaultFilterModel.minimumFps);
    i0.ɵɵadvance(6);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.settings.initialBitrateEstimate);
    i0.ɵɵproperty("placeholder", ctx_r1.defaultFilterModel.initialBitrateEstimate);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.settings.initialErrorCovariance);
    i0.ɵɵproperty("placeholder", ctx_r1.defaultFilterModel.initialErrorCovariance);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.settings.processNoise);
    i0.ɵɵproperty("placeholder", ctx_r1.defaultFilterModel.processNoise);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.settings.measurementNoise);
    i0.ɵɵproperty("placeholder", ctx_r1.defaultFilterModel.measurementNoise);
  }
}
function LowBandwidthDetectorComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵlistener("click", function LowBandwidthDetectorComponent_Conditional_0_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleIndicator(true));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 3);
    i0.ɵɵelement(3, "path", 4)(4, "path", 5);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(5, "div", 6)(6, "p", 7);
    i0.ɵɵtext(7, " Fluid Interactivity Modes were disabled due to an unstable connection. ");
    i0.ɵɵelementStart(8, "button", 8);
    i0.ɵɵlistener("click", function LowBandwidthDetectorComponent_Conditional_0_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openLBMDialog());
    });
    i0.ɵɵtext(9, " Learn more ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "button", 9);
    i0.ɵɵlistener("click", function LowBandwidthDetectorComponent_Conditional_0_Template_button_click_10_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleIndicator(false));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(11, "svg", 10);
    i0.ɵɵelement(12, "path", 11);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("expanded", ctx_r1.isIndicatorExpanded() && ctx_r1.isLowBandwidth());
    i0.ɵɵadvance(5);
    i0.ɵɵclassProp("lbm-message--open", ctx_r1.isLowBandwidth() && ctx_r1.isIndicatorExpanded());
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("data-testid", "learn-more-lbm");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("data-testid", "close-lbm-indicator");
  }
}
function LowBandwidthDetectorComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-filter-settings");
  }
}
const WSCloseCode_NORMAL_CLOSURE = 3000;
const WSCloseCode_NORMAL_AFK_TIMEOUT = 3001;
const WSCloseCode_NORMAL_MANUAL_DISCONNECT = 3002;
const WSCloseCode_NORMAL_CIRRUS_CLOSED = 3003;
const WSCloseCodes = [WSCloseCode_NORMAL_CLOSURE, WSCloseCode_NORMAL_AFK_TIMEOUT, WSCloseCode_NORMAL_MANUAL_DISCONNECT, WSCloseCode_NORMAL_CIRRUS_CLOSED];
const DisconnectReason = {
  afk: 'afk',
  none: 'none',
  reset: 'reset',
  wsOnError: 'wsOnError',
  dataChannelClosed: 'dataChannelClosed',
  dataChannelTimeout: 'dataChannelTimeout'
};

/*
export interface RequestReservation extends InstanceMessageBase {
  type: 'requestReservation';
}
*/
const OrchestrationMessageTypes = {
  streamerList: 'streamerList',
  listStreamers: 'listStreamers',
  requestReservation: 'requestReservation',
  instanceReady: 'instanceReady',
  instanceReserved: 'instanceReserved',
  ssInfo: 'ssInfo',
  playerCount: 'playerCount',
  answer: 'answer',
  iceCandidate: 'iceCandidate',
  ping: 'ping',
  config: 'config',
  offer: 'offer'
};
const UnrealInternalSignalEvents = {
  OnVideoInitialized: 'OnVideoInitialized',
  RestAfkTimer: 'RestAfkTimer',
  FreezeFrameStart: 'FreezeFrameStart',
  UnrealCallback: 'UnrealCallback',
  ClickableOverlay: 'ClickableOverlay',
  VideoPlayClick: 'VideoPlayClick',
  ShowPlayButton: 'ShowPlayButton',
  ForceResizeViewport: 'ForceResizeViewport',
  VideoAdaptedToContainer: 'VideoAdaptedToContainer',
  TelemetryStart: 'TelemetryStart',
  TelemetryStop: 'TelemetryStop',
  TelemetryReset: 'TelemetryReset'
};
function AnswerHandler(msg) {
  this.onWebRtcAnswer$.next(msg);
}
function ConfigHandler(msg) {
  this.onConfig$.next(msg);
}
function IceCandidateHandler(msg) {
  this.onWebRtcIce$.next(msg.candidate);
}
function InstanceReadyHandler(_) {}
const scoped = templateString => `[UNREAL] ${templateString[0]}`;
const trackMixpanelEvent = createAction(scoped`track mixpanel event`, props());
const changeLowBandwidth = createAction(scoped`change low bandwidth`, props());
const setMaxFps = createAction(scoped`change fps`, props());
const destroyRemoteConnections = createAction(scoped`destroyRemoteConnections`, props());
const destroyConnectionsAndResetState = createAction(scoped`destroyConnections and reset`);
const setCirrusConnected = createAction(scoped`cirrusConnected`);
const setCirrusDisconnected = createAction(scoped`cirrusDisconnected`);
const changeStatusMainVideoOnScene = createAction(scoped`change status main video on scene`, props());
const setAwsInstance = createAction(scoped`set aws instance`, props());
const setStatusMessage = createAction(scoped`set status message`, props());
const setStatusPercentSignallingServer = createAction(scoped`change status percent signalling server`, props());
const setFreezeFrame = createAction(scoped`set freeze frame`, props());
const setMatchUrls = createAction(scoped`set match urls`, props());
const setStreamClientCompanyId = createAction(scoped`set stream client company id`, props());
const setStreamViewId = createAction(scoped`set stream view id`, props());
const setIntroImageSrc = createAction(scoped`set intro image src`, props());
const setLoadingImageSrc = createAction(scoped`set loading image src`, props());
const setIntroVideoSrc = createAction(scoped`set intro video src`, props());
const resetIntroSrc = createAction(scoped`reset intro src`);
const setFreezeFrameFromVideo = createAction(scoped`set freeze frame from video`, props());
const setEstablishingConnection = createAction(scoped`set establishing connection`, props());
const setDataChannelConnected = createAction(scoped`set data channel connected`, props());
const setConfig = createAction(scoped`set config`, props());
const setErrorMessage = createAction(scoped`set error message`, props());
const setViewportReady = createAction(scoped`set viewport ready`, props());
const changeStreamResolutionAction = createAction(scoped`change stream resolution`, props());
const changeStreamResolutionSuccessAction = createAction(scoped`change stream resolution success action`, props());
const setSignalingName = createAction(scoped`set aws instanceName`, props());
const updateCirrusInfo = createAction(scoped`set unrealInfo`, props());
const commandStarted = createAction(scoped`command started`, props());
const commandCompleted = createAction(scoped`command completed`, props());
const setLoopBackCommandIsCompleted = createAction(scoped`set loopBack command is completed`);
const showUnrealErrorMessage = createAction(scoped`show unreal error message`, props());
const initSignalling = createAction(scoped`init signalling`);
const resetConfig = createAction(scoped`reset config`);
const resetAfkAction = createAction(scoped`reset afk action`);
const resetWarnTimeout = createAction(scoped`reset config warn timeout`);
const resetUnrealStateAction = createAction(scoped`reset state`);
const resetUnrealState = createAction(scoped`reset unreal state`);
const SpecialKeyCodes = {
  BackSpace: 8,
  Shift: 16,
  Control: 17,
  Alt: 18,
  RightShift: 253,
  RightControl: 254,
  RightAlt: 255
};
// https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
const MouseButton = {
  MainButton: 0,
  // Left button.
  AuxiliaryButton: 1,
  // Wheel button.
  SecondaryButton: 2,
  // Right button.
  FourthButton: 3,
  // Browser Back button.
  FifthButton: 4 // Browser Forward button.
};
// https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
const MouseButtonsMask = {
  PrimaryButton: 1,
  // Left button.
  SecondaryButton: 2,
  // Right button.
  AuxiliaryButton: 4,
  // Wheel button.
  FourthButton: 8,
  // Browser Back button.
  FifthButton: 16 // Browser Forward button.
};
const EControlSchemeType = {
  // A mouse can lock inside the WebRTC player so the user can simply move the
  // mouse to control the orientation of the camera. The user presses the
  // Escape key to unlock the mouse.
  LockedMouse: 0,
  // A mouse can hover over the WebRTC player so the user needs to click and
  // drag to control the orientation of the camera.
  HoveringMouse: 1,
  Default: 2
};

// Must be kept in sync with PixelStreamingProtocol::EToUE4Msg C++ descriptors.
const EMessageType = {
  /*
   * Control Messages. Range = 0..49.
   */
  IFrameRequest: 0,
  RequestQualityControl: 1,
  MaxFpsRequest: 2,
  AverageBitrateRequest: 3,
  StartStreaming: 4,
  StopStreaming: 5,
  LatencyTest: 6,
  RequestInitialSettings: 7,
  /*
   * Input Messages. Range = 50..89.
   */
  // Generic Input Messages. Range = 50..59.
  UIInteraction: 50,
  Command: 51,
  // Keyboard Input Message. Range = 60..69.
  KeyDown: 60,
  KeyUp: 61,
  KeyPress: 62,
  // Mouse Input Messages. Range = 70..79.
  MouseEnter: 70,
  MouseLeave: 71,
  MouseDown: 72,
  MouseUp: 73,
  MouseMove: 74,
  MouseWheel: 75,
  // Touch Input Messages. Range = 80..89.
  TouchStart: 80,
  TouchEnd: 81,
  TouchMove: 82
};
const EToClientMessageType = {
  QualityControlOwnership: 0,
  Response: 1,
  Command: 2,
  FreezeFrame: 3,
  UnfreezeFrame: 4,
  VideoEncoderAvgQP: 5,
  LatencyTest: 6,
  InitialSettings: 7,
  InputControlOwnership: 12,
  Protocol: 255
};
const UNREAL_CONFIG = new InjectionToken('Unreal Initial Configuration');
const InputOptions = {
  controlScheme: EControlSchemeType.Default,
  suppressBrowserKeys: true,
  fakeMouseWithTouches: false
};
const UnrealStatusMessage = {
  CONNECTING_TO_SESSION: 'Connecting to session.',
  STARTING_YOUR_SESSION: 'Starting your session'
};
const DEBOUNCE_TO_MANY_RESIZE_CALLS = 100;
const SAME_SIZE_THRESHOLD = 1.01;
const MINIMAL_FPS = 6;
const STREAMING_VIDEO_ID = 'streamingVideo';
const CONSOLE_COMMAND_ENABLE_MESSAGES = 'EnableAllScreenMessages';
const CONSOLE_COMMAND_DISABLE_MESSAGES = 'DisableAllScreenMessages';
const CONSOLE_COMMAND_PIXEL_QUALITY = 'PixelStreaming.FreezeFrameQuality 95';
const FULL_HD_WIDTH = 1920;
const FULL_HD_HEIGHT = 1080;
const WS_TIMEOUT = 2000;
const WS_OPEN_STATE = 1;
const DEFAULT_AFK_TIMEOUT_PERIOD = 15;
const DEFAULT_AFK_TIMEOUT = 120;
const DATA_CHANNEL_CONNECTION_TIMEOUT = 8000; // 8000 ms;
const SIGNALLING_PERCENT_VALUE = 56;
const SCREEN_LOCKER_CONTAINER_ID = '3dsource_start_screen';
const initialState = {
  lowBandwidthStats: undefined,
  wasInitialized: false,
  isFirstSuccessLoad: false,
  lowBandwidth: false,
  cirrusConnected: false,
  establishingConnection: false,
  viewportReady: false,
  dataChannelConnected: false,
  isVideoPlaying: false,
  statusPercentSignallingServer: null,
  statusMessage: null,
  errorMessage: null,
  ssInfo: null,
  ssData: null,
  streamResolution: {
    width: null,
    height: null
  },
  freezeFrameFromVideo: {
    dataUrl: null,
    progress: null
  },
  freezeFrame: {
    dataUrl: null,
    progress: null
  },
  disconnectReason: DisconnectReason.none,
  awsInstance: {
    wsUrl: null,
    instanceName: null,
    pollingUrl: null
  },
  streamConfig: {
    autoStart: true,
    warnTimeout: DEFAULT_AFK_TIMEOUT,
    matchMakerUrls: []
  },
  loaderCommands: {
    commandsInProgress: [],
    totalCommandsStarted: 0,
    totalCommandsCompleted: 0
  },
  matchUrls: [],
  streamClientCompanyId: '',
  streamViewId: 'default',
  videoIntroSrc: null,
  imageIntroSrc: null,
  imageLoadingSrc: ''
};
const unrealReducer = createReducer(initialState, on(changeLowBandwidth, (state, {
  lowBandwidth,
  stats
}) => {
  return {
    ...state,
    lowBandwidth: lowBandwidth,
    lowBandwidthStats: lowBandwidth ? stats : undefined
  };
}), on(changeStatusMainVideoOnScene, (state, {
  isVideoPlaying
}) => {
  return {
    ...state,
    isVideoPlaying: isVideoPlaying
  };
}), on(setAwsInstance, (state, {
  instanceName,
  wsUrl,
  pollingUrl
}) => {
  return {
    ...state,
    awsInstance: {
      instanceName,
      wsUrl,
      pollingUrl
    }
  };
}), on(setViewportReady, (state, {
  value
}) => {
  return {
    ...state,
    viewportReady: value,
    statusMessage: value ? null : state.statusMessage,
    errorMessage: value ? null : state.errorMessage
  };
}), on(updateCirrusInfo, (state, {
  ssInfo,
  ssData
}) => {
  return {
    ...state,
    ssInfo: ssInfo,
    // For back compatibility
    ssData: ssData // Contains all the data from the ssInfo as object
  };
}), on(changeStreamResolutionSuccessAction, (state, {
  width,
  height
}) => {
  return {
    ...state,
    streamResolution: {
      width: width,
      height: height
    }
  };
}), on(setFreezeFrame, (state, freezeFrame) => {
  return {
    ...state,
    freezeFrame: {
      dataUrl: freezeFrame.progress === 0 || freezeFrame.progress === 1 || freezeFrame.progress === null ? freezeFrame.dataUrl : state.freezeFrame.dataUrl,
      progress: freezeFrame.progress || null
    }
  };
}), on(setErrorMessage, (state, errorMessage) => {
  if (state.dataChannelConnected) {
    return state;
  }
  return {
    ...state,
    errorMessage: errorMessage,
    statusMessage: null
  };
}), on(setFreezeFrameFromVideo, (state, freezeFrameFromVideo) => {
  return {
    ...state,
    freezeFrameFromVideo: {
      dataUrl: freezeFrameFromVideo.dataUrl,
      progress: freezeFrameFromVideo.progress || null
    }
  };
}), on(setStatusMessage, (state, {
  message
}) => {
  return {
    ...state,
    statusMessage: message
  };
}), on(setEstablishingConnection, (state, {
  value
}) => {
  return {
    ...state,
    establishingConnection: value
  };
}), on(setStatusPercentSignallingServer, (state, {
  percent
}) => {
  return {
    ...state,
    statusPercentSignallingServer: percent
  };
}), on(setDataChannelConnected, (state, {
  value
}) => {
  return {
    ...state,
    dataChannelConnected: value,
    wasInitialized: value ? true : state.wasInitialized
  };
}), on(setConfig, (state, {
  config
}) => {
  return {
    ...state,
    streamConfig: {
      ...state.streamConfig,
      ...config
    }
  };
}), on(resetConfig, state => {
  return {
    ...state,
    streamConfig: initialState.streamConfig
  };
}), on(resetWarnTimeout, state => {
  return {
    ...state,
    streamConfig: {
      ...state.streamConfig,
      warnTimeout: DEFAULT_AFK_TIMEOUT
    }
  };
}), on(setCirrusConnected, state => {
  return {
    ...state,
    cirrusConnected: true
  };
}), on(setCirrusDisconnected, state => {
  return {
    ...state,
    cirrusConnected: false
  };
}), on(initSignalling, state => {
  return {
    ...state,
    disconnectReason: DisconnectReason.none
  };
}), on(setSignalingName, (state, {
  instanceName
}) => {
  return {
    ...state,
    awsInstance: {
      ...state.awsInstance,
      instanceName
    }
  };
}), on(setLoopBackCommandIsCompleted, state => {
  return {
    ...state,
    isFirstSuccessLoad: true
  };
}), on(setMatchUrls, (state, {
  urls
}) => {
  return {
    ...state,
    matchUrls: urls
  };
}), on(setStreamClientCompanyId, (state, {
  id
}) => {
  return {
    ...state,
    streamClientCompanyId: id
  };
}), on(setStreamViewId, (state, {
  id
}) => {
  return {
    ...state,
    streamViewId: id
  };
}), on(setIntroImageSrc, (state, {
  src
}) => {
  return {
    ...state,
    imageIntroSrc: src
  };
}), on(setLoadingImageSrc, (state, {
  src
}) => {
  return {
    ...state,
    imageLoadingSrc: src
  };
}), on(setIntroVideoSrc, (state, {
  src
}) => {
  return {
    ...state,
    videoIntroSrc: src
  };
}), on(resetIntroSrc, state => {
  return {
    ...state,
    imageIntroSrc: '',
    videoIntroSrc: ''
  };
}), on(commandStarted, (state, {
  id,
  command
}) => {
  return {
    ...state,
    loaderCommands: {
      ...state.loaderCommands,
      totalCommandsStarted: state.loaderCommands.totalCommandsStarted + 1,
      commandsInProgress: [...state.loaderCommands.commandsInProgress, {
        id,
        command,
        timeStamp: new Date().getTime()
      }]
    }
  };
}), on(commandCompleted, (state, {
  id
}) => {
  return {
    ...state,
    loaderCommands: removeExileCommands(state.loaderCommands, id)
  };
}), on(resetUnrealState, state => {
  return {
    ...initialState,
    wasInitialized: state.wasInitialized,
    isFirstSuccessLoad: state.isFirstSuccessLoad,
    matchUrls: state.matchUrls,
    streamClientCompanyId: state.streamClientCompanyId,
    streamViewId: state.streamViewId,
    imageIntroSrc: state.imageIntroSrc,
    videoIntroSrc: state.videoIntroSrc,
    imageLoadingSrc: state.imageLoadingSrc
  };
}), on(resetUnrealStateAction, () => {
  return initialState;
}));
const unrealFeature = createFeature({
  name: 'unrealFeature',
  reducer: unrealReducer
});
class SubService {
  constructor() {
    this.store = inject(Store);
    this.disconnect$ = this.store.select(unrealFeature.selectCirrusConnected).pipe(skip(1), filter(Falsy), share());
  }
}
let AFKService = /*#__PURE__*/(() => {
  class AFKService extends SubService {
    constructor() {
      super();
      // Optionally detect if the user is not interacting (AFK) and disconnect them.
      this.enabled = true; // Set to true to enable the AFK system.
      this.closeTimeout = DEFAULT_AFK_TIMEOUT_PERIOD; // The time after the warning when we disconnect the user.
      this.active = false; // Whether the AFK system is currently looking for inactivity.
      this.countdown = 0; // The inactivity warning overlay has a countdown to show time until disconnect.
      this.selectWarnTimeout = this.store.selectSignal(selectWarnTimeout);
      this.isViewportReady = this.store.selectSignal(unrealFeature.selectViewportReady);
      this.initAfk();
    }
    initAfk() {
      merge(this.store.select(selectWarnTimeout), fromSignal(UnrealInternalSignalEvents.RestAfkTimer)).pipe(withLatestFrom(this.store.select(unrealFeature.selectViewportReady)), filter(([, viewportReady]) => viewportReady)).subscribe(() => this.resetAfkWarningTimer());
      this.store.select(unrealFeature.selectViewportReady).pipe(distinctUntilChanged(), filter(Truthy)).subscribe(() => this.startAfkWarningTimer());
      this.disconnect$.subscribe(() => this.stop());
    }
    init() {
      // do nothing, just to not forget to initialize Service
    }
    hideOverlay() {
      sendSignal(UnrealInternalSignalEvents.ClickableOverlay);
    }
    /**
     * Start a timer which when elapsed will warn the user they are inactive.
     */
    startAfkWarningTimer() {
      this.active = this.enabled;
      this.resetAfkWarningTimer();
    }
    /**
     * If the user interacts, then reset the warning timer.
     */
    resetAfkWarningTimer() {
      if (this.active) {
        this.stop();
        this.warnTimer = setTimeout(() => {
          this.showAfkOverlay();
        }, this.selectWarnTimeout() * 1000);
      }
    }
    /**
     * Update the count-down spans number for the overlay
     * @param countdown the count down number to be inserted into the span for updating
     */
    updateCountDown(countdown) {
      this.dispatchMessage(String(countdown));
    }
    /**
     * Update the text overlays inner text
     * @param message the update text to be inserted into the overlay
     */
    dispatchMessage(message) {
      sendSignal(UnrealInternalSignalEvents.ClickableOverlay, {
        message,
        isActivityDetected: true,
        className: 'clickableState',
        onOverlayClick: () => this.reset()
      });
    }
    stop() {
      clearInterval(this.countdownTimer);
      clearTimeout(this.warnTimer);
      this.hideOverlay();
    }
    reset() {
      this.hideOverlay();
      clearInterval(this.countdownTimer);
      this.startAfkWarningTimer();
    }
    showAfkOverlay() {
      if (!this.isViewportReady()) {
        return;
      }
      // Pause the timer while the user is looking at the inactivity warning overlay.
      this.active = false;
      this.countdown = this.closeTimeout;
      this.updateCountDown(this.countdown);
      if (InputOptions.controlScheme == EControlSchemeType.LockedMouse) {
        document.exitPointerLock();
      }
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          // The user failed to click so disconnect them
          this.hideOverlay();
          // TODO possible way (Blinking), because postponed close event: destroyRemoteConnections({ disconnectReason: DisconnectReason.afk }),
          this.store.dispatch(destroyConnectionsAndResetState());
          clearInterval(this.countdownTimer);
        } else {
          this.updateCountDown(this.countdown);
        }
      }, 1000);
    }
    static {
      this.ɵfac = function AFKService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AFKService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AFKService,
        factory: AFKService.ɵfac
      });
    }
  }
  return AFKService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FreezeFrameService = /*#__PURE__*/(() => {
  class FreezeFrameService extends SubService {
    constructor() {
      super(...arguments);
      this.receiving = false;
      this.size = 0;
      this.freezeFrameOverlay = new Image();
    }
    init() {
      this.store.select(unrealFeature.selectViewportReady).pipe(filter(Truthy)).subscribe(() => this.invalidate());
    }
    setData(view) {
      view = view.slice(1 + 4);
      const jpeg = new Uint8Array(this.jpeg.length + view.length);
      jpeg.set(this.jpeg, 0);
      jpeg.set(view, this.jpeg.length);
      this.jpeg = jpeg;
      if (this.jpeg.length === this.size) {
        this.receiving = false;
        Logger.info(`FRAME: Received complete freeze frame ${this.size}`);
        this.showFreezeFrame();
      } else if (this.jpeg.length > this.size) {
        Logger.error(`FRAME: Received bigger freeze frame than advertised: ${this.jpeg.length}/${this.size}`);
        this.store.dispatch(setFreezeFrame({
          dataUrl: null,
          progress: 0
        }));
        this.jpeg = undefined;
        this.receiving = false;
      } else {
        this.dispatchInProgress();
        /* Logger.warn(
          `received next chunk (${view.length} bytes) of freeze frame: ${this.jpeg.length}/${this.size}`,
        );*/
      }
    }
    dispatchInProgress() {
      this.store.dispatch(setFreezeFrame({
        dataUrl: null,
        progress: (this.jpeg?.length || 0) / this.size
      }));
    }
    start(view) {
      this.size = new DataView(view.slice(1, 5).buffer).getInt32(0, true);
      this.jpeg = view.slice(1 + 4);
      if (this.jpeg.length < this.size) {
        this.dispatchInProgress();
        sendSignal(UnrealInternalSignalEvents.FreezeFrameStart);
        Logger.info(`FRAME: Received first chunk of freeze frame: ${this.jpeg.length}/${this.size}`);
        this.receiving = true;
      } else {
        Logger.info(`FRAME: Received complete freeze frame: ${this.jpeg.length}/${this.size}`);
        this.receiving = false;
        this.showFreezeFrame();
      }
    }
    invalidate() {
      this.store.dispatch(setFreezeFrame({
        dataUrl: null,
        progress: null
      }));
      this.jpeg = undefined;
      this.receiving = false;
    }
    showFreezeFrame() {
      if (!this.jpeg) {
        return;
      }
      const base64 = btoa(this.jpeg?.reduce((data, byte) => data + String.fromCharCode(byte), ''));
      this.freezeFrameOverlay.src = 'data:image/jpeg;base64,' + base64;
      this.store.dispatch(setFreezeFrame({
        dataUrl: this.freezeFrameOverlay.src,
        progress: 1
      }));
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵFreezeFrameService_BaseFactory;
        return function FreezeFrameService_Factory(__ngFactoryType__) {
          return (ɵFreezeFrameService_BaseFactory || (ɵFreezeFrameService_BaseFactory = i0.ɵɵgetInheritedFactory(FreezeFrameService)))(__ngFactoryType__ || FreezeFrameService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FreezeFrameService,
        factory: FreezeFrameService.ɵfac
      });
    }
  }
  return FreezeFrameService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class DataFlowMonitor {
  /**
   * Initializes the DataFlowMonitor monitor.
   * @param yellowFlagThresholdPercentage - The percentage drop to trigger a YELLOW warning (default: 15%).
   * @param redFlagThresholdPercentage - The percentage drop to trigger a RED warning (default: 30%).
   * @param historyBufferLength - buffer length (default: 100).
   * @param splitPoint - The point at which to split the history buffer into two halves (default: 0.5).
   */
  constructor(yellowFlagThresholdPercentage = 15, redFlagThresholdPercentage = 30, historyBufferLength = 100, splitPoint = 0.5) {
    this.yellowFlagThresholdPercentage = yellowFlagThresholdPercentage;
    this.redFlagThresholdPercentage = redFlagThresholdPercentage;
    this.historyBufferLength = historyBufferLength;
    this.splitPoint = splitPoint;
    this.dataHistory = [];
  }
  reset() {
    this.dataHistory.length = 0;
  }
  config(data) {
    this.reset();
    this.yellowFlagThresholdPercentage = data.yellowFlag;
    this.redFlagThresholdPercentage = data.redFlag;
  }
  /**
   * Adds a new bitrate measurement and checks for significant drops.
   * @param currentValue - The current bitrate in kbps.
   * @returns BitrateCheckResult indicating if a drop was detected.
   */
  addValue(currentValue) {
    if (isNaN(currentValue) || currentValue < 1) {
      return {};
    }
    const historyLength = this.dataHistory.length;
    if (historyLength > this.historyBufferLength) {
      this.dataHistory.shift();
    }
    this.dataHistory.push(currentValue);
    if (historyLength < this.historyBufferLength) {
      this.dataHistory.length = this.historyBufferLength;
      this.dataHistory.fill(currentValue, 0, this.historyBufferLength);
    }
    const splitIndex = Math.floor(historyLength * this.splitPoint);
    const firstHalf = this.dataHistory.slice(0, splitIndex);
    const secondHalf = this.dataHistory.slice(splitIndex);
    const firstHalfMedian = calculateMedian(firstHalf);
    const secondHalfMedian = calculateMedian(secondHalf);
    const dropPercentage = clampf(0, 100, (firstHalfMedian - secondHalfMedian) / firstHalfMedian * 100);
    const isRedFlag = dropPercentage >= this.redFlagThresholdPercentage;
    if (dropPercentage >= this.yellowFlagThresholdPercentage) {
      return {
        config: {
          yellowFlagThresholdPercentage: this.yellowFlagThresholdPercentage,
          redFlagThresholdPercentage: this.redFlagThresholdPercentage,
          historyBufferLength: this.historyBufferLength,
          splitPoint: this.splitPoint
        },
        isDropDetected: true,
        dropPercentage,
        dataHistory: [...this.dataHistory],
        activeMedian: secondHalfMedian,
        quality: isRedFlag ? 'red' : 'orange',
        message: `Significant flow drop detected: ${dropPercentage.toFixed(2)}% (from ${firstHalfMedian} to ${secondHalfMedian})`
      };
    }
    return {
      config: {
        yellowFlagThresholdPercentage: this.yellowFlagThresholdPercentage,
        redFlagThresholdPercentage: this.redFlagThresholdPercentage,
        historyBufferLength: this.historyBufferLength,
        splitPoint: this.splitPoint
      },
      isDropDetected: false,
      dropPercentage,
      dataHistory: [...this.dataHistory],
      activeMedian: secondHalfMedian,
      quality: 'lime',
      message: 'Stable flow'
    };
  }
}

/**
 * Default LBM Filter Parameters
 */
const DefaultFilterModel = {
  minimumBitrate: 1600,
  yellowFlag: 30,
  redFlag: 50,
  minimumFps: 5,
  monitoringDelayTime: 5000,
  initialBitrateEstimate: 1600,
  initialErrorCovariance: 1,
  processNoise: 3,
  measurementNoise: 500,
  panelOpen: false
};
/**
 * Global LBM Filter Parameters
 */
const FilterModel = {
  ...DefaultFilterModel
};
/**
 * Bitrate Monitor Static Class
 */
const BITRATE_MONITOR = new DataFlowMonitor(FilterModel.yellowFlag, FilterModel.redFlag, 20);
let VideoService = /*#__PURE__*/(() => {
  class VideoService extends SubService {
    constructor() {
      super();
      this.latencyTestTimings = new LatencyTimings();
      this.videoTrack$ = new Subject();
      this.VideoEncoderQP = 0;
      this.aggregatedStats = {};
      this.kalmanFilter1D = new KalmanFilter1D(FilterModel.initialBitrateEstimate, FilterModel.initialErrorCovariance, FilterModel.processNoise, FilterModel.measurementNoise);
      /**
       * Aggregate video stats and emit it as videoStats$
       */
      this.videoStats$ = this.videoTrack$.pipe(
      // IMPORTANT! DO NOT CHANGE THOSE NUMBERS, LBM Stats are based on those values
      switchMap(({
        pcClient
      }) => interval(250).pipe(map(() => pcClient))), switchMap(pcClient => from(this.getStats(pcClient))), filter(Truthy), share());
      Signal.on('setKalmanParams').subscribe(data => {
        this.kalmanFilter1D.config(data);
        BITRATE_MONITOR.config(data);
      });
    }
    setContainer(container) {
      this.container = container;
    }
    setLatencyTimings(latencyTimings) {
      this.latencyTestTimings.SetUETimings(latencyTimings);
    }
    setEncoder(data) {
      this.VideoEncoderQP = Number(new TextDecoder('utf-16').decode(data));
    }
    create() {
      this.disconnect$.pipe(take(1)).subscribe(() => this.destroy());
      this.destroy();
      this.createWebRtcVideo();
      this.createWebRtcAudio();
    }
    attachVideoStream(stream, pcClient) {
      if (this.video) {
        this.video.srcObject = stream;
        this.videoTrack$.next({
          stream,
          pcClient
        });
      } else {
        console.error('Video element is not defined.');
      }
    }
    attachAudioStream(stream) {
      // do nothing the video has the same media stream as the audio track we have here (they are linked)
      if (this.video?.srcObject === stream) {
        return;
      }
      // video element has some other media stream that is not associated with this audio track
      else if (this.audio && this.video?.srcObject && this.video?.srcObject !== stream) {
        this.audio.srcObject = stream;
        this.playAudio(this.audio);
      }
    }
    play() {
      void this.video?.play();
    }
    async getStats(pcClient) {
      if (!pcClient) {
        return null;
      }
      const stats = await pcClient.getStats(null);
      return this.generateAggregatedStatsFunction(stats);
    }
    generateAggregatedStatsFunction(stats) {
      const newStat = {};
      // store each type of codec we can get stats on
      newStat.codecs = {};
      newStat.currentRoundTripTime = -1;
      stats.forEach(stat => {
        // Get the inbound-rtp for video
        if (stat.type === 'inbound-rtp' && stat.kind === 'video') {
          Object.assign(newStat, stat);
          newStat.bytesReceivedStart = this.aggregatedStats && this.aggregatedStats.bytesReceivedStart ? this.aggregatedStats.bytesReceivedStart : stat.bytesReceived;
          newStat.framesDecodedStart = this.aggregatedStats && this.aggregatedStats.framesDecodedStart ? this.aggregatedStats.framesDecodedStart : stat.framesDecoded;
          newStat.timestampStart = this.aggregatedStats && this.aggregatedStats.timestampStart ? this.aggregatedStats.timestampStart : stat.timestamp;
          if (this.aggregatedStats && this.aggregatedStats.timestamp) {
            // Get the mimetype of the video codec being used
            if (stat.codecId && this.aggregatedStats.codecs && Object.hasOwn(this.aggregatedStats.codecs, stat.codecId)) {
              newStat.videoCodec = this.aggregatedStats.codecs[stat.codecId];
            }
            if (this.aggregatedStats.bytesReceived) {
              // bitrate = bits received since last time / number of ms since last time
              // This is automatically in kbits (where k=1000) since time is in ms and stat we want is in seconds (so a '* 1000' then a '/ 1000' would negate each other)
              newStat.bitrate = Math.floor(8 * (newStat.bytesReceived - this.aggregatedStats.bytesReceived) / (newStat.timestamp - this.aggregatedStats.timestamp));
            }
            if (this.aggregatedStats.bytesReceivedStart) {
              newStat.avgBitrate = Math.floor(8 * (newStat?.bytesReceived - this.aggregatedStats.bytesReceivedStart) / (newStat.timestamp - this.aggregatedStats.timestampStart));
            }
            if (this.aggregatedStats.framesDecodedStart) {
              newStat.avgFrameRate = Math.floor((newStat.framesDecoded - this.aggregatedStats.framesDecodedStart) / ((newStat.timestamp - this.aggregatedStats.timestampStart) / 1000));
            }
          }
        }
        if (stat.type === 'candidate-pair' && Object.hasOwn(stat, 'currentRoundTripTime')) {
          newStat.currentRoundTripTime = stat.currentRoundTripTime ?? 0;
        }
        // Store mimetype of each codec
        if (Object.hasOwn(newStat, 'codecs') && stat.type === 'codec' && stat.mimeType && stat.id) {
          const codecId = stat.id;
          newStat.codecs[codecId] = stat.mimeType.replace('video/', '').replace('audio/', '');
        }
      });
      newStat.pixelRatio = +window.devicePixelRatio.toFixed(2);
      if (this.aggregatedStats.receiveToCompositeMs) {
        newStat.receiveToCompositeMs = this.aggregatedStats.receiveToCompositeMs;
        this.latencyTestTimings.SetFrameDisplayDeltaTime(this.aggregatedStats.receiveToCompositeMs);
      }
      // Calculate duration of run
      newStat.runTime = Math.floor((newStat.timestamp - newStat.timestampStart) / 1000);
      newStat.kalmanBitrate = Math.floor(this.kalmanFilter1D.update(newStat.bitrate || FilterModel.initialBitrateEstimate));
      newStat.dataFlowCheckResult = BITRATE_MONITOR.addValue(newStat.kalmanBitrate);
      newStat.bitrateDrop = Math.floor(newStat.dataFlowCheckResult.dropPercentage);
      this.aggregatedStats = newStat;
      return this.onAggregatedStats(newStat);
    }
    onAggregatedStats(aggregatedStats) {
      return {
        quality: mapQpToQuality(this.VideoEncoderQP),
        aggregatedStats: {
          ...aggregatedStats,
          VideoEncoderQP: this.VideoEncoderQP
        }
      };
    }
    destroy() {
      this.video = null;
      this.audio = null;
      while (this.container?.firstChild) {
        this.container.removeChild(this.container.firstChild);
      }
      this.store.dispatch(changeStatusMainVideoOnScene({
        isVideoPlaying: false
      }));
    }
    createWebRtcVideo() {
      dispatchResize();
      const video = document.createElement('video');
      video.id = STREAMING_VIDEO_ID;
      video.playsInline = true;
      video.muted = true;
      video.autoplay = true;
      video.preload = 'auto';
      video.disablePictureInPicture = true;
      this.video = video;
      this.container?.appendChild(this.video);
      this.video.addEventListener('play', () => {
        this.store.dispatch(changeStatusMainVideoOnScene({
          isVideoPlaying: true
        }));
      });
      fromEvent(this.video, 'loadedmetadata').pipe(first(), filter(data => this.video === data.target), tapLog('VideoService loadedmetadata:')).subscribe(() => sendSignal(UnrealInternalSignalEvents.OnVideoInitialized, this.video));
    }
    createWebRtcAudio() {
      const audio = new Audio();
      audio.id = 'streamingAudio';
      this.audio = audio;
    }
    playAudio(audio) {
      from(audio.play()).pipe(catchError(() => fromEvent(document, 'click')), take(1)).subscribe({
        next: () => audio.play(),
        error: () => ({})
      });
    }
    static {
      this.ɵfac = function VideoService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VideoService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VideoService,
        factory: VideoService.ɵfac
      });
    }
  }
  return VideoService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CommandTelemetryService = /*#__PURE__*/(() => {
  class CommandTelemetryService {
    constructor() {
      this.appId = 'metabox-telemetry';
      this.commandsSent = {};
      this.exileTimout = 60000;
      this.pollingTime = 5000;
      this.commandSequenceNumber = 0;
      this.payloads = [];
      this.httpClient = inject(HttpClient);
      this.unrealInitialConfig = inject(UNREAL_CONFIG, {
        optional: true
      });
      if (!this.unrealInitialConfig?.commandTelemetryReceiver) {
        return;
      }
      this.reset();
      this.sessionId = sessionStorage.getItem(this.appId) || this.uuid;
      this.userId = localStorage.getItem(this.appId) || this.uuid;
      sessionStorage.setItem(this.appId, this.sessionId);
      localStorage.setItem(this.appId, this.userId);
      this.start();
    }
    get timeNow() {
      return Date.now();
    }
    get sessionTime() {
      return this.timeNow - this.startTime;
    }
    get canSkipSending() {
      return !(this.timeNow - this.lastTime > this.pollingTime * 2);
    }
    decorate(funcToDecorate) {
      this.listenCallbacks();
      return this.wrapper.bind(this, funcToDecorate);
    }
    start() {
      fromSignal(UnrealInternalSignalEvents.TelemetryStart).subscribe(({
        externalId
      }) => {
        this.trackStartCommand(`EXT-${externalId}`);
      });
      fromSignal(UnrealInternalSignalEvents.TelemetryStop).subscribe(({
        externalId,
        payload
      }) => {
        const trackingId = `EXT-${externalId}`;
        this.trackStopCommand(trackingId, undefined, payload?.multi, payload);
      });
      fromSignal(UnrealInternalSignalEvents.TelemetryReset).subscribe(() => {
        this.reset();
      });
      timer(0, this.pollingTime).subscribe(() => {
        this.send(this.payloads);
      });
    }
    reset() {
      this.uuid = generateUuid();
      this.commandSequenceNumber = 0;
      this.viewId = this.uuid;
      this.startTime = this.timeNow;
      this.payloads.length = 0;
      this.commandsSent = {};
    }
    trackStartCommand(trackingId) {
      const out = {
        command: trackingId,
        trackingId
      };
      const timers = {
        sessionElapsedTime: this.sessionTime
      };
      this.pushStatToBuffer('commandSent', out, timers);
      this.trackTime(out);
    }
    trackStopCommand(trackingId, timeStampsRaw, multi = false, response = {}) {
      const commandResponse = this.commandsSent[trackingId];
      if (!commandResponse) {
        return;
      }
      const totalRoundTripTime = this.timeNow - commandResponse.timeStampJs;
      /**
       * Time between telemetry was reset and command was sent.
       */
      const commandSentJsTime = commandResponse.timeStampJs - this.startTime;
      let unrealTimers = {};
      const t = timeStampsRaw?.timeStampCommand;
      if (t) {
        unrealTimers = {
          unrealRoundTripTime: t.onCompleteCommand.timestamp - t.onRequestCommand.timestamp,
          unrealExecutionDuration: t.onCompleteCommand.timestamp - t.onStartCommand.timestamp,
          timeDiffRequest: t.onRequestCommand.timestamp - commandResponse.timeStampJs,
          timeDiffCallBack: this.timeNow - t.onCompleteCommand.timestamp
        };
      }
      const timers = {
        sessionElapsedTime: this.sessionTime,
        commandSentJsTime,
        totalRoundTripTime,
        ...unrealTimers
      };
      this.pushStatToBuffer('commandStop', {
        ...commandResponse.command,
        response
      }, timers, timeStampsRaw);
      if (!multi) {
        delete this.commandsSent[trackingId];
      }
    }
    pushStatToBuffer(type, commandContent, computedTimers, timeStampsRaw) {
      this.pushData({
        type,
        commandSequenceNumber: this.commandSequenceNumber++,
        commandContent,
        timeStampsRaw,
        computedTimers
      });
    }
    trackTime(command) {
      this.commandsSent[command.trackingId] = {
        timeStampJs: this.timeNow,
        command
      };
    }
    send(payload) {
      if (payload.length === 0 || this.canSkipSending && payload.length < 10) {
        return;
      }
      this.lastTime = this.timeNow;
      const out = {
        appId: this.appId,
        sessionId: this.sessionId,
        viewId: this.viewId,
        userId: this.userId,
        ua: navigator.userAgent,
        timeStamp: new Date(this.timeNow).toString(),
        href: location.href,
        resolution: {
          width: window.screen.width,
          height: window.screen.height,
          pixelRatio: window.devicePixelRatio
        },
        payload
      };
      const lastIndex = payload[payload.length - 1].commandSequenceNumber;
      this.httpClient.post(this.unrealInitialConfig?.commandTelemetryReceiver || '', out).pipe(first(), catchError(() => of(null))).subscribe(() => {
        this.payloads = this.payloads.filter(p => p.commandSequenceNumber > lastIndex);
      });
    }
    /**
     * Listens for Unreal Engine callbacks.
     * Subscribes to the Unreal Engine event loop back and filters out events that do not have a tracking ID.
     * When a callback with a tracking ID is received,
     * it stops tracking the time for that command and filters out commands
     * that have exceeded the timeout limit.
     */
    listenCallbacks() {
      fromSignal(UnrealInternalSignalEvents.UnrealCallback).pipe(filter(({
        json
      }) => {
        const callback = 'commandCallback' in json ? json.commandCallback : json;
        return Truthy(callback?.trackingId);
      })).subscribe(({
        json
      }) => {
        const callback = json.commandCallback;
        const timeStampsRaw = json.timeStamp;
        const trackingId = callback?.trackingId || '';
        this.trackStopCommand(trackingId, timeStampsRaw);
        this.removeExileCommands();
      });
    }
    pushData(payload) {
      this.payloads.push(payload);
    }
    /**
     * Removes commands that have exceeded the timeout limit.
     * Iterates over all the commands sent and checks if the difference between the current time
     * and the time the command was sent is greater than the timeout limit.
     * If it is, the command is marked for deletion.
     * After checking all commands, those marked for deletion are removed from the commands sent.
     * This method is used to ensure that commands that are not responded to within a certain time frame
     * do not remain in the commandsSent object indefinitely, which could lead to memory leaks over time.
     */
    removeExileCommands() {
      const time = new Date().getTime();
      const markForDelete = [];
      Object.entries(this.commandsSent).forEach(([trackingId, {
        timeStampJs
      }]) => {
        if (time - timeStampJs > this.exileTimout) {
          markForDelete.push(trackingId);
        }
      });
      markForDelete.forEach(trackingId => {
        delete this.commandsSent[trackingId];
      });
    }
    /**
     * Wraps the provided function with telemetry tracking.
     * Generates a unique tracking ID and adds it to the data object.
     * Pushes the command sent to the payloads with the tracking ID.
     * Starts tracking the time for the command.
     * Finally, calls the provided function with the modified data object.
     *
     * @param {IToBeDecorated} funcToDecorate - The function to be decorated with telemetry tracking.
     * @param {any} data - The data object to be passed to the function. It will be augmented with a unique tracking ID.
     */
    wrapper(funcToDecorate, data) {
      const out = {
        ...data,
        trackingId: generateUuid()
      };
      const timers = {
        sessionElapsedTime: this.sessionTime
      };
      this.pushStatToBuffer('commandSent', {
        ...out,
        trackingId: `${out.trackingId}`
      }, timers);
      this.trackTime(out);
      funcToDecorate(out);
    }
    static {
      this.ɵfac = function CommandTelemetryService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CommandTelemetryService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CommandTelemetryService,
        factory: CommandTelemetryService.ɵfac
      });
    }
  }
  return CommandTelemetryService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function TelemetryStart(externalId) {
  sendSignal(UnrealInternalSignalEvents.TelemetryStart, {
    externalId
  });
}
function TelemetryStop(externalId, payload) {
  sendSignal(UnrealInternalSignalEvents.TelemetryStop, {
    externalId,
    payload
  });
}
function ResetTelemetry() {
  sendSignal(UnrealInternalSignalEvents.TelemetryReset);
}
function StreamerListHandler(msg) {
  this.send(JSON.stringify({
    type: 'subscribe',
    streamerId: msg.ids[0]
  }));
}
function OfferHandler(msg) {
  this.onOffer$.next(msg);
}
let SignallingService = /*#__PURE__*/(() => {
  class SignallingService extends SubService {
    constructor() {
      super();
      this.httpClient = inject(HttpClient);
      this.regionsPingService = inject(RegionsPingService);
      this.onOffer$ = new Subject();
      this.onConfig$ = new Subject();
      this.onWebRtcIce$ = new Subject();
      this.onWebRtcAnswer$ = new Subject();
      this.wsMsgHandlers = {};
      this.establishingConnection = toSignal(this.store.select(unrealFeature.selectEstablishingConnection));
      this.isCirrusConnected = toSignal(this.store.select(unrealFeature.selectCirrusConnected));
      this.establishingConnectionDrop$ = this.store.select(unrealFeature.selectEstablishingConnection).pipe(skip(1), filter(Falsy), tapLog('selectEstablishingConnection'), share());
      this.setHandlersFromStream();
      this.store.select(unrealFeature.selectDataChannelConnected).pipe(filter(Truthy)).subscribe(() => {
        this.send(JSON.stringify({
          type: 'p2pEstablished',
          source: 'front',
          sessionId: generateUuid()
        }));
      });
      combineLatest([this.store.select(selectMatchUrls).pipe(tapLog('MatchMakerUrls changed:')), this.store.select(selectIsAutostart).pipe(tapLog('Autostart is:'))]).pipe(filter(([, autoStart]) => autoStart), map$1(([matchMakerUrls]) => [...matchMakerUrls].filter(Truthy)), filter(urls => urls.length > 0)).subscribe(urls => this.connectToSignaling(urls));
      this.store.select(selectWsUrl).pipe(filter(Truthy)).subscribe(url => {
        this.initWebSocket(url);
      });
    }
    initEstablishingConnection() {
      this.showStatusMessage(UnrealStatusMessage.STARTING_YOUR_SESSION);
      this.store.dispatch(setEstablishingConnection({
        value: true
      }));
    }
    stopEstablishingConnection() {
      this.store.dispatch(setEstablishingConnection({
        value: false
      }));
    }
    connectToSignaling(urlList) {
      // Preparation for WebSocket Orchestration
      this.correlationId = generateUuid();
      this.environmentId = '7e356e8d-8fa5-4cf7-83d0-394903e7b0d6';
      ResetTelemetry();
      if (this.establishingConnection() || this.isCirrusConnected()) {
        Logger.warn(`SIGNALING REQUEST can't be called again!. Waiting for connection or error.`);
        return;
      }
      this.initEstablishingConnection();
      this.regionsPingService.getFastest().pipe(first()).subscribe(region => {
        const out = urlList.map(url => {
          if (region && !url.includes(':region')) {
            return url.replace(/signallingserver/gi, `signallingserver/region:${region}`);
          }
          return url;
        });
        this.connectToSignalingAfterPing(out);
      });
    }
    connectToSignalingAfterPing(urls) {
      const urlGen = getActiveUrl(urls);
      TelemetryStart('getSignaling');
      const createSubscription = () => {
        const signalingUrl = `${urlGen.next().value}`;
        if (signalingUrl.match(/^ws(s?):\/\//i)) {
          this.store.dispatch(setAwsInstance({
            wsUrl: signalingUrl,
            pollingUrl: null,
            instanceName: null
          }));
          return;
        }
        const subscription = combineLatest([this.store.select(unrealFeature.selectStreamClientCompanyId), this.store.select(unrealFeature.selectStreamViewId)]).pipe(tap(([clientId, viewId]) => {
          if (!clientId || !viewId) {
            console.error('Client ID or View ID is not set');
          }
        }), filter(([clientId, viewId]) => !!clientId && !!viewId), tapLog('Stream Id =>'), switchMap$1(([clientId, viewId]) => this.httpClient.get(`${signalingUrl}${clientId}/${viewId}`)), timeout(4000), filter(data => {
          TelemetryStop('getSignaling', {
            ...data,
            multi: true
          });
          if (data.signallingServer === '' || data.error) {
            this.showStatusMessage(data?.mm_message || 'Server not found');
            if (data?.info) {
              this.store.dispatch(setStatusPercentSignallingServer({
                percent: data.info.percent
              }));
            }
            throw new Error('Invalid Value');
          }
          this.store.dispatch(setStatusPercentSignallingServer({
            percent: 100
          }));
          return true;
        }), retryWhen(error => error.pipe(tap(() => this.showStatusMessage(UnrealStatusMessage.CONNECTING_TO_SESSION)), tap(() => Logger.log('Retrying with new URL')), delay(4000), tap(() => {
          // Unsubscribe the previous subscription and create a new one
          subscription.unsubscribe();
          createSubscription();
        }))), takeUntil(merge(this.disconnect$, this.establishingConnectionDrop$))).subscribe(data => {
          subscription.unsubscribe();
          const wsProtocol = location.protocol.match(/https/i) ? 'wss' : 'ws';
          const wsUrl = `${wsProtocol}://${data.signallingServer}`;
          this.store.dispatch(setAwsInstance({
            wsUrl,
            pollingUrl: signalingUrl,
            instanceName: data.signallingServer
          }));
        });
      };
      createSubscription();
    }
    showStatusMessage(message) {
      this.store.dispatch(setStatusMessage({
        message
      }));
    }
    /**
     * Close the connection with the signaling server
     * @param data
     */
    close(data) {
      const {
        code,
        reason
      } = data || {
        code: WSCloseCode_NORMAL_CLOSURE,
        reason: 'NoReason'
      };
      if (this.ws) Logger.warn('Closing existing WebSocket connection');
      this.ws?.close(code, reason);
      this.ws = null;
    }
    send(data) {
      let dataString = data;
      if (typeof dataString !== 'string') {
        dataString = JSON.stringify(data);
      }
      if (this.ws && this.ws.readyState === WS_OPEN_STATE) {
        try {
          Logger.colored(...COLOR_CODES.TO_CIRRUS, JSON.parse(data));
        } catch {
          Logger.colored(...COLOR_CODES.TO_CIRRUS, data);
        }
        try {
          this.ws.send(dataString);
        } catch {
          Logger.error('No Websocket');
        }
      }
    }
    watchTimeoutOrErrorAndReconnectLater() {
      this.stopRetryTimer();
      this.wsTimeoutHandler = setTimeout(() => {
        Logger.warn('No WS Response, retrying new signaling');
        this.showStatusMessage(UnrealStatusMessage.CONNECTING_TO_SESSION);
        this.stopEstablishingConnection();
        this.store.dispatch(initSignalling());
      }, WS_TIMEOUT);
    }
    stopRetryTimer() {
      clearTimeout(this.wsTimeoutHandler);
    }
    initWebSocket(url) {
      if (!window?.['WebSocket']) {
        alert("Your browser doesn't support WebSocket");
        return;
      }
      this.clearWs();
      const wsUrl = this.httpUrlToWs(url);
      Logger.info('Creating socket', wsUrl);
      try {
        this.ws = new WebSocket(wsUrl);
      } catch (error) {
        this.ws = {};
        this.store.dispatch(setErrorMessage({
          errorType: 'WebSocketError',
          message: 'WebSocket Error'
        }));
        Logger.error('Error creating WebSocket', error);
      }
      this.ws.onmessage = OnMessageHandler.bind(this);
      this.ws.onerror = OnErrorHandler.bind(this);
      this.ws.onclose = OnCloseHandler.bind(this);
      this.ws.onopen = OnOpenHandler.bind(this);
      this.watchTimeoutOrErrorAndReconnectLater();
      TelemetryStart('iceCandidate');
    }
    httpUrlToWs(url) {
      return url.replace('http://', 'ws://').replace('https://', 'wss://');
    }
    clearWs() {
      this.onWebRtcAnswer$.next(null);
      if (this.ws) {
        this.ws.onmessage = () => null;
        this.ws.onerror = () => null;
        this.ws.onclose = () => null;
        this.ws.onopen = () => null;
        this.ws = null;
      }
    }
    handleMessage(msg) {
      try {
        Logger.colored(...COLOR_CODES.FROM_CIRRUS, msg);
        this.wsMsgHandlers[msg.type](msg);
      } catch {
        Logger.colored(...COLOR_CODES.FROM_CIRRUS_ERROR, `Invalid CIRRUS message type: ${msg.type}`);
      }
    }
    setHandlersFromStream() {
      this.wsMsgHandlers.ping = PingHandler.bind(this);
      this.wsMsgHandlers.config = ConfigHandler.bind(this);
      this.wsMsgHandlers.answer = AnswerHandler.bind(this);
      this.wsMsgHandlers.ssInfo = SSInfoHandler.bind(this);
      this.wsMsgHandlers.streamerList = StreamerListHandler.bind(this);
      this.wsMsgHandlers.playerCount = PlayerCountHandler.bind(this);
      this.wsMsgHandlers.iceCandidate = IceCandidateHandler.bind(this);
      this.wsMsgHandlers.instanceReady = InstanceReadyHandler.bind(this);
      this.wsMsgHandlers.instanceReserved = InstanceReservedHandler.bind(this);
      this.wsMsgHandlers.offer = OfferHandler.bind(this);
    }
    static {
      this.ɵfac = function SignallingService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SignallingService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SignallingService,
        factory: SignallingService.ɵfac
      });
    }
  }
  return SignallingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WebRtcPlayerService = /*#__PURE__*/(() => {
  class WebRtcPlayerService extends SubService {
    constructor() {
      super();
      this.onDataChannelMessage$ = new Subject();
      this.signallingSrv = inject(SignallingService);
      this.videoService = inject(VideoService);
      this.cfg = {};
      this.useMic = false;
      this.forceTURN = false;
      this.forceMonoAudio = false;
      /**
       * Never called for now
       */
      this.destroy$ = new Subject();
      this.listenSignaling();
    }
    listenSignaling() {
      const iceCandidateBuffer = [];
      const processBuffer = () => {
        iceCandidateBuffer.forEach(cnd => {
          this.handleCandidateFromServer(cnd);
        });
        iceCandidateBuffer.length = 0;
      };
      this.signallingSrv.onConfig$.pipe(takeUntil(this.destroy$)).subscribe(config => {
        this.videoService.create();
        this.setConfig(config);
      });
      this.signallingSrv.onWebRtcAnswer$.pipe(filter(Truthy), takeUntil(this.destroy$)).subscribe(answer => {
        this.receiveAnswer(answer);
        processBuffer();
      });
      this.signallingSrv.onOffer$.pipe(filter(Truthy), takeUntil(this.destroy$)).subscribe(() => {
        void this.createWebRtcOffer();
      });
      this.signallingSrv.onWebRtcIce$.pipe(withLatestFrom(this.signallingSrv.onWebRtcAnswer$), takeUntil(this.destroy$)).subscribe(([candidate, answerEstablished]) => {
        TelemetryStop('iceCandidate', {
          multi: true
        });
        iceCandidateBuffer.push(candidate);
        if (answerEstablished) {
          processBuffer();
        }
      });
    }
    async createWebRtcOffer() {
      Logger.info('Creating offer');
      let offer;
      try {
        clearTimeout(this.webRtcErrorTimeout);
        offer = await this.createPeerConnection(this.cfg);
        this.webRtcErrorTimeout = setTimeout(() => {
          if (this.pcClient?.connectionState?.match(/connecting|failed/gi)) {
            this.dispatchWebRtcError('WebRTCError: Timeout');
          }
        }, 10000);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (error) {
        this.dispatchWebRtcError('WebRTCError: Offer Error');
      }
      return offer;
    }
    createDataChannel(pc, label, options) {
      // This is the primary data channel code path when we are "offering"
      Logger.info(`[DATACHANNEL] Creating datachannel primary (${label})...`);
      const datachannel = pc.createDataChannel(label, options);
      return this.setupDataChannelCallbacks(datachannel);
    }
    receiveAnswer(answer) {
      this.pcClient?.setRemoteDescription(answer);
    }
    handleCandidateFromServer(iceCandidate) {
      try {
        const candidate = new RTCIceCandidate(iceCandidate);
        Logger.info('[Unreal ICE candidate]', '| Type=', candidate.type, '| Protocol=', candidate.protocol, '| Address=', candidate.address, '| Port=', candidate.port, '|');
        // if forcing TURN, reject any candidates not relay
        if (this.forceTURN) {
          // check if no relay address is found, if so, we are assuming it means no TURN server
          if (candidate.candidate.indexOf('relay') < 0) {
            Logger.warn('Dropping candidate because it was not TURN relay.', '| Type=', candidate.type, '| Protocol=', candidate.protocol, '| Address=', candidate.address, '| Port=', candidate.port, '|');
            return;
          }
        }
        this.pcClient?.addIceCandidate(candidate).catch(function () {
          //  Logger.error('Failed to add ICE candidate', e);
        });
      } catch (e) {
        Logger.error('Error handleCandidateFromServer', e);
      }
    }
    mungeSDP(offer) {
      let audioSDP = '';
      // set max bitrate to highest bitrate Opus supports
      audioSDP += 'maxaveragebitrate=510000;';
      if (this.useMic) {
        // set the max capture rate to 48khz (so we can send high quality audio from mic)
        audioSDP += 'sprop-maxcapturerate=48000;';
      }
      // Force mono or stereo based on whether ?forceMono was passed or not
      audioSDP += this.forceMonoAudio ? 'sprop-stereo=0;stereo=0;' : 'sprop-stereo=1;stereo=1;';
      // enable in-band forward error correction for opus audio
      audioSDP += 'useinbandfec=1';
      // We use the line 'useinbandfec=1' (which Opus uses) to set our Opus specific audio parameters.
      offer.sdp = offer.sdp?.replace('useinbandfec=1', audioSDP);
    }
    /**
     * Closes existing PeerConnection
     */
    closePC() {
      if (this.pcClient) Logger.warn('Closing existing PeerConnection');
      this.pcClient?.close();
      this.pcClient = null;
    }
    canSend() {
      return this.dcClient && this.dcClient.readyState === 'open';
    }
    send(data) {
      if (this.canSend()) {
        this.dcClient.send(data);
      } else {
        throw new Error('data channel is not prepared!');
      }
    }
    setConfig(parOptions = {}) {
      const urlParams = new URLSearchParams(window.location.search);
      //**********************
      //Config setup
      //**********************
      this.cfg = {
        ...parOptions.peerConnectionOptions
      };
      this.forceTURN = urlParams.has('ForceTURN');
      if (this.forceTURN) {
        Logger.info('Forcing TURN usage by setting ICE Transport Policy in peer connection config.');
        this.cfg.iceTransportPolicy = 'relay';
      }
      this.cfg.bundlePolicy = urlParams.has('ForceMaxBundle') ? 'max-bundle' : 'balanced';
      //**********************
      //Variables
      //**********************
      this.pcClient = null;
      this.dcClient = null;
      // When ?useMic check for SSL or localhost
      const isLocalhostConnection = location.hostname === 'localhost' || location.hostname === '127.0.0.1';
      const isHttpsConnection = location.protocol === 'https:';
      if (this.useMic && !isLocalhostConnection && !isHttpsConnection) {
        this.useMic = false;
        Logger.error('Microphone access in the browser will not work if you are not on HTTPS or localhost. Disabling mic access.');
        Logger.error("For testing you can enable HTTP microphone access Chrome by visiting chrome://flags/ and enabling 'unsafely-treat-insecure-origin-as-secure'");
      }
    }
    dispatchWebRtcError(message) {
      Logger.error(message);
      this.store.dispatch(setErrorMessage({
        errorType: 'WebRTCError',
        message
      }));
    }
    async createPeerConnection(config) {
      this.closePC();
      this.pcClient = new RTCPeerConnection(config);
      TelemetryStart('Browser ICE gathering');
      TelemetryStart('Browser ICE connection');
      TelemetryStart('Signaling state change');
      this.handlePeerConnectionEvents(this.pcClient);
      await this.setupTransceiversAsync(this.pcClient);
      this.dcClient = this.createDataChannel(this.pcClient, 'cirrus', {
        // See https://www.w3.org/TR/webrtc/#dom-rtcdatachannelinit for values (this is needed for Firefox to be consistent with Chrome.)
        ordered: true
      });
      this.disconnect$.pipe(first()).subscribe(() => {
        this.closePC();
      });
      await this.createOffer(this.pcClient);
    }
    handlePeerConnectionEvents(pcClient) {
      fromEvent(pcClient, 'signalingstatechange').pipe(map$1(() => this.pcClient?.signalingState), takeUntil(this.disconnect$)).subscribe(state => {
        Logger.info('[Signaling state change] |', state, '|');
        TelemetryStop('Signaling state change', {
          state,
          multi: true
        });
      });
      fromEvent(pcClient, 'iceconnectionstatechange').pipe(map$1(() => this.pcClient?.iceConnectionState), takeUntil(this.disconnect$)).subscribe(state => {
        Logger.info('[Browser ICE connection] |', state, '|');
        TelemetryStop('Browser ICE connection', {
          state,
          multi: true
        });
      });
      fromEvent(pcClient, 'icegatheringstatechange').pipe(map$1(() => this.pcClient?.iceGatheringState), takeUntil(this.disconnect$)).subscribe(state => {
        Logger.info('[Browser ICE gathering] |', state, '|');
        TelemetryStop('Browser ICE gathering', {
          state,
          multi: true
        });
      });
      fromEvent(pcClient, 'connectionstatechange').pipe(map$1(() => this.pcClient?.connectionState), takeUntil(this.disconnect$)).subscribe(state => {
        Logger.info('[RTCPeerConnection state] |', state, '|');
      });
      fromEvent(pcClient, 'icecandidate').pipe(map$1(e => e.candidate), filter(Truthy), tap$1(candidate => Logger.info('[Browser ICE candidate]', '| Type=', candidate.type, '| Protocol=', candidate.protocol, '| Address=', candidate.address, '| Port=', candidate.port, '|')), takeUntil(this.disconnect$)).subscribe(candidate => this.signallingSrv.send({
        type: 'iceCandidate',
        candidate
      }));
      fromEvent(pcClient, 'datachannel').pipe(tap$1(() => Logger.info('Data channel created for us by browser as we are a receiving peer.')), map$1(e => e.channel), takeUntil(this.disconnect$)).subscribe(datachannel => {
        this.dcClient = this.setupDataChannelCallbacks(datachannel);
      });
      const onTrack$ = fromEvent(pcClient, 'track').pipe(filter(e => !!e.track), tap$1(e => Logger.info('Got track - ' + e.track.kind + ' id=' + e.track.id + ' readyState=' + e.track.readyState)), share());
      onTrack$.pipe(filter(e => e.track.kind === 'audio'), map$1(e => e.streams[0]), takeUntil(this.disconnect$)).subscribe(stream => this.videoService.attachAudioStream(stream));
      const videoTrack$ = onTrack$.pipe(filter(e => e.track.kind === 'video'), map$1(e => e.streams[0]), tap$1(() => Logger.info('Set video source from video track ontrack.')), takeUntil(this.disconnect$), share());
      videoTrack$.subscribe(stream => {
        this.videoService.attachVideoStream(stream, this.pcClient);
      });
    }
    async setupTransceiversAsync(pc) {
      const hasTransceivers = pc.getTransceivers().length > 0;
      // Setup a transceiver for getting UE video
      pc.addTransceiver('video', {
        direction: 'recvonly'
      });
      // Setup a transceiver for sending mic audio to UE and receiving audio from UE
      if (!this.useMic) {
        pc.addTransceiver('audio', {
          direction: 'recvonly'
        });
      } else {
        const audioSendOptions = this.useMic ? {
          autoGainControl: false,
          channelCount: 1,
          echoCancellation: false,
          latency: 0,
          noiseSuppression: false,
          sampleRate: 48000,
          sampleSize: 16,
          volume: 1.0
        } : false;
        // Note using mic on android chrome requires SSL or chrome://flags/ "unsafely-treat-insecure-origin-as-secure"
        const stream = await navigator.mediaDevices.getUserMedia({
          video: false,
          audio: audioSendOptions
        });
        if (stream) {
          if (hasTransceivers) {
            for (const transceiver of pc.getTransceivers()) {
              if (transceiver && transceiver.receiver && transceiver.receiver.track && transceiver.receiver.track.kind === 'audio') {
                for (const track of stream.getTracks()) {
                  if (track.kind && track.kind == 'audio') {
                    transceiver.sender.replaceTrack(track);
                    transceiver.direction = 'sendrecv';
                  }
                }
              }
            }
          } else {
            for (const track of stream.getTracks()) {
              if (track.kind && track.kind == 'audio') {
                pc.addTransceiver(track, {
                  direction: 'sendrecv'
                });
              }
            }
          }
        } else {
          pc.addTransceiver('audio', {
            direction: 'recvonly'
          });
        }
      }
    }
    setupDataChannelCallbacks(datachannel) {
      try {
        TelemetryStart('DataChannel Connection');
        // Inform browser we would like binary data as an ArrayBuffer (FF chooses Blob by default!)
        datachannel.binaryType = 'arraybuffer';
        fromEvent(datachannel, 'close').pipe(first()).subscribe(e => {
          Logger.warn(`[DATACHANNEL] Data channel disconnected: ${datachannel.label}(${datachannel.id})`, e);
          this.store.dispatch(destroyRemoteConnections({
            disconnectReason: DisconnectReason.dataChannelClosed
          }));
        });
        fromEvent(datachannel, 'error').pipe(takeUntil(this.disconnect$)).subscribe(e => {
          const message = `[DATACHANNEL] Data channel error: ${datachannel.label}(${datachannel.id})`;
          Logger.error(message, e);
        });
        fromEvent(datachannel, 'open').pipe(tap$1(() => {
          Logger.info(`[DATACHANNEL] Data channel connected: ${datachannel.label}(${datachannel.id})`);
        }), takeUntil(this.disconnect$)).subscribe(() => {
          TelemetryStop('DataChannel Connection');
          this.onDataChannelConnected();
        });
        fromEvent(datachannel, 'message').pipe(map$1(e => e.data), takeUntil(this.disconnect$)).subscribe(data => this.onDataChannelMessage$.next(data));
        return datachannel;
      } catch (e) {
        Logger.warn('[DATACHANNEL] Datachannel setup caused an exception: ', e);
        return null;
      }
    }
    onDataChannelConnected() {
      let text = 'Session connected, video stream starting.';
      if (navigator.userAgent.includes('Firefox')) {
        text += '\n If you are experiencing connection problems please try Google Chrome';
      }
      this.store.dispatch(setStatusMessage({
        message: text
      }));
      this.store.dispatch(setDataChannelConnected({
        value: true
      }));
    }
    async createOffer(pcClient) {
      try {
        const offer = await pcClient.createOffer({
          offerToReceiveAudio: false,
          //Note: if you don't need audio you can get improved latency by turning this off.
          offerToReceiveVideo: true
        });
        this.mungeSDP(offer);
        pcClient?.setLocalDescription(offer);
        this.signallingSrv.send(offer);
      } catch {
        Logger.error("Couldn't create offer");
      }
    }
    static {
      this.ɵfac = function WebRtcPlayerService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WebRtcPlayerService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: WebRtcPlayerService,
        factory: WebRtcPlayerService.ɵfac
      });
    }
  }
  return WebRtcPlayerService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const deepEqual = (a, b) => {
  if (a === b) return true;
  // must both be objects (and not null)?
  if (typeof a === 'object' && a !== null && typeof b === 'object' && b !== null) {
    // arrays?
    if (Array.isArray(a) || Array.isArray(b)) {
      if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) {
        return false;
      }
      for (let i = 0; i < a.length; i++) {
        if (!deepEqual(a[i], b[i])) return false;
      }
      return true;
    }
    // plain objects
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA) {
      // `b` must have key, and values must match
      if (!Object.prototype.hasOwnProperty.call(b, key)) {
        return false;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  // everything else (including mismatched types)
  return false;
};
const filteredLogs = [{
  command: 'onChangeSequence'
}];
let AggregatorService = /*#__PURE__*/(() => {
  class AggregatorService extends SubService {
    constructor() {
      super();
      this.selectStreamConfig = toSignal(this.store.select(selectStreamConfig));
      this.videoService = inject(VideoService);
      this.webrtcPlayer = inject(WebRtcPlayerService);
      this.freezeFrame = inject(FreezeFrameService);
      this.unrealInitialConfig = inject(UNREAL_CONFIG);
      this.responseEventListeners = new Map();
      /**
       * Never called for now
       */
      this.destroy$ = new Subject();
      this.listenWebRTC();
      this.initialize();
    }
    init() {
      // do nothing, just to not forget to initialize Service
    }
    initialize() {
      this.store.select(unrealFeature.selectCirrusConnected).pipe(distinctUntilChanged()).subscribe(connected => {
        this.resetResponseList();
        if (connected) {
          this.startListenCallbacks();
        }
      });
      const unlockViewport$ = this.store.select(unrealFeature.selectViewportReady).pipe(filter(Truthy));
      merge(unlockViewport$, this.disconnect$).subscribe(() => {
        this.removeLoadScreen();
      });
      if (!this.selectStreamConfig()?.autoStart || location.href.match(/^http:/gi)) {
        this.removeLoadScreen();
      }
      InputOptions.controlScheme = EControlSchemeType.HoveringMouse;
    }
    addResponseEventListener(name, listener) {
      this.responseEventListeners.set(name, listener);
    }
    showOnScreenKeyboard(command) {
      if (command.showOnScreenKeyboard) {
        // Show the 'edit text' button.
        //editTextButton.classList.remove('hiddenState');
        // Place the 'edit text' button near the UE4 input widget.
        //let pos = unquantizeAndDenormalizeUnsigned(command.x, command.y);
        //editTextButton.style.top = pos.y.toString() + 'px';
        //editTextButton.style.left = (pos.x - 40).toString() + 'px';
      } else {
        // Hide the 'edit text' button.
        //editTextButton.classList.add('hiddenState');
        // Hide the on-screen keyboard.
        // hiddenInput.blur();
      }
    }
    removeLoadScreen() {
      document.getElementById(this.unrealInitialConfig?.screenLockerContainerId || SCREEN_LOCKER_CONTAINER_ID)?.remove();
    }
    startListenCallbacks() {
      Logger.info('Start Listen Callbacks');
      let previousJson = null;
      this.addResponseEventListener('unrealEvents', data => {
        try {
          if (typeof data !== 'string') {
            return;
          }
          const json = JSON.parse(data);
          if (!deepEqual(json, previousJson)) {
            if (json?.error) {
              Logger.colored(...COLOR_CODES.FROM_UNREAL_ERROR, `${json.error}`, data);
              this.store.dispatch(showUnrealErrorMessage({
                code: json.code,
                error: json?.error
              }));
            } else {
              this.showMessageFromUnreal(json);
              previousJson = json;
              sendSignal(UnrealInternalSignalEvents.UnrealCallback, {
                json
              });
            }
          } else {
            // Logger.warn('Duplicate message received');
          }
        } catch (e) {
          Logger.error(e);
          Logger.error('ERROR=>', data);
        }
      });
    }
    showMessageFromUnreal(json) {
      if (filteredLogs.some(where({
        command: json?.command
      }))) {
        return;
      }
      Logger.colored(...COLOR_CODES.FROM_UNREAL, json);
    }
    resetResponseList() {
      this.responseEventListeners.clear();
    }
    listenWebRTC() {
      this.webrtcPlayer.onDataChannelMessage$.pipe(takeUntil(this.destroy$)).subscribe(data => this.dataChannelMessageHandler(data));
    }
    dataChannelMessageHandler(data) {
      const view = new Uint8Array(data);
      const anyData = data.slice(1);
      if (this.freezeFrame.receiving) {
        this.freezeFrame.setData(view);
        return;
      }
      switch (view[0]) {
        case EToClientMessageType.QualityControlOwnership:
          {
            const ownership = view[1] !== 0;
            Logger.colored(...COLOR_CODES.FROM_UNREAL, 'Received quality controller message, will control quality: ' + ownership);
            break;
          }
        case EToClientMessageType.Response:
          {
            const response = decodeData(anyData);
            for (const listener of this.responseEventListeners.values()) {
              listener(response);
            }
            break;
          }
        case EToClientMessageType.Command:
          {
            const commandAsString = decodeData(anyData);
            Logger.colored(...COLOR_CODES.FROM_UNREAL, commandAsString);
            const command = JSON.parse(commandAsString);
            if (command.command === 'onScreenKeyboard') {
              this.showOnScreenKeyboard(command);
            }
            break;
          }
        case EToClientMessageType.FreezeFrame:
          Logger.colored(...COLOR_CODES.FROM_UNREAL, 'Freeze frame');
          this.freezeFrame.start(view);
          break;
        case EToClientMessageType.UnfreezeFrame:
          Logger.colored(...COLOR_CODES.FROM_UNREAL, 'Un-Freeze frame');
          this.freezeFrame.invalidate();
          break;
        case EToClientMessageType.VideoEncoderAvgQP:
          this.videoService.setEncoder(anyData);
          break;
        case EToClientMessageType.LatencyTest:
          {
            const latencyTimings = decodeData(anyData);
            Logger.colored(...COLOR_CODES.FROM_UNREAL, 'Got latency timings :', latencyTimings);
            Logger.colored(...COLOR_CODES.FROM_UNREAL, latencyTimings);
            this.videoService.setLatencyTimings(latencyTimings);
            break;
          }
        case EToClientMessageType.InitialSettings:
          Logger.colored(...COLOR_CODES.FROM_UNREAL, 'InitialSettings message :', JSON.parse(decodeData(anyData)));
          break;
        case EToClientMessageType.Protocol:
          Logger.colored(...COLOR_CODES.FROM_UNREAL, 'Protocol message :', JSON.parse(decodeData(anyData)));
          break;
        case EToClientMessageType.InputControlOwnership:
          Logger.colored(...COLOR_CODES.FROM_UNREAL, 'InputControlOwnership message :', anyData);
          break;
        default:
          Logger.warn(`unrecognized data received, packet ID ${view[0]}`);
      }
    }
    static {
      this.ɵfac = function AggregatorService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AggregatorService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AggregatorService,
        factory: AggregatorService.ɵfac
      });
    }
  }
  return AggregatorService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ConsoleExtensionsService = /*#__PURE__*/(() => {
  class ConsoleExtensionsService extends SubService {
    constructor() {
      super(...arguments);
      this.httpClient = inject(HttpClient);
      this.isDevMode = inject(DevModeService).isDevMode;
    }
    init() {
      if (!this.isDevMode) {
        return;
      }
      window.dropConnection = () => {
        this.store.dispatch(destroyConnectionsAndResetState());
        return true;
      };
      window.toggleBandwidth = () => {
        this.store.select(unrealFeature.selectLowBandwidth).pipe(first()).subscribe(isLow => {
          this.store.dispatch(changeLowBandwidth({
            lowBandwidth: !isLow
          }));
        });
        return 'LowBandwidth => toggled';
      };
      window.setMaxFps = maxFps => {
        this.store.dispatch(setMaxFps({
          maxFps
        }));
        return `Max Fps Set to ${maxFps}`;
      };
      window.restartApp = () => {
        this.store.select(unrealFeature.selectAwsInstance).pipe(first(), filter(data => !!data.instanceName), tapLog('Instance', `Restart initiated`), switchMap$1(data => this.httpClient.get(`//${data.instanceName}/restartapp`)), catchError(() => of(null))).subscribe();
      };
      window.unrealHelp = () => {
        this.unrealHelp();
      };
      window.setWarnTime = time => {
        this.store.dispatch(setConfig({
          config: {
            warnTimeout: time
          }
        }));
      };
    }
    unrealHelp() {
      Logger.info('dropConnection() => Closes Web Socket and abort communication.');
      Logger.info('toggleBandwidth() => toggles speed.');
      Logger.info('restartApp() => force restart Unreal app.');
      Logger.info('rebootInstance() => force reboot instance.');
      Logger.info('startShowcase(time) => start Showcase.');
      Logger.info('setWarnTime() => set time to appear the AFK window.');
      Logger.info('emitCommand(command) => send command to Unreal Engine.');
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵConsoleExtensionsService_BaseFactory;
        return function ConsoleExtensionsService_Factory(__ngFactoryType__) {
          return (ɵConsoleExtensionsService_BaseFactory || (ɵConsoleExtensionsService_BaseFactory = i0.ɵɵgetInheritedFactory(ConsoleExtensionsService)))(__ngFactoryType__ || ConsoleExtensionsService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ConsoleExtensionsService,
        factory: ConsoleExtensionsService.ɵfac
      });
    }
  }
  return ConsoleExtensionsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DevModeService = /*#__PURE__*/(() => {
  class DevModeService {
    get isDevMode() {
      return Truthy(localStorage.getItem('devMode'));
    }
    setDevMode(value) {
      return localStorage.setItem('devMode', value.toString());
    }
    static {
      this.ɵfac = function DevModeService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DevModeService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DevModeService,
        factory: DevModeService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DevModeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class TouchEmulator {
  constructor(host) {
    this.host = host;
    this.lastDistance = 0;
    this.prevDistance = 0;
    this.touchReset = true;
    this.delta = 0;
    this.moveSensitivityScale = 3;
    this.prevX = 0;
    this.prevY = 0;
    this.registerTouchEvents(host.video);
  }
  getPosition({
    clientX,
    clientY
  }) {
    return {
      x: clientX - this.host.videoBoundingRect.left,
      y: clientY - this.host.videoBoundingRect.top
    };
  }
  getCenter(v1, v2) {
    return {
      x: (v2.x - v1.x) / 2 + v1.x,
      y: (v2.y - v1.y) / 2 + v1.y
    };
  }
  getDistance(v1, v2) {
    const quad = {
      x: Math.abs(v2.x - v1.x) ^ 2,
      y: Math.abs(v2.y - v1.y) ^ 2
    };
    return Math.sqrt(quad.x + quad.y);
  }
  updateDistance(touches) {
    const center = this.getCenter(this.getPosition(touches[0]), this.getPosition(touches[1]));
    this.lastDistance = this.getDistance(this.getPosition(touches[0]), this.getPosition(touches[1]));
    if (this.touchReset) {
      this.prevDistance = this.lastDistance;
      this.touchReset = false;
    }
    return center;
  }
  touchToVector2({
    clientX,
    clientY
  }) {
    return {
      x: clientX,
      y: clientY
    };
  }
  twoFingersAction(touches) {
    const center = this.getCenter(this.touchToVector2(touches[0]), this.touchToVector2(touches[1]));
    this.lastDistance = 0;
    this.prevDistance = 0;
    this.prevX = center.x;
    this.prevY = center.y;
    this.host.emitMouseUp(MouseButton.MainButton, center.x, center.y);
    this.host.emitMouseDown(MouseButton.SecondaryButton, center.x, center.y);
  }
  threeFingersActionMove(touches) {
    const center = this.getCenter(this.touchToVector2(touches[0]), this.touchToVector2(touches[1]));
    this.delta = this.lastDistance - this.prevDistance;
    const xx = center.x - this.prevX;
    const yy = center.y - this.prevY;
    this.host.emitMouseMove(center.x, center.y, this.moveSensitivityScale * xx, this.moveSensitivityScale * yy);
    this.prevX = center.x;
    this.prevY = center.y;
  }
  twoFingersActionZoom(touches) {
    const center = this.updateDistance(touches);
    this.delta = this.lastDistance - this.prevDistance;
    if (Math.abs(this.delta) < 0.3) {
      return;
    }
    this.delta = this.delta / Math.abs(this.delta) * 2000;
    if (isNaN(this.delta)) {
      return;
    }
    this.prevDistance = this.lastDistance;
    this.host.emitMouseWheel(this.delta, center.x, center.y);
  }
  registerTouchEvents(playerElement) {
    let finger;
    fromEvent(playerElement, 'touchstart', {
      passive: false
    }).subscribe(e => {
      e.preventDefault();
      e.stopPropagation();
      const touches = e.touches || e.changedTouches;
      if (touches.length === 3) {
        return;
      }
      if (touches.length === 2) {
        this.twoFingersAction(touches);
        return;
      }
      /**
       * One finger actions below
       */
      this.prevDistance = 0;
      this.touchReset = true;
      if (finger === undefined) {
        const firstTouch = e.changedTouches[0];
        const {
          x,
          y
        } = this.getPosition(firstTouch);
        finger = {
          id: firstTouch.identifier,
          x,
          y
        };
        // Hack: Mouse events require an enter and leave so we just
        // enter and leave manually with each touch as this event
        // is not fired with a touch device.
        playerElement.dispatchEvent(new MouseEvent('mouseenter', e));
        this.host.emitMouseDown(MouseButton.MainButton, finger.x, finger.y);
      }
    });
    fromEvent(playerElement, 'touchend', {
      passive: false
    }).subscribe(e => {
      e.preventDefault();
      e.stopPropagation();
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let t = 0; t < e.changedTouches.length; t++) {
        const touch = e.changedTouches[t];
        if (touch.identifier === finger?.id) {
          const {
            x,
            y
          } = this.getPosition(touch);
          this.host.emitMouseUp(MouseButton.MainButton, x, y);
          this.host.emitMouseUp(MouseButton.SecondaryButton, x, y);
          // Hack: Manual mouse leave event.
          playerElement.dispatchEvent(new MouseEvent('mouseleave', e));
          finger = undefined;
          break;
        }
      }
    });
    fromEvent(playerElement, 'touchmove', {
      passive: false
    }).subscribe(e => {
      e.preventDefault();
      e.stopPropagation();
      const touches = e.touches || e.changedTouches;
      if (touches.length === 3) {
        this.threeFingersActionMove(touches);
        return;
      }
      if (touches.length === 2) {
        this.twoFingersActionZoom(touches);
        return;
      }
      for (let t = 0; t < touches.length; t++) {
        const touch = e.touches[t];
        if (touch.identifier === finger?.id) {
          const {
            x,
            y
          } = this.getPosition(touch);
          this.host.emitMouseMove(x, y, this.moveSensitivityScale * (x - finger.x), this.moveSensitivityScale * (y - finger.y));
          finger.x = x;
          finger.y = y;
          break;
        }
      }
    });
  }
}
let UnrealCommunicatorService = /*#__PURE__*/(() => {
  class UnrealCommunicatorService {
    constructor() {
      this.telemetry = inject(CommandTelemetryService);
      this.afkService = inject(AFKService);
      this.freezeFrame = inject(FreezeFrameService);
      this.webrtcPlayer = inject(WebRtcPlayerService);
      this.videoService = inject(VideoService);
      this.consoleExtensions = inject(ConsoleExtensionsService);
      this.store = inject(Store);
      this.destroy$ = new Subject();
      this.cirrusConnected = toSignal(this.store.select(unrealFeature.selectCirrusConnected));
      this.emitUIInteraction = this.telemetry.decorate(this.emitUIInteraction.bind(this));
      this.consoleExtensions.init();
      this.afkService.init();
      this.freezeFrame.init();
      this.listenVideo();
      this.store.select(unrealFeature.selectDataChannelConnected).pipe(filter(Truthy)).subscribe(() => {
        this.requestInitialSettings();
        this.requestQualityControl();
      });
    }
    destroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    sendCommandToUnreal(data) {
      if (this.webrtcPlayer.canSend()) {
        const uniqId = data?.correlationId ?? generateUuid();
        const sendData = {
          ...data,
          correlationId: uniqId
        };
        Logger.colored(...COLOR_CODES.TO_UNREAL, sendData);
        this.emitUIInteraction(sendData);
        this.store.dispatch(commandStarted({
          id: uniqId,
          command: data.command
        }));
      }
    }
    emitUIInteraction(descriptor) {
      this.emitDescriptor(EMessageType.UIInteraction, descriptor);
    }
    /**
     A build-in command can be sent to the UE4 client. The commands are defined by a
     JSON descriptor and will be executed automatically.
     The currently supported commands are:
        1. A command to run any console command:
     "{ ConsoleCommand: <string> }"
        2. A command to change the resolution to the given width and height.
     "{ Resolution.Width: <value>, Resolution.Height: <value> } }"
     */
    emitCommand(descriptor) {
      this.emitDescriptor(EMessageType.Command, descriptor);
    }
    sendInputData(data) {
      try {
        resetAfk();
        this.webrtcPlayer.send(data);
      } catch (error) {
        if (this.cirrusConnected()) {
          Logger.error(`DataChannel connection not established, can't send data=>${error}`);
        }
      }
    }
    emitDescriptor(messageType, descriptor) {
      // Convert the descriptor object into a JSON string.
      const descriptorAsString = JSON.stringify(descriptor);
      // Add the UTF-16 JSON string to the array byte buffer, going two bytes at
      // a time.
      const data = new DataView(new ArrayBuffer(1 + 2 + 2 * descriptorAsString.length));
      let byteIdx = 0;
      data.setUint8(byteIdx, messageType);
      byteIdx++;
      data.setUint16(byteIdx, descriptorAsString.length, true);
      byteIdx += 2;
      for (let i = 0; i < descriptorAsString.length; i++) {
        data.setUint16(byteIdx, descriptorAsString.charCodeAt(i), true);
        byteIdx += 2;
      }
      this.sendInputData(data.buffer);
    }
    requestInitialSettings() {
      this.sendInputData(new Uint8Array([EMessageType.RequestInitialSettings]).buffer);
    }
    requestQualityControl() {
      this.sendInputData(new Uint8Array([EMessageType.RequestQualityControl]).buffer);
    }
    listenVideo() {
      fromSignal(UnrealInternalSignalEvents.OnVideoInitialized).subscribe(() => this.prepareScreen());
    }
    prepareScreen() {
      this.showPlayOverlay();
      this.freezeFrame.invalidate();
    }
    showPlayOverlay() {
      const callback = () => {
        this.videoService.play();
        resetAfk();
        sendSignal(UnrealInternalSignalEvents.VideoPlayClick, {
          text: 'Play Clicked'
        });
        return true;
      };
      sendSignal(UnrealInternalSignalEvents.ShowPlayButton, {
        text: 'Play',
        callback
      });
    }
    static {
      this.ɵfac = function UnrealCommunicatorService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UnrealCommunicatorService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UnrealCommunicatorService,
        factory: UnrealCommunicatorService.ɵfac
      });
    }
  }
  return UnrealCommunicatorService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class InputService extends SubService {
  constructor() {
    super();
    this.commandsSender = inject(UnrealCommunicatorService);
    this.isDevMode = inject(DevModeService).isDevMode;
    this.defaultKeys = [KeyboardNumericCode.KeyW, KeyboardNumericCode.KeyS, KeyboardNumericCode.KeyA, KeyboardNumericCode.KeyD, KeyboardNumericCode.ArrowUp, KeyboardNumericCode.ArrowDown, KeyboardNumericCode.ArrowLeft, KeyboardNumericCode.ArrowRight, KeyboardNumericCode.NumpadAdd, KeyboardNumericCode.NumpadSubtract, KeyboardNumericCode.ControlRight, KeyboardNumericCode.Equal, KeyboardNumericCode.Minus, KeyboardNumericCode.NumpadDecimal];
    this.availableKeys = this.defaultKeys;
    this.reInit$ = new Subject();
    this.videoBoundingRect = new DOMRect(0, 0, 1, 1);
    this.fingerIds = new Map();
    this.maxByteValue = 255;
    this.fingers = [9, 8, 7, 6, 5, 4, 3, 2, 1, 0];
    this.offsetParams = {
      scaleX: 1,
      scaleY: 1,
      scaledHeight: 0,
      scaledWidth: 0,
      offsetByY: 0,
      offsetByX: 0
    };
    const visibilityHiddenTrigger$ = fromEvent(document, 'visibilitychange').pipe(map$1(() => document.visibilityState === 'hidden'), filter(Truthy));
    const visibilityVisibleTrigger$ = fromEvent(document, 'visibilitychange').pipe(map$1(() => document.visibilityState === 'visible'), filter(Truthy), startWith(true));
    this.deactivatedVideoTrigger$ = merge(this.disconnect$, this.reInit$, visibilityHiddenTrigger$);
    fromSignal(UnrealInternalSignalEvents.OnVideoInitialized).pipe(combineLatestWith(visibilityVisibleTrigger$, this.store.select(unrealFeature.selectViewportReady).pipe(filter(Truthy), startWith(true))), filter(([video]) => !!video)).subscribe(([video]) => this.setup(video));
  }
  useKeyboardKeys(keys) {
    this.availableKeys = keys || [];
  }
  setup(video) {
    this.options = InputOptions;
    this.video = video;
    this.reInit$.next();
    merge(fromResizeObserver(video), fromSignal(UnrealInternalSignalEvents.VideoAdaptedToContainer)).pipe(debounceTime(300), takeUntil$1(this.deactivatedVideoTrigger$)).subscribe(() => {
      this.setupNormalizeAndQuantize(video);
    });
    this.setupNormalizeAndQuantize(video);
    this.registerInputs();
  }
  /**
   * We use `object-fit: cover` on the video element. Since the video can have
   * a different aspect ratio from its container (and potentially be larger),
   * we need to calculate offsets and scale factors to map container (e.g., mouse)
   * coordinates back to the actual video coordinates.
   *
   * @param videoElement The video element whose scaling and positioning we need
   * @returns Object containing offset and scale info for coordinate normalization
   * @private
   */
  getObjectFitOffset(videoElement) {
    const {
      width,
      height
    } = this.videoBoundingRect;
    const {
      videoWidth,
      videoHeight
    } = videoElement;
    Logger.log('Video Quantizing with => ', this.videoBoundingRect, {
      videoWidth,
      videoHeight
    });
    // Compute aspect ratios
    const containerRatio = width / height;
    const videoRatio = videoWidth / videoHeight;
    // Determine how much to scale the video to fit the container (cover mode)
    const scale = videoRatio > containerRatio ? height / videoHeight : width / videoWidth;
    // Calculate the displayed (scaled) dimensions of the video
    const scaledWidth = videoWidth * scale;
    const scaledHeight = videoHeight * scale;
    // Offsets in x/y directions (like "padding") once the video is scaled
    const offsetByX = (width - scaledWidth) / 2;
    const offsetByY = (height - scaledHeight) / 2;
    // Scale factors for coordinate transformation from container space to video space
    const scaleX = width / scaledWidth;
    const scaleY = height / scaledHeight;
    return {
      offsetByX,
      offsetByY,
      scaleX,
      scaleY,
      scaledWidth,
      scaledHeight
    };
  }
  setupNormalizeAndQuantize(videoElement) {
    if (videoElement) {
      this.videoBoundingRect = videoElement.getBoundingClientRect();
      this.offsetParams = this.getObjectFitOffset(videoElement);
      // Unsigned XY positions are the ratio (0.0..1.0) along a viewport axis,
      // quantized into an uint16 (0..65536).
      // Signed XY deltas are the ratio (-1.0..1.0) along a viewport axis,
      // quantized into an int16 (-32767..32767).
      // This allows the browser viewport and client viewport to have a different
      // size.
      // Hack: Currently we set an out-of-range position to an extreme (65535)
      // as we can't yet accurately detect mouse enter and leave events
      // precisely inside a video with an aspect ratio which causes mattes.
      this.normalizeAndQuantizeUnsigned = (x, y) => {
        const normalizedX = x / videoElement.clientWidth;
        const normalizedY = y / videoElement.clientHeight;
        if (normalizedX < 0.0 || normalizedX > 1.0 || normalizedY < 0.0 || normalizedY > 1.0) {
          return {
            inRange: false,
            x: 65535,
            y: 65535
          };
        } else {
          return {
            inRange: true,
            x: normalizedX * 65536,
            y: normalizedY * 65536
          };
        }
      };
      this.unQuantizeAndDenormalizeUnsigned = (x, y) => {
        const normalizedX = x / 65536;
        const normalizedY = y / 65536;
        return {
          x: normalizedX * videoElement.clientWidth,
          y: normalizedY * videoElement.clientHeight
        };
      };
      // Signed.
      this.normalizeAndQuantizeSigned = (x, y) => {
        const normalizedX = x / (0.5 * videoElement.clientWidth);
        const normalizedY = y / (0.5 * videoElement.clientHeight);
        return {
          x: normalizedX * 32767,
          y: normalizedY * 32767
        };
      };
    }
  }
  sendInputData(data) {
    this.commandsSender.sendInputData(data);
  }
  registerInputs() {
    merge(this.store.select(unrealFeature.selectLowBandwidth).pipe(distinctUntilChanged(), filter(Truthy)), fromEvent(window, 'blur')).pipe(filter(() => !!this.video), takeUntil$1(this.deactivatedVideoTrigger$)).subscribe(() => this.releaseMouseButtons(255, 0, 0));
    this.registerMouseEnterAndLeaveEvents(this.video);
    this.registerHoveringMouseEvents(this.video);
    this.registerKeyboardEvents(this.availableKeys);
    if (InputOptions.fakeMouseWithTouches) {
      new TouchEmulator(this);
    } else {
      this.registerTouchEvents(this.video);
    }
  }
  getTouchPositionWithOffset({
    clientX,
    clientY
  }) {
    const {
      offsetByX,
      offsetByY,
      scaleX,
      scaleY
    } = this.offsetParams;
    return {
      x: (clientX - offsetByX - this.videoBoundingRect.left) * scaleX,
      y: (clientY - offsetByY - this.videoBoundingRect.top) * scaleY
    };
  }
  getMousePositionWithOffset({
    offsetX,
    offsetY
  }) {
    const {
      offsetByX,
      offsetByY,
      scaleX,
      scaleY
    } = this.offsetParams;
    return {
      x: (offsetX - offsetByX) * scaleX,
      y: (offsetY - offsetByY) * scaleY
    };
  }
  registerTouchEvents(htmlVideoElement) {
    // We need to assign a unique identifier to each finger.
    // We do this by mapping each Touch object to the identifier.
    const rememberTouch = touch => {
      const finger = this.fingers.pop();
      if (finger === undefined) {
        Logger.info('exhausted touch indentifiers');
        return;
      }
      this.fingerIds.set(touch.identifier, finger);
    };
    const forgetTouch = touch => {
      this.fingers.push(this.fingerIds.get(touch.identifier));
      // Sort array back into descending order. This means if finger '1' were to lift after finger '0', we would ensure that 0 will be the first index to pop
      this.fingers.sort(function (a, b) {
        return b - a;
      });
      this.fingerIds.delete(touch.identifier);
    };
    const emitTouchData = (type, touches) => {
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let t = 0; t < touches.length; t++) {
        let byte = 2;
        const numTouches = 1; // the number of touches to be sent this message
        const touch = touches[t];
        const {
          x,
          y
        } = this.getTouchPositionWithOffset(touch);
        Logger.info(`F${this.fingerIds.get(touch.identifier)}=(${x}, ${y})`);
        const coord = this.normalizeAndQuantizeUnsigned(x, y);
        const data = new DataView(new ArrayBuffer(9));
        data.setUint8(0, type);
        data.setUint8(1, numTouches);
        data.setUint16(byte, coord.x, true);
        byte += 2;
        data.setUint16(byte, coord.y, true);
        byte += 2;
        data.setUint8(byte, this.fingerIds.get(touch.identifier));
        byte += 1;
        // force is between 0.0 and 1.0 so quantize into byte.
        // iOs bug: Forced to be always 0.5 on all devices as we do not use forced touch any way;/
        data.setUint8(byte, this.maxByteValue * 0.5);
        byte += 1;
        data.setUint8(byte, coord.inRange ? 1 : 0);
        byte += 1;
        this.sendInputData(data.buffer);
      }
    };
    fromEvent(htmlVideoElement, 'touchstart').pipe(takeUntil$1(this.deactivatedVideoTrigger$)).subscribe(e => {
      this.focusWindow();
      const touches = e.changedTouches;
      // Assign a unique identifier to each touch.
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let t = 0; t < touches.length; t++) {
        rememberTouch(touches[t]);
      }
      Logger.info('touch start');
      emitTouchData(EMessageType.TouchStart, touches);
      e.preventDefault();
    });
    fromEvent(htmlVideoElement, 'touchend').pipe(takeUntil$1(this.deactivatedVideoTrigger$)).subscribe(e => {
      const touches = e.changedTouches;
      Logger.info('touch end');
      emitTouchData(EMessageType.TouchEnd, touches);
      // Re-cycle unique identifiers previously assigned to each touch.
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let t = 0; t < touches.length; t++) {
        forgetTouch(touches[t]);
      }
      e.preventDefault();
    });
    fromEvent(htmlVideoElement, 'touchmove').pipe(takeUntil$1(this.deactivatedVideoTrigger$)).subscribe(e => {
      const touches = e.touches;
      Logger.info('touch move');
      emitTouchData(EMessageType.TouchMove, touches);
      e.preventDefault();
    });
  }
  focusWindow() {
    window.focus();
  }
  emitMouseMove(x, y, deltaX, deltaY) {
    const coord = this.normalizeAndQuantizeUnsigned(x, y);
    const delta = this.normalizeAndQuantizeSigned(deltaX, deltaY);
    const Data = new DataView(new ArrayBuffer(9));
    Data.setUint8(0, EMessageType.MouseMove);
    Data.setUint16(1, coord.x, true);
    Data.setUint16(3, coord.y, true);
    Data.setInt16(5, delta.x, true);
    Data.setInt16(7, delta.y, true);
    this.sendInputData(Data.buffer);
  }
  emitMouseDown(button, x, y) {
    const coord = this.normalizeAndQuantizeUnsigned(x, y);
    const Data = new DataView(new ArrayBuffer(6));
    Data.setUint8(0, EMessageType.MouseDown);
    Data.setUint8(1, button);
    Data.setUint16(2, coord.x, true);
    Data.setUint16(4, coord.y, true);
    this.sendInputData(Data.buffer);
  }
  emitMouseUp(button, x, y) {
    const coord = this.normalizeAndQuantizeUnsigned(x, y);
    const Data = new DataView(new ArrayBuffer(6));
    Data.setUint8(0, EMessageType.MouseUp);
    Data.setUint8(1, button);
    Data.setUint16(2, coord.x, true);
    Data.setUint16(4, coord.y, true);
    this.sendInputData(Data.buffer);
  }
  emitMouseWheel(delta, x, y) {
    const coord = this.normalizeAndQuantizeUnsigned(x, y);
    const Data = new DataView(new ArrayBuffer(7));
    Data.setUint8(0, EMessageType.MouseWheel);
    Data.setInt16(1, delta, true);
    Data.setUint16(3, coord.x, true);
    Data.setUint16(5, coord.y, true);
    this.sendInputData(Data.buffer);
  }
  releaseMouseButtons(buttons, x, y) {
    if (buttons & MouseButtonsMask.PrimaryButton) {
      this.emitMouseUp(MouseButton.MainButton, x, y);
    }
    if (buttons & MouseButtonsMask.SecondaryButton) {
      this.emitMouseUp(MouseButton.SecondaryButton, x, y);
    }
    if (buttons & MouseButtonsMask.AuxiliaryButton) {
      this.emitMouseUp(MouseButton.AuxiliaryButton, x, y);
    }
    if (buttons & MouseButtonsMask.FourthButton) {
      this.emitMouseUp(MouseButton.FourthButton, x, y);
    }
    if (buttons & MouseButtonsMask.FifthButton) {
      this.emitMouseUp(MouseButton.FifthButton, x, y);
    }
  }
  // If the user has any mouse buttons pressed then press them again.
  pressMouseButtons(buttons, x, y) {
    if (buttons & MouseButtonsMask.PrimaryButton) {
      this.emitMouseDown(MouseButton.MainButton, x, y);
    }
    if (buttons & MouseButtonsMask.SecondaryButton) {
      this.emitMouseDown(MouseButton.SecondaryButton, x, y);
    }
    if (buttons & MouseButtonsMask.AuxiliaryButton) {
      this.emitMouseDown(MouseButton.AuxiliaryButton, x, y);
    }
    if (buttons & MouseButtonsMask.FourthButton) {
      this.emitMouseDown(MouseButton.FourthButton, x, y);
    }
    if (buttons & MouseButtonsMask.FifthButton) {
      this.emitMouseDown(MouseButton.FifthButton, x, y);
    }
  }
  registerHoveringMouseEvents(htmlVideoElement) {
    htmlVideoElement.onmousemove = e => {
      const {
        x,
        y
      } = this.getMousePositionWithOffset(e);
      this.emitMouseMove(x, y, e.movementX, e.movementY);
      e.preventDefault();
    };
    htmlVideoElement.onmousedown = e => {
      const {
        x,
        y
      } = this.getMousePositionWithOffset(e);
      this.focusWindow();
      this.emitMouseDown(e.button, x, y);
      e.preventDefault();
    };
    htmlVideoElement.onmouseup = e => {
      const {
        x,
        y
      } = this.getMousePositionWithOffset(e);
      this.emitMouseUp(e.button, x, y);
      e.preventDefault();
    };
    // When the context menu is shown then it is safest to release the button
    // which was pressed when the event happened. This will guarantee we will
    // get at least one mouse up corresponding to a mouse down event. Otherwise
    // the mouse can get stuck.
    // https://github.com/facebook/react/issues/5531
    // playerElement.oncontextmenu = (e) => {
    //   e.preventDefault();
    //   this.emitMouseUp(e.button, e.offsetX, e.offsetY);
    // };
    fromEvent(htmlVideoElement, 'wheel').pipe(takeUntil$1(this.deactivatedVideoTrigger$)).subscribe(e => {
      this.emitMouseWheel(e.deltaY * -120, e.offsetX, e.offsetY);
      e.preventDefault();
    });
    htmlVideoElement.pressMouseButtons = e => {
      this.pressMouseButtons(e.buttons, e.offsetX, e.offsetY);
    };
    htmlVideoElement.releaseMouseButtons = e => {
      this.releaseMouseButtons(e.buttons, e.offsetX, e.offsetY);
    };
  }
  registerMouseEnterAndLeaveEvents(htmlVideoElement) {
    htmlVideoElement.onmouseenter = e => {
      this.focusWindow();
      const Data = new DataView(new ArrayBuffer(1));
      Data.setUint8(0, EMessageType.MouseEnter);
      this.sendInputData(Data.buffer);
      htmlVideoElement.pressMouseButtons(e);
    };
    htmlVideoElement.onmouseleave = e => {
      const Data = new DataView(new ArrayBuffer(1));
      Data.setUint8(0, EMessageType.MouseLeave);
      this.sendInputData(Data.buffer);
      htmlVideoElement.releaseMouseButtons(e);
    };
  }
  // Browser keys do not have a charCode so we only need to test keyCode.
  isKeyCodeBrowserKey(keyCode) {
    // Function keys or tab key.
    return keyCode >= 112 && keyCode <= 123 || keyCode === 9;
  }
  getKeyCode(e) {
    if (e.keyCode === SpecialKeyCodes.Shift && e.code === 'ShiftRight') return SpecialKeyCodes.RightShift;else if (e.keyCode === SpecialKeyCodes.Control && e.code === 'ControlRight') return SpecialKeyCodes.RightControl;else if (e.keyCode === SpecialKeyCodes.Alt && e.code === 'AltRight') return SpecialKeyCodes.RightAlt;else return e.keyCode;
  }
  registerKeyboardEvents(availableKeys) {
    const availableKeyNames = Object.entries(availableKeys).map(([, value]) => {
      return InvertedKeyMap[value];
    });
    const keyBlock = event => {
      const code = event.code;
      const isInputFieldFocused = event.target?.localName === 'input';
      const keyMatch = availableKeyNames.includes(code);
      if (this.isDevMode && !keyMatch) {
        Logger.warn('Code=>', code, 'Keyboard event is not filtered in DEV Mode. App may behave inappropriately!');
        return isInputFieldFocused;
      }
      return isInputFieldFocused || !keyMatch;
    };
    this.startListenKeys(keyBlock);
  }
  startListenKeys(_filter) {
    const filter = _filter ?? (() => false);
    document.onkeydown = e => {
      if (filter(e)) {
        return;
      }
      const isCtrlOrCommand = e.ctrlKey || e.metaKey;
      const isPlusOrMinus = e.keyCode === KeyboardNumericCode.Equal || e.keyCode === KeyboardNumericCode.Minus;
      if (isCtrlOrCommand && isPlusOrMinus) {
        return;
      }
      this.sendInputData(new Uint8Array([EMessageType.KeyDown, this.getKeyCode(e), Number(e.repeat)]).buffer);
      // Backspace is not considered a keypress in JavaScript but we need it
      // to be so characters may be deleted in a UE4 text entry field.
      if (e.keyCode === SpecialKeyCodes.BackSpace) {
        document.onkeypress({
          charCode: SpecialKeyCodes.BackSpace
        });
        //document.dispatchEvent(new KeyboardEvent('keydown',{key: name, keyCode: SpecialKeyCodes.BackSpace, code: SpecialKeyCodes.BackSpace, repeat: false} ));
      }
      if (this.options.suppressBrowserKeys && this.isKeyCodeBrowserKey(e.keyCode)) {
        e.preventDefault();
      }
    };
    document.onkeyup = e => {
      if (filter(e)) {
        return;
      }
      this.sendInputData(new Uint8Array([EMessageType.KeyUp, this.getKeyCode(e)]).buffer);
      if (this.options.suppressBrowserKeys && this.isKeyCodeBrowserKey(e.keyCode)) {
        e.preventDefault();
      }
    };
    document.onkeypress = e => {
      if (filter(e)) {
        return;
      }
      const data = new DataView(new ArrayBuffer(3));
      data.setUint8(0, EMessageType.KeyPress);
      data.setUint16(1, e.charCode, true);
      this.sendInputData(data.buffer);
    };
  }
}
let RegionsPingService = /*#__PURE__*/(() => {
  class RegionsPingService {
    constructor() {
      this.httpClient = inject(HttpClient);
      this.unrealInitialConfig = inject(UNREAL_CONFIG, {
        optional: true
      });
      this.config = {
        ping_count: 2,
        ping_timeout: 2000,
        max_parallel_requests: 10,
        bust_cache: true
      };
      if (!this.unrealInitialConfig?.regionsPingUrl) {
        return;
      }
    }
    getFastest(regionListUrl = this.unrealInitialConfig?.regionsPingUrl || '') {
      return this.getProviders(regionListUrl).pipe(switchMap$1(providers => this.getPingResult(providers)), catchError(() => of(null)), map$1(data => data?.region_code));
    }
    getPingResult(providers) {
      const regions = providers.regions;
      this.config.ping_timeout = providers.timeout || this.config.ping_timeout;
      return from(this.startPinging(regions));
    }
    getProviders(regionList = this.unrealInitialConfig?.regionsPingUrl || '') {
      return this.httpClient.get(regionList);
    }
    startPinging(endpoints) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async resolve => {
        const pingResults = [];
        const semaphore = new Semaphore(10);
        const tasks = endpoints.map(async ({
          region_code,
          url,
          timeout
        }) => {
          await semaphore.acquire();
          try {
            const result = await this.checkLatency(url, timeout);
            const data = {
              region_code,
              result
            };
            pingResults.push({
              region_code,
              result
            });
            resolve(data);
          } catch {
            pingResults.push({
              region_code: undefined,
              result: []
            });
          } finally {
            semaphore.release();
          }
          const okValues = pingResults.filter(pingResult => pingResult.result.length > 1);
          if (okValues.length) {
            return okValues[0];
          }
          return okValues;
        });
        await Promise.all(tasks);
        resolve(null);
      });
    }
    async checkLatency(endpoint, timeout = this.config.ping_timeout) {
      const pingResults = [];
      for (let i = 0; i < this.config.ping_count; i++) {
        const startTime = performance.now();
        try {
          await this.fetchWithTimeout(this.config.bust_cache ? `${endpoint}?&cache_buster=${performance.now()}` : endpoint, {
            method: 'GET',
            mode: 'no-cors',
            headers: {
              'Cache-Control': 'no-cache, no-store, must-revalidate',
              Pragma: 'no-cache',
              Expires: '0'
            },
            credentials: 'omit' // Optional: prevents sending or receiving cookies, which can affect caching.
          }, timeout);
        } finally {
          const latency = Math.round(performance.now() - startTime);
          pingResults.push(latency);
        }
      }
      return pingResults;
    }
    async fetchWithTimeout(url, options = {}, timeout) {
      const controller = new AbortController();
      options.signal = controller.signal;
      const timeoutId = setTimeout(() => controller.abort(), timeout);
      try {
        const response = await fetch(url, options);
        clearTimeout(timeoutId);
        return response;
      } catch (error) {
        clearTimeout(timeoutId);
        throw error;
      }
    }
    static {
      this.ɵfac = function RegionsPingService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RegionsPingService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: RegionsPingService,
        factory: RegionsPingService.ɵfac
      });
    }
  }
  return RegionsPingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let StreamStatusTelemetryService = /*#__PURE__*/(() => {
  class StreamStatusTelemetryService {
    constructor() {
      this.store = inject(Store);
      this.videoService = inject(VideoService);
      this.initTelemetry();
    }
    mapEventData(data, signalingServer, isLowBandwidth, lbmStats) {
      const {
        bitrate,
        VideoEncoderQP,
        framesPerSecond,
        frameWidth,
        frameHeight,
        jitter,
        packetsLost,
        currentRoundTripTime
      } = data.aggregatedStats;
      return {
        runTime: data.aggregatedStats.runTime,
        frameWidth,
        frameHeight,
        isLowBandwidth,
        client: signalingServer.wsUrl,
        pixelRatio: window.devicePixelRatio,
        framesPerSecond,
        jitter,
        packetsLost,
        instanceName: signalingServer.instanceName,
        bitrate,
        lbmStats,
        rtt: currentRoundTripTime,
        VideoEncoderQP
      };
    }
    initTelemetry() {
      this.videoService.videoStats$.pipe(withLatestFrom(this.store.select(unrealFeature.selectAwsInstance), this.store.select(unrealFeature.selectLowBandwidth), this.store.select(unrealFeature.selectLowBandwidthStats), this.store.select(unrealFeature.selectCirrusConnected)), auditTime(5000), filter(([,,,, cirrusConnected]) => cirrusConnected), map$1(([data, signalingServer, isLowBandwidth, lbmStats]) => this.mapEventData(data, signalingServer, isLowBandwidth, lbmStats))).subscribe(data => this.trackEventToMixPanel(data));
    }
    trackEventToMixPanel(data) {
      this.store.dispatch(trackMixpanelEvent({
        event: 'streamStatus',
        data
      }));
    }
    init() {
      // do nothing, just to not forget to initialize Service
    }
    static {
      this.ɵfac = function StreamStatusTelemetryService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || StreamStatusTelemetryService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: StreamStatusTelemetryService,
        factory: StreamStatusTelemetryService.ɵfac
      });
    }
  }
  return StreamStatusTelemetryService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UnrealErrorModalComponent = /*#__PURE__*/(() => {
  class UnrealErrorModalComponent {
    constructor() {
      this.dialogRef = inject(DialogRef);
      this.dialogData = inject(DIALOG_DATA);
    }
    close() {
      this.dialogRef.close();
    }
    static {
      this.ɵfac = function UnrealErrorModalComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UnrealErrorModalComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: UnrealErrorModalComponent,
        selectors: [["app-unreal-error-modal"]],
        decls: 10,
        vars: 3,
        consts: [[1, "src-modal", "src-modal--small"], [1, "src-modal__header"], [1, "src-modal__title"], [1, "src-modal__body"], [1, "src-modal__footer"], [3, "onClick", "colorScheme"]],
        template: function UnrealErrorModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵtext(3, " Warning ");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "div", 3)(5, "div");
            i0.ɵɵtext(6);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "div", 4)(8, "src-button", 5);
            i0.ɵɵlistener("onClick", function UnrealErrorModalComponent_Template_src_button_onClick_8_listener() {
              return ctx.close();
            });
            i0.ɵɵtext(9, " Ok ");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("data-testid", "unreal-error-header-title");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.dialogData.content);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("colorScheme", "secondary");
          }
        },
        dependencies: [SourceButtonComponent],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return UnrealErrorModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UnrealEffects = /*#__PURE__*/(() => {
  class UnrealEffects {
    constructor() {
      this.dialog = inject(Dialog);
      this.http = inject(HttpClient);
      this.store = inject(Store);
      this.isDevMode = inject(DevModeService).isDevMode;
      this.unrealInitialConfig = inject(UNREAL_CONFIG, {
        optional: true
      });
      this.actions$ = inject(Actions);
      this.player = inject(WebRtcPlayerService);
      this.signallingService = inject(SignallingService);
      this.scrollStrategy = inject(ScrollStrategyOptions).block();
      this.commandsSender = inject(UnrealCommunicatorService);
      this.videoService = inject(VideoService);
      this.dataChannelConnectionTimeout = this.unrealInitialConfig?.dataChannelConnectionTimeout ?? DATA_CHANNEL_CONNECTION_TIMEOUT;
      this.cirrusDisconnectEffect$ = createEffect(() => {
        return this.actions$.pipe(ofType(setCirrusDisconnected), map(() => resetUnrealState()));
      });
      this.destroyConnections$ = createEffect(() => {
        return this.actions$.pipe(ofType(destroyConnectionsAndResetState), map(() => destroyRemoteConnections({
          disconnectReason: DisconnectReason.reset
        })));
      });
      this.resetState$ = createEffect(() => {
        return this.actions$.pipe(ofType(destroyConnectionsAndResetState), map(() => resetUnrealState()));
      });
      this.destroyRemoteConnections$ = createEffect(() => {
        return this.actions$.pipe(ofType(destroyRemoteConnections), tap(({
          disconnectReason
        }) => {
          this.signallingService.close({
            code: WSCloseCode_NORMAL_CIRRUS_CLOSED,
            reason: disconnectReason
          });
          this.player.closePC();
        }));
      }, {
        dispatch: false
      });
      this.changeStreamResolution$ = createEffect(() => {
        return this.actions$.pipe(ofType(changeStreamResolutionAction), filter(size => !!(size?.width && size?.height)), concatLatestFrom(() => [this.store.select(unrealFeature.selectStreamResolution)]), filter(([newSizes, savedSizes]) => !(newSizes.width === savedSizes.width && newSizes.height === savedSizes.height)), map(([sizes]) => changeStreamResolutionSuccessAction({
          width: sizes.width,
          height: sizes.height
        })));
      });
      this.forceLBMOff$ = createEffect(() => {
        return fromEvent(document, 'visibilitychange').pipe(map(() => document.visibilityState === 'visible'), filter(Truthy), tapLog('forceLBMOff$'), map(() => changeLowBandwidth({
          lowBandwidth: false
        })));
      });
      this.resetFreezeFrameOnLowBandwidthTriggered$ = createEffect(() => {
        return this.actions$.pipe(ofType(changeLowBandwidth), map(state => state.lowBandwidth), distinctUntilChanged(), map(() => setFreezeFrame({
          dataUrl: null,
          progress: null
        })));
      });
      this.sendLbmStat$ = this.store.select(unrealFeature.selectViewportReady).pipe(distinctUntilChanged(), filter(Truthy), exhaustMap(() => this.actions$.pipe(ofType(changeLowBandwidth), filter(({
        lowBandwidth
      }) => lowBandwidth), concatLatestFrom(() => [this.store.select(unrealFeature.selectAwsInstance), this.store.select(unrealFeature.selectStreamClientCompanyId), this.store.select(unrealFeature.selectStreamViewId)]), first(), exhaustMap(([, instance, companyId, viewId]) => this.http.post(this.unrealInitialConfig?.customErrorsEndpoint || '', {
        message: {
          type: 'front',
          error: 'low_bandwidth_mode',
          signalling: instance.pollingUrl
        },
        client: instance.pollingUrl,
        session_uuid: companyId,
        session_uuid2: viewId
      }).pipe(catchError(() => EMPTY)))))).subscribe();
      this.resetAfk$ = createEffect(() => {
        return this.actions$.pipe(ofType(setConfig, resetWarnTimeout, resetConfig), map(() => resetAfkAction()));
      });
      this.resetFreezeFrameOnViewportDestroy$ = createEffect(() => {
        return this.actions$.pipe(ofType(setViewportReady), filter(Falsy), map(() => setFreezeFrame({
          dataUrl: null,
          progress: null
        })));
      });
      this.setMaxFps$ = createEffect(() => {
        return this.actions$.pipe(ofType(setMaxFps), tap(({
          maxFps
        }) => {
          this.commandsSender.sendCommandToUnreal(getSetFpsCommand(maxFps));
        }));
      }, {
        dispatch: false
      });
      this.webrtcErrorModalComponent$ = createEffect(() => {
        return this.actions$.pipe(ofType(setErrorMessage), debounceTime$1(400), combineLatestWith(this.store.select(unrealFeature.selectDataChannelConnected)), filter(([error, isConnected]) => {
          return !isConnected && error?.errorType === 'WebRTCError';
        }), tap(() => this.dialog.open(WebrtcErrorModalComponent)));
      }, {
        dispatch: false
      });
      this.resetAfkAction$ = createEffect(() => {
        return this.actions$.pipe(ofType(resetAfkAction), tap(() => resetAfk()));
      }, {
        dispatch: false
      });
      this.setDataChannelTimeoutCheck$ = createEffect(() => {
        return this.actions$.pipe(ofType(setAwsInstance), filter(({
          wsUrl
        }) => !!wsUrl), tap(() => Logger.info(`DataChannel timeout check started with next timeout: ${this.dataChannelConnectionTimeout}`)), debounceTime$1(this.dataChannelConnectionTimeout),
        // Timeout, if not connected, sends an error report, then reconnects
        concatLatestFrom(() => [this.store.select(unrealFeature.selectSsData), this.store.select(unrealFeature.selectCirrusConnected), this.store.select(unrealFeature.selectDataChannelConnected)]), filter(([,, isCirrusConnected, isDataChannelConnected]) => {
          return isCirrusConnected && !isDataChannelConnected;
        }), switchMap$1(([awsInstance, ssData]) => {
          const error = `DataChannel connection timeout ${this.dataChannelConnectionTimeout}ms, requesting new signaling.`;
          Logger.error(error);
          return this.http.post(awsInstance.pollingUrl || '', {
            awsInstance,
            connectionId: ssData?.connectionId,
            href: location.href,
            userAgent: navigator.userAgent,
            error
          }).pipe(catchError(error => {
            Logger.error('Error sending timeout info:', error);
            return of(null);
          }));
        }), map(() => destroyRemoteConnections({
          disconnectReason: DisconnectReason.dataChannelTimeout
        })));
      });
      this.destroyConnectionAndRestart$ = createEffect(() => {
        return this.actions$.pipe(ofType(destroyRemoteConnections), filter(({
          disconnectReason
        }) => disconnectReason === DisconnectReason.dataChannelTimeout), switchMap$1(() => this.actions$.pipe(ofType(resetUnrealState), first())), map(() => initSignalling()));
      });
      this.showUnrealError$ = createEffect(() => {
        return this.actions$.pipe(ofType(showUnrealErrorMessage), map(({
          code
        }) => getRtcErrorMessage(code)), distinctUntilChanged(), filter(Truthy), switchMap$1(content => this.dialog.open(UnrealErrorModalComponent, {
          scrollStrategy: this.scrollStrategy,
          data: {
            content
          }
        }).closed), map(() => showUnrealErrorMessage({
          code: null
        })));
      });
      this.sendStatisticsToUnreal$ = createEffect(() => {
        return this.actions$.pipe(ofType(showUnrealErrorMessage), filter(({
          code
        }) => code === 404), concatLatestFrom(() => [this.store.select(unrealFeature.selectAwsInstance), this.store.select(unrealFeature.selectStreamClientCompanyId), this.store.select(unrealFeature.selectStreamViewId)]), switchMap$1(([action, instance, companyId, viewId]) => this.http.post(this.unrealInitialConfig?.customErrorsEndpoint || '', {
          client: instance.pollingUrl,
          session_uuid: companyId,
          session_uuid2: viewId,
          message: {
            type: 'front',
            error: 'pak_not_found',
            info: action?.error ?? ''
          }
        }).pipe(mapResponse({
          next: () => console.log(`successfully send to ${this.unrealInitialConfig?.customErrorsEndpoint}`),
          error: () => console.error(`get error from ${this.unrealInitialConfig?.customErrorsEndpoint}`)
        }))));
      }, {
        dispatch: false
      });
      this.initAppBySetDataChannelConnected$ = createEffect(() => {
        return this.actions$.pipe(ofType(setDataChannelConnected), tap(() => {
          this.commandsSender.sendCommandToUnreal(getExecuteConsoleCommand({
            value: CONSOLE_COMMAND_PIXEL_QUALITY
          }));
          this.commandsSender.sendCommandToUnreal(getDebugModeCommand({
            value: this.isDevMode
          }));
          TelemetryStart('SetViewportReady');
        }), switchMap$1(() => this.store.select(selectCommandsInProgress).pipe(debounceTime$1(100),
        // !IMPORTANT last command detection time
        first(), switchMap$1(() => observeCommandResponse(getLoopBackCommand(), data => this.commandsSender.sendCommandToUnreal(data))), switchMap$1(() => this.videoService.videoStats$), filter(videoStats => !!videoStats.aggregatedStats.framesPerSecond && videoStats.aggregatedStats.framesPerSecond > MINIMAL_FPS && (videoStats.aggregatedStats.framesDecoded || 0) > 15), first(), map(() => setLoopBackCommandIsCompleted()))));
      });
      this.setViewportReadyBySetLoopBackCommandIsCompleted$ = createEffect(() => {
        return this.actions$.pipe(ofType(setLoopBackCommandIsCompleted), tap(() => TelemetryStop('SetViewportReady', {
          ready: true
        })), map(() => setViewportReady({
          value: true
        })));
      });
      this.listenUnrealCallbackByInitSignalling$ = createEffect(() => {
        return this.actions$.pipe(ofType(initSignalling), switchMap$1(() => fromSignal(UnrealInternalSignalEvents.UnrealCallback).pipe(map(({
          json
        }) => json?.commandCallback?.correlationId), filter(Truthy), map(id => commandCompleted({
          id
        })))));
      });
      this.setConfigByInitSignalling$ = createEffect(() => {
        return this.actions$.pipe(ofType(initSignalling), concatLatestFrom(() => this.store.select(unrealFeature.selectMatchUrls)), switchMap$1(() => this.store.select(unrealFeature.selectMatchUrls).pipe(filter(item => item?.length > 0))), map(matchMakerUrls => {
          if (isEmpty(matchMakerUrls)) {
            throw Error('Signalling URL(s) is empty');
          }
          return setConfig({
            config: {
              matchMakerUrls
            }
          });
        }));
      });
    }
    static {
      this.ɵfac = function UnrealEffects_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UnrealEffects)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UnrealEffects,
        factory: UnrealEffects.ɵfac
      });
    }
  }
  return UnrealEffects;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const selectFreezeFrameDataUrlFromVideo = createSelector(unrealFeature.selectFreezeFrameFromVideo, unrealFeature.selectLowBandwidth, (freezeFrameFromVideo, isLow) => isLow ? null : freezeFrameFromVideo?.dataUrl || null);
const selectFreezeFrameProgressMessageFromVideo = createSelector(unrealFeature.selectFreezeFrameFromVideo, unrealFeature.selectLowBandwidth, (freezeFrameFromVideo, isLow) => isLow ? null : freezeFrameFromVideo?.progress || null);
const selectFreezeFrameDataUrl = createSelector(unrealFeature.selectFreezeFrame, unrealFeature.selectLowBandwidth, (freezeFrame, isLow) => freezeFrame?.dataUrl && isLow ? freezeFrame?.dataUrl : null);
const selectIsFreezeFrameLoading = createSelector(unrealFeature.selectFreezeFrame, freezeFrame => freezeFrame?.progress ? freezeFrame.progress > 0 && freezeFrame.progress < 1 : false);
const selectFreezeFrameCombinedDataUrl = createSelector(selectFreezeFrameDataUrlFromVideo, selectFreezeFrameDataUrl, (dataUrlFromVideo, remoteDataUrl) => dataUrlFromVideo || remoteDataUrl || null);
const selectStreamConfig = createSelector(unrealFeature.selectStreamConfig, config => config);
const selectWarnTimeout = createSelector(selectStreamConfig, config => config?.warnTimeout || DEFAULT_AFK_TIMEOUT);
const selectMatchUrls = createSelector(selectStreamConfig, config => (config?.matchMakerUrls || []).filter(Truthy));
const selectIsAutostart = createSelector(selectStreamConfig, config => config?.autoStart);
const selectWsUrl = createSelector(unrealFeature.selectAwsInstance, instance => instance?.wsUrl);
const selectShowReconnectPopup = createSelector(unrealFeature.selectWasInitialized, unrealFeature.selectCirrusConnected, unrealFeature.selectEstablishingConnection, unrealFeature.selectImageIntroSrc, unrealFeature.selectVideoIntroSrc, (wasInitialized, connected, establishing, imageSrc, videoSrc) => wasInitialized && !connected && !establishing && !imageSrc && !videoSrc);
const selectShowLoader = createSelector(unrealFeature.selectWasInitialized, unrealFeature.selectViewportReady, selectStreamConfig, selectShowReconnectPopup, (wasInitialized, viewportReady, config, showPopup) => (config.autoStart && !wasInitialized || !showPopup) && !viewportReady);
const selectIsVideoPlayingAndDataChannelConnected = createSelector(unrealFeature.selectIsVideoPlaying, unrealFeature.selectDataChannelConnected, (isVideoPlaying, isDataChannelConnected) => isVideoPlaying && isDataChannelConnected);
const selectSignalingParameters = createSelector(unrealFeature.selectSsData, unrealFeature.selectAwsInstance, unrealFeature.selectSsInfo, (data, instance, ssInfo) => {
  const info = [];
  if (data) {
    info.push(`${data.cirrusVersion}, ${data.branchInfo}`);
    info.push(`Unreal App Version: ${data.streamerVersion}`);
    info.push(`APP: ${data.streamPath}${data.streamApp}`);
  } else {
    info.push(ssInfo);
  }
  info.push(`Polling: ${instance.pollingUrl}`);
  info.push(`WS: ${instance.wsUrl}`);
  return info.join('<br>');
});
const selectLoaderCommands = createSelector(unrealFeature.selectLoaderCommands, loaderCommands => loaderCommands);
const selectCommandsInProgress = createSelector(selectLoaderCommands, loaderCommands => loaderCommands.commandsInProgress.length);
const selectCommandProgress = createSelector(selectLoaderCommands, loaderCommands => {
  if (loaderCommands.totalCommandsStarted > 0) {
    return loaderCommands.totalCommandsCompleted / loaderCommands.totalCommandsStarted;
  }
  return 0;
});
const selectLastCommandInProgress = createSelector(selectLoaderCommands, loaderCommands => loaderCommands.commandsInProgress?.length ? loaderCommands.commandsInProgress[loaderCommands.commandsInProgress.length - 1] : null);
/**
 * Returns Scene load progress as a float value in between 0-1
 */
const selectTotalProgress = createSelector(unrealFeature.selectStatusPercentSignallingServer, selectCommandProgress, unrealFeature.selectAwsInstance, (statusPercentSignallingServer, commandProgress, awsInstance) => {
  /**
   * Set 57% {@link SIGNALLING_PERCENT_VALUE} immediately when signalingServer?.signalingUrl is available
   * Up to 56% {@link SIGNALLING_PERCENT_VALUE} - 1 of the progress is reserved for signaling server polling
   */
  const SIGNALLING_MAX = SIGNALLING_PERCENT_VALUE / 100;
  const splitPoint = awsInstance?.wsUrl ? SIGNALLING_MAX + 0.01 : SIGNALLING_MAX;
  const percentSignaling = lerp(0.001, splitPoint, (statusPercentSignallingServer ?? 0) / 100);
  const percentRest = lerp(0, 1 - splitPoint, commandProgress);
  return clampf(0, 1, percentSignaling + percentRest);
});
function InstanceReservedHandler(msg) {
  this.store.dispatch(setSignalingName({
    instanceName: msg.payload.instanceId
  }));
}
function PingHandler() {
  this.send(JSON.stringify({
    type: 'pong',
    source: 'front'
  }));
}
function PlayerCountHandler(msg) {
  Logger.log(msg);
}
function SSInfoHandler(msg) {
  this.store.dispatch(updateCirrusInfo({
    ssInfo: msg.message,
    ssData: msg.data
  }));
  return null;
}
function OnCloseHandler(e) {
  this.stopRetryTimer();
  Logger.warn(`WS closed: ${JSON.stringify(e.code)} - ${e.reason}`);
  this.store.dispatch(setCirrusDisconnected());
}
function OnErrorHandler(e) {
  clearTimeout(this.wsTimeoutHandler);
  Logger.warn(`WS error: ${JSON.stringify(e)}`);
  this.store.dispatch(setErrorMessage({
    errorType: 'WebSocketError',
    message: 'WebSocket Error'
  }));
  this.store.dispatch(destroyRemoteConnections({
    disconnectReason: DisconnectReason.wsOnError
  }));
  this.initEstablishingConnection();
  this.watchTimeoutOrErrorAndReconnectLater();
}
function OnMessageHandler(e) {
  clearTimeout(this.wsTimeoutHandler);
  const handleData = data => {
    //Logger.colored(...COLOR_CODES.FROM_SIGNALING, data);
    const msg = JSON.parse(data);
    this.handleMessage(msg);
  };
  if (typeof e.data === 'string') {
    handleData(e.data);
  } else if (e.data instanceof Blob) {
    e.data.text().then(handleData);
  }
}
function OnOpenHandler() {
  this.stopRetryTimer();
  this.store.dispatch(setCirrusConnected());
  this.send({
    type: OrchestrationMessageTypes.requestReservation,
    correlationId: this.correlationId,
    payload: {
      environmentId: this.environmentId
    }
  });
  this.send({
    type: OrchestrationMessageTypes.listStreamers,
    correlationId: this.correlationId
  });
}
const clampAndKeepMaxPercents = () => {
  return source => source.pipe(scan((maxProgress, currentProgress) => currentProgress > maxProgress ? currentProgress : maxProgress, 0));
};
function observeCommandResponse(data, sender, timeOut = 60000, dispatchOnTimeout = true) {
  const correlationId = generateUuid();
  const out = {
    ...data,
    correlationId
  };
  const observable = fromSignal(UnrealInternalSignalEvents.UnrealCallback).pipe(map$1(({
    json
  }) => {
    // Some callbacks do not have commandCallback wrapper,
    // so first we check if it exists,
    // then fallback to JSON itself
    return 'commandCallback' in json ? {
      json
    } : {
      json: {
        commandCallback: json
      }
    };
  }), filter(({
    json
  }) => {
    return json.commandCallback.correlationId === correlationId;
  }), timeout(timeOut), catchError(() => dispatchOnTimeout ? of({
    json: {
      commandCallback: {
        correlationId: 'timeout'
      }
    }
  }) : of(null)), first(), tapLog('Command Response Observer'), filter(Truthy));
  setTimeout(() => sender(out), 0);
  return observable;
}
function decodeData(anyData) {
  try {
    return new TextDecoder('utf-16').decode(anyData);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return '';
  }
}

/**
 * UnrealInternalSignalEvents commands list wrapper listener
 * @param event
 */
function fromSignal(event) {
  return Signal.on(event).pipe(
  //tapLog('fromSignal', event), // <== for debugging, do not remove
  map$1(data => data.detail));
}
/**
 * UnrealInternalSignalEvents commands list wrapper sender
 * @param event
 * @param args
 */
function sendSignal(event, ...args) {
  Signal.broadcast(event, {
    detail: args?.[0] || null
  });
}
function fromUnrealCallBackSignal(command) {
  return fromSignal(UnrealInternalSignalEvents.UnrealCallback).pipe(map$1(data => data?.json), map$1(json => {
    if ('commandCallback' in json) {
      return json?.commandCallback;
    }
    return json;
  }), filter(json => json.command === command), map$1(data => data), map$1(data => {
    if ('payload' in data) {
      return {
        command: data.command,
        payload: data?.payload
      };
    }
    return {
      command: data.command
    };
  }));
}
const dispatchResize = () => {
  window.dispatchEvent(new Event('resize'));
};
const forceResizeUnrealVideo = () => {
  sendSignal(UnrealInternalSignalEvents.ForceResizeViewport);
};
const errorCodes = {
  code404: 'Your asset is being synced on Metabox servers and is not yet available in Metabox Studio or Metabox Configurator. Please check again later after syncing is complete. '
};
function getRtcErrorMessage(code) {
  if (code === null) return undefined;
  return errorCodes[`code${code}`];
}
const floatToSmoothPercents = () => {
  return source => source.pipe(scan((acc, value) => ({
    previous: acc.current,
    current: value,
    previousTs: acc.currentTs,
    currentTs: typeof performance !== 'undefined' ? performance.now() : Date.now()
  }), {
    previous: 0,
    current: 0,
    previousTs: 0,
    currentTs: 0
  }), concatMap(({
    previous,
    current,
    previousTs,
    currentTs
  }) => {
    // time delta in milliseconds
    const dt = previousTs ? currentTs - previousTs : 0;
    if (Math.abs(current - previous) > 0.95) {
      // Assume that a big difference seems like switch between 0 and 1 immediately after resetLoaderState(),
      // so it should go to 'current' without transitions
      return of(current);
    }
    // Max 300ms duration for smooth transition
    return smoothTransition(previous, current, Math.min(dt, 300));
  }), map$1(value => clampf(0, 100, Math.round(value * 100))));
};
/**
 * Creates an observable that emits values transitioning smoothly from the start value to the end value over a specified duration.
 * The transition is performed using linear interpolation (lerp) and clamped to the range [0, 1].
 *
 * @param {number} start - The starting value of the transition.
 * @param {number} end - The ending value of the transition.
 * @param {number} duration - The duration of the transition in milliseconds.
 * @returns {Observable<number>} An observable that emits the interpolated values from start to end over the specified duration.
 */
const smoothTransition = (start, end, duration) => {
  const startTime = animationFrameScheduler.now();
  return interval(0, animationFrameScheduler).pipe(map$1(() => {
    const elapsed = (animationFrameScheduler.now() - startTime) / duration;
    return clampf(0, 1, elapsed);
  }), distinctUntilChanged(), takeWhile(fraction => fraction < 1, true), map$1(fraction => lerp(start, end, fraction)));
};
const getImageFromVideoStream = (takeSizeFrom = 'video', imageOutput, sizes) => {
  try {
    const video = document.getElementById(STREAMING_VIDEO_ID);
    const {
      canvas,
      ctx
    } = getCanvasCached('video');
    canvas.width = takeSizeFrom === 'video' ? sizes?.width || video?.clientWidth || FULL_HD_WIDTH : FULL_HD_WIDTH;
    canvas.height = takeSizeFrom === 'video' ? sizes?.height || video?.clientHeight || FULL_HD_HEIGHT : FULL_HD_HEIGHT;
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    return getSnapshot(canvas, canvas.width, imageOutput);
  } catch {
    return null;
  }
};

/**
 * Generator for loop through urls
 * Each time it will return the next url, based on an index which MUST NOT be re-initialized inside function
 * @param urls
 */
let index = 0;
function* getActiveUrl(urls) {
  while (true) {
    yield urls[index++ % urls.length];
  }
}
class KalmanFilter1D {
  /**
   * @param initialEstimate Initial guess of the state.
   * @param initialUncertainty Initial uncertainty in the guess.
   * @param processNoise Process variance (Q) representing model uncertainty.
   * @param measurementNoise Measurement variance (R) representing noise in measurements.
   */
  constructor(initialEstimate, initialUncertainty, processNoise, measurementNoise) {
    this.estimate = initialEstimate;
    this.uncertainty = initialUncertainty;
    this.processNoise = processNoise;
    this.measurementNoise = measurementNoise;
  }
  /**
   * Incorporates a new measurement and returns the updated estimate.
   * @param measurement The new measurement value.
   */
  update(measurement) {
    // === Prediction Step ===
    // For a constant model, the predicted state is the previous estimate.
    const predictedEstimate = this.estimate;
    // Increase the uncertainty by the process noise.
    const predictedUncertainty = this.uncertainty + this.processNoise;
    // === Update Step ===
    // Compute the innovation or measurement residual.
    const innovation = measurement - predictedEstimate;
    // Compute the innovation covariance.
    const innovationCovariance = predictedUncertainty + this.measurementNoise;
    // Compute the Kalman Gain.
    const kalmanGain = predictedUncertainty / innovationCovariance;
    // Update the estimate with the measurement, weighted by the Kalman Gain.
    this.estimate = predictedEstimate + kalmanGain * innovation;
    // Update the uncertainty.
    this.uncertainty = (1 - kalmanGain) * predictedUncertainty;
    return this.estimate;
  }
  config(data) {
    const {
      initialBitrateEstimate,
      initialErrorCovariance,
      processNoise,
      measurementNoise
    } = data;
    this.estimate = initialBitrateEstimate;
    this.uncertainty = initialErrorCovariance;
    this.processNoise = processNoise;
    this.measurementNoise = measurementNoise;
  }
}
class LatencyTimings {
  Reset() {
    this.TestStartTimeMs = null;
    this.UEReceiptTimeMs = null;
    this.UEEncodeMs = null;
    this.UECaptureToSendMs = null;
    this.UETransmissionTimeMs = null;
    this.BrowserReceiptTimeMs = null;
    this.FrameDisplayDeltaTimeMs = null;
  }
  SetUETimings(UETimings) {
    this.UEReceiptTimeMs = UETimings.ReceiptTimeMs;
    this.UEEncodeMs = UETimings.EncodeMs;
    this.UECaptureToSendMs = UETimings.CaptureToSendMs;
    this.UETransmissionTimeMs = UETimings.TransmissionTimeMs;
    this.BrowserReceiptTimeMs = Date.now();
    this.OnAllLatencyTimingsReady(this);
  }
  SetFrameDisplayDeltaTime(DeltaTimeMs) {
    if (this.FrameDisplayDeltaTimeMs == null) {
      this.FrameDisplayDeltaTimeMs = Math.round(DeltaTimeMs);
      this.OnAllLatencyTimingsReady(this);
    }
  }
  OnAllLatencyTimingsReady(_) {}
}
function mapQpToQuality(VideoEncoderQP) {
  const orangeQP = 26;
  const redQP = 35;
  let quality = 'lime';
  if (VideoEncoderQP > redQP) {
    quality = 'red';
  } else if (VideoEncoderQP > orangeQP) {
    quality = 'orange';
  }
  return quality;
}
const getResetControlClampsCommand = () => ({
  command: MetaBoxCommand.FResetControlClampsCommand
});
const getCameraRecenterCommand = () => ({
  command: MetaBoxCommand.FCameraRecenterCommand
});
const unLoadAllLevelsCommand = () => ({
  command: MetaBoxCommand.FUnLoadAllLevelsCommand
});
const getDragCommand = () => ({
  command: MetaBoxCommand.FDragCommand
});
const getUnselectAllProductsCommand = () => ({
  command: MetaBoxCommand.FUnselectAllProductsCommand
});
const getPauseSequenceCommand = () => ({
  command: MetaBoxCommand.FPauseSequenceCommand
});
const getStopSequenceCommand = () => ({
  command: MetaBoxCommand.FStopSequenceCommand
});
const getUnLoadAllProductsCommand = () => ({
  command: MetaBoxCommand.FUnLoadAllProductsCommand
});
const getRequestCameraPresetCommand = () => ({
  command: MetaBoxCommand.FRequestCameraPresetCommand
});
const getLoopBackCommand = () => ({
  command: MetaBoxCommand.FLoopBackCommand
});
const getSetFpsCommand = fpsRequired => ({
  command: MetaBoxCommand.FExecuteConsoleCommandCommand,
  payload: {
    value: `t.MaxFPS ${fpsRequired}`
  }
});
const getFreezeFrameCommand = (payload, source) => ({
  command: MetaBoxCommand.FFreezeFrameCommand,
  payload,
  source
});
const getFreezeFrameNative = () => ({
  command: MetaBoxCommand.FFreezeFrameV2Command
});
const getUnfreezeFrameNative = () => ({
  command: MetaBoxCommand.FUnfreezeFrameV2Command
});
const getDragSequenceCommand = payload => ({
  command: MetaBoxCommand.FDragSequenceCommand,
  payload
});
const alignProductsToPlaneCommand = payload => ({
  command: MetaBoxCommand.FAlignProductsToPlaneCommand,
  payload
});
const getApplyCameraPresetCommand = payload => ({
  command: MetaBoxCommand.FApplyCameraPresetCommand,
  payload
});
const getLoadSceneStateCommand = payload => ({
  command: MetaBoxCommand.FLoadSceneStateCommand,
  payload
});
const getClickSnapCommand = payload => ({
  command: MetaBoxCommand.FClickSnapCommand,
  payload
});
const getSetControlCameraModeCommand = payload => ({
  command: MetaBoxCommand.FSetControlCameraModeCommand,
  payload
});
const getSetCameraControlClampsCommand = payload => ({
  command: MetaBoxCommand.FSetCameraControlClampsCommand,
  payload
});
const getSetPawnMovementModeCommand = payload => ({
  command: MetaBoxCommand.FSetPawnMovementModeCommand,
  payload
});
const getEnableTeleportCommand = payload => ({
  command: MetaBoxCommand.FEnableTeleportCommand,
  payload
});
const getEnableSceneStateCallbackCommand = payload => ({
  command: MetaBoxCommand.FEnableSceneStateCallbackCommand,
  payload
});
const getApplyZoomCommand = payload => ({
  command: MetaBoxCommand.FApplyZoomCommand,
  payload
});
const getCameraBoxCommand = payload => ({
  command: MetaBoxCommand.FCameraBoxCommand,
  payload
});
const getDropCommand = payload => ({
  command: MetaBoxCommand.FDropCommand,
  payload
});
const getSelectProductByObjectNameCommand = payload => ({
  command: MetaBoxCommand.FSelectProductByObjectNameCommand,
  payload
});
const getChangeGizmoTypeCommand = payload => ({
  command: MetaBoxCommand.FChangeGizmoTypeCommand,
  payload
});
const getWeatherCommand = payload => ({
  command: MetaBoxCommand.FWeatherCommand,
  payload
});
const getFitToObjectsCommand = payload => ({
  command: MetaBoxCommand.FFitToObjectsCommand,
  payload
});
const setProductsLocationCommand = payload => ({
  command: MetaBoxCommand.FSetProductsLocationCommand,
  payload
});
const getChangeResolutionCommand = payload => ({
  command: MetaBoxCommand.FChangeResolutionCommand,
  payload
});
const getEnableSpinnerModeCommand = payload => ({
  command: MetaBoxCommand.FEnableSpinnerModeCommand,
  payload
});
const getControlSensitivityCommand = payload => ({
  command: MetaBoxCommand.FControlSensitivityCommand,
  payload
});
const getCameraSettingsCommand = payload => ({
  command: MetaBoxCommand.FCameraSettingsCommand,
  payload
});
const getDebugModeCommand = payload => ({
  command: MetaBoxCommand.FDebugModeCommand,
  payload
});
const getEnableControlsCommand = payload => ({
  command: MetaBoxCommand.FEnableControlsCommand,
  payload
});
const getExecuteConsoleCommand = payload => ({
  command: MetaBoxCommand.FExecuteConsoleCommandCommand,
  payload
});
const getInitSequenceByObjectNameCommand = payload => ({
  command: MetaBoxCommand.FInitSequenceByObjectNameCommand,
  payload
});
const getPlaySequenceCommand = payload => ({
  command: MetaBoxCommand.FPlaySequenceCommand,
  payload
});
const getJumpToSequenceCommand = payload => ({
  command: MetaBoxCommand.FJumpToSequenceCommand,
  payload
});
const getMoveSelectedCommand = payload => ({
  command: MetaBoxCommand.FMoveSelectedCommand,
  payload
});
const getRotateSelectedCommand = payload => ({
  command: MetaBoxCommand.FRotateSelectedCommand,
  payload
});
const getTakeRenderCommand = payload => ({
  command: MetaBoxCommand.FTakeRenderCommand,
  payload
});
const getTakeSpinnerRenderPreviewCommand = payload => ({
  command: MetaBoxCommand.FTakeSpinnerRenderPreviewCommand,
  payload
});
const getTakeSpinnerRenderCommand = payload => ({
  command: MetaBoxCommand.FTakeSpinnerRenderCommand,
  payload
});
const getSetMaterialCommand = payload => ({
  command: MetaBoxCommand.FSetMaterialCommand,
  payload
});
const getLoadProductCommand = payload => ({
  command: MetaBoxCommand.FLoadProductCommand,
  payload
});
const getUnLoadProductByObjectNameCommand = payload => ({
  command: MetaBoxCommand.FUnLoadProductByObjectNameCommand,
  payload
});
const getLoadLevelCommand = payload => ({
  command: MetaBoxCommand.FLoadLevelCommand,
  payload
});
const getEnableComposureCommand = payload => ({
  command: MetaBoxCommand.FEnableComposureCommand,
  payload
});
const clampPanToProductsCommand = payload => ({
  command: MetaBoxCommand.FClampPanToProductsCommand,
  payload
});
const getSetSettingsSequenceCommand = payload => ({
  command: MetaBoxCommand.FSetSettingsSequenceCommand,
  payload
});
const removeExileCommands = (state, idToRemove) => {
  const exileTimout = 10000;
  const out = {
    ...state
  };
  out.commandsInProgress = out.commandsInProgress.filter(whereNot({
    id: idToRemove
  }));
  out.totalCommandsCompleted++;
  const time = new Date().getTime();
  const markForDelete = [];
  Object.entries(out.commandsInProgress).forEach(([, {
    id,
    timeStamp
  }]) => {
    if (time - timeStamp > exileTimout) {
      markForDelete.push(id);
    }
  });
  out.totalCommandsCompleted += markForDelete.length;
  out.commandsInProgress = out.commandsInProgress.filter(command => !markForDelete.includes(command.id));
  return out;
};
const resetAfk = () => {
  sendSignal(UnrealInternalSignalEvents.RestAfkTimer);
};
function fromResizeObserver(elem) {
  return new Observable(subscriber => {
    const observer = new window.ResizeObserver(entries => subscriber.next(entries));
    observer.observe(elem);
    return () => observer.unobserve(elem);
  });
}
class VideoRecorder {
  capture(canvas) {
    // Optional frames per second argument can be set in captureStream().
    const stream = canvas.captureStream();
    this.recordedChunks = [];
    const options = {
      mimeType: 'video/webm; codecs=vp9'
    };
    this.mediaRecorder = new MediaRecorder(stream, options);
    this.mediaRecorder.ondataavailable = this.handleDataAvailable.bind(this);
    this.mediaRecorder.start();
    // demo: to download after 9sec
    /*
    setTimeout((event) => {
      mediaRecorder.stop();
    }, 9000);
    */
  }
  stop() {
    this.mediaRecorder?.stop();
  }
  handleDataAvailable(event) {
    if (event.data.size > 0) {
      this.recordedChunks.push(event.data);
      this.download();
    }
  }
  download() {
    const blob = new Blob(this.recordedChunks, {
      type: 'video/webm'
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    a.href = url;
    a.download = 'test.webm';
    a.click();
    URL.revokeObjectURL(url);
  }
}
let ClickableOverlayComponent = /*#__PURE__*/(() => {
  class ClickableOverlayComponent {
    constructor() {
      this.state = toSignal(fromSignal(UnrealInternalSignalEvents.ClickableOverlay).pipe(map$1(data => typeof data === 'object' ? data : null)));
    }
    static {
      this.ɵfac = function ClickableOverlayComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ClickableOverlayComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ClickableOverlayComponent,
        selectors: [["app-clickable-overlay"]],
        decls: 1,
        vars: 1,
        consts: [["id", "videoPlayOverlay", 3, "ngClass"], ["id", "videoPlayOverlay", 3, "click", "ngClass"], [1, "resume-box"], ["aria-hidden", "true", "role", "presentation", 1, "resume-box__pic"], [1, "text-number", 3, "innerHTML"], [1, "resume-box__text"], [1, "resume-box__heading"], [3, "colorScheme", "isFullWidth", "size", "data-testid"]],
        template: function ClickableOverlayComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, ClickableOverlayComponent_Conditional_0_Template, 2, 2, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.state() ? 0 : -1);
          }
        },
        dependencies: [NgClass, SourceButtonComponent],
        styles: ["#videoPlayOverlay[_ngcontent-%COMP%]{position:absolute;z-index:30;top:0;width:100%;height:100%;font-size:1.8em;font-family:var(--src-font-family-body);background-color:#646464b3}.clickableState[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;cursor:pointer}.textDisplayState[_ngcontent-%COMP%]{display:flex}.hiddenState[_ngcontent-%COMP%]{display:none}.resume-box[_ngcontent-%COMP%]{width:340px;padding:32px 20px 20px;flex-direction:column;align-items:center;border-radius:var(--src-border-rounded-parent, 8px);background:var(--src-color-bg-default, #fff);box-shadow:0 26px 80px #0003,0 0 1px #0003}.resume-box[_ngcontent-%COMP%]   .resume-box__pic[_ngcontent-%COMP%]{width:72px;height:72px;margin:0 auto 22px;border-radius:48px;background:#ecf0f2;padding:12px;display:flex;align-items:center;justify-content:center}.resume-box[_ngcontent-%COMP%]   .resume-box__pic[_ngcontent-%COMP%]   .text-number[_ngcontent-%COMP%]{color:var(--src-colors-text-default, #1f2937);text-align:center;font-family:var(--src-font-family-body);font-size:30px;font-style:normal;font-weight:400;line-height:24px}.resume-box__text[_ngcontent-%COMP%]{margin-bottom:18px}.resume-box__text[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{text-align:center;font-family:var(--src-font-family-body);font-size:var(--src-font-size-sm, 14px);font-style:normal;font-weight:400;line-height:24px;color:var(--src-color-text-default-subdued, #6b7280)}.resume-box__text[_ngcontent-%COMP%]   .resume-box__heading[_ngcontent-%COMP%]{color:var(--src-color-bg-default, #1f2937);text-align:center;font-family:var(--src-font-family-body);font-size:18px;font-style:normal;font-weight:500;line-height:26px;margin-bottom:8px}"],
        changeDetection: 0
      });
    }
  }
  return ClickableOverlayComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FreezeFrameComponent = /*#__PURE__*/(() => {
  class FreezeFrameComponent {
    constructor() {
      this.store = inject(Store);
      this.freezeFrameProgressMessageFromVideo = toSignal(this.store.select(selectFreezeFrameProgressMessageFromVideo));
      this.combinedFreeze = toSignal(this.store.select(selectFreezeFrameCombinedDataUrl));
    }
    static {
      this.ɵfac = function FreezeFrameComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FreezeFrameComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FreezeFrameComponent,
        selectors: [["app-freeze-frame"]],
        decls: 3,
        vars: 2,
        consts: [[1, "freeze-images"], ["alt", "freezeFrameImage", 1, "videoStillImage", 3, "src"], [1, "progress-status"]],
        template: function FreezeFrameComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵdomElementStart(0, "div", 0);
            i0.ɵɵconditionalCreate(1, FreezeFrameComponent_Conditional_1_Template, 1, 1, "img", 1);
            i0.ɵɵconditionalCreate(2, FreezeFrameComponent_Conditional_2_Template, 2, 1, "div", 2);
            i0.ɵɵdomElementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.combinedFreeze() ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.freezeFrameProgressMessageFromVideo() ? 2 : -1);
          }
        },
        styles: [".freeze-images[_ngcontent-%COMP%]{pointer-events:none;position:absolute;left:0;top:0;width:100%;height:100%;z-index:1}.freeze-images[_ngcontent-%COMP%]   .freezeFrameOverlay[_ngcontent-%COMP%]{top:0;left:0;width:100%;height:100%;position:absolute;object-fit:cover;object-position:center}.freeze-images[_ngcontent-%COMP%]   .videoStillImage[_ngcontent-%COMP%]{position:absolute;z-index:1;top:0;left:0;width:100%;height:100%;object-fit:cover}.freeze-images[_ngcontent-%COMP%]   .progress-status[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;z-index:1;display:flex;flex-direction:column;justify-content:center;align-items:center;width:auto;height:auto;margin:0;padding:10px;background-color:#ffffffb3;border:1px solid grey;transform:translate(-50%,-50%)}"],
        changeDetection: 0
      });
    }
  }
  return FreezeFrameComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SafePipe = /*#__PURE__*/(() => {
  class SafePipe {
    constructor() {
      this.sanitizer = inject(DomSanitizer);
    }
    transform(value, type) {
      if (!value) {
        return value;
      }
      switch (type) {
        case 'html':
          return this.sanitizer.bypassSecurityTrustHtml(value);
        case 'style':
          return this.sanitizer.bypassSecurityTrustStyle(value);
        case 'script':
          return this.sanitizer.bypassSecurityTrustScript(value);
        case 'url':
          return this.sanitizer.bypassSecurityTrustUrl(value);
        case 'resourceUrl':
          return this.sanitizer.bypassSecurityTrustResourceUrl(value);
        default:
          throw new Error(`Invalid safe type specified: ${type}`);
      }
    }
    static {
      this.ɵfac = function SafePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SafePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "safe",
        type: SafePipe,
        pure: true
      });
    }
  }
  return SafePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LowBandwidthModalComponent = /*#__PURE__*/(() => {
  class LowBandwidthModalComponent {
    constructor() {
      this.dialogRef = inject(DialogRef);
    }
    close(value) {
      this.dialogRef.close(value || false);
    }
    static {
      this.ɵfac = function LowBandwidthModalComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LowBandwidthModalComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LowBandwidthModalComponent,
        selectors: [["app-low-bandwidth-modal"]],
        decls: 13,
        vars: 8,
        consts: [[1, "src-modal", "src-modal--lbm"], [1, "src-modal__header"], [1, "src-modal__title"], [1, "src-modal__body"], [1, "src-modal__scroll-box", 3, "innerHtml"], [1, "src-modal__footer"], [1, "src-modal__buttons"], [3, "onClick", "data-testid"], ["colorScheme", "primary", 3, "onClick", "data-testid"]],
        template: function LowBandwidthModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "header", 1)(2, "h6", 2);
            i0.ɵɵtext(3, " Unstable Connection ");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "section", 3);
            i0.ɵɵelement(5, "div", 4);
            i0.ɵɵpipe(6, "safe");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "footer", 5)(8, "div", 6)(9, "src-button", 7);
            i0.ɵɵlistener("onClick", function LowBandwidthModalComponent_Template_src_button_onClick_9_listener() {
              return ctx.close(true);
            });
            i0.ɵɵtext(10, " Switch ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "src-button", 8);
            i0.ɵɵlistener("onClick", function LowBandwidthModalComponent_Template_src_button_onClick_11_listener() {
              return ctx.close();
            });
            i0.ɵɵtext(12, " Ok ");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵattribute("data-testid", "low-bandwidth");
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("data-testid", "title");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(6, 5, "Fluid Interactivity Modes were disabled due to an unstable connection. Showcase Gallery Mode is enabled. To regain full functionality, switch to Interactive Mode.", "html"), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("data-testid", "switch-to-interactive-mode");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("data-testid", "close-lbm-modal");
          }
        },
        dependencies: [SourceButtonComponent, SafePipe],
        styles: [".src-modal--lbm[_ngcontent-%COMP%]{width:360px}.src-modal--lbm[_ngcontent-%COMP%]   .src-modal__body[_ngcontent-%COMP%]{font-size:14px;line-height:24px}.src-modal--lbm[_ngcontent-%COMP%]   .src-modal__buttons[_ngcontent-%COMP%]{display:flex;gap:8px}"],
        changeDetection: 0
      });
    }
  }
  return LowBandwidthModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AfkRestartScreenLockerComponent = /*#__PURE__*/(() => {
  class AfkRestartScreenLockerComponent {
    constructor() {
      this.store = inject(Store);
      this.videoService = inject(VideoService);
      this.destroyRef = inject(DestroyRef);
      this.showReconnectPopup = toSignal(this.store.select(selectShowReconnectPopup));
      this.isViewportReady = toSignal(this.store.select(unrealFeature.selectViewportReady));
      this.imageLoadingSrc = toSignal(this.store.select(unrealFeature.selectImageLoadingSrc));
      this.streamConfig = toSignal(this.store.select(selectStreamConfig));
      this.isSecondStart = signal(!!(this.streamConfig()?.autoStart && location.href.match(/^https/gi)), ...(ngDevMode ? [{
        debugName: "isSecondStart"
      }] : []));
      this.playCallBack = null;
    }
    ngOnInit() {
      this.store.select(unrealFeature.selectCirrusConnected).pipe(skip$1(1), filter(Falsy), takeUntilDestroyed(this.destroyRef)).subscribe(() => this.onDisconnect());
    }
    ngAfterViewInit() {
      fromSignal(UnrealInternalSignalEvents.ShowPlayButton).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => {
        this.playCallBack = event.callback;
        if (this.videoService.video?.paused) {
          Logger.info('Simulate Press Play');
          this.playCallBack();
        }
      });
    }
    connect() {
      this.store.dispatch(initSignalling());
    }
    onDisconnect() {
      this.isSecondStart.set(true);
      this.playCallBack = null;
    }
    static {
      this.ɵfac = function AfkRestartScreenLockerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AfkRestartScreenLockerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AfkRestartScreenLockerComponent,
        selectors: [["app-afk-restart-screen-locker"]],
        decls: 1,
        vars: 1,
        consts: [[1, "preload"], [1, "back"], ["fill", "", "loading", "lazy", "alt", "image loading src", 3, "ngSrc"], [1, "stream-message-wrapper"], [1, "resume-box"], [1, "resume-box__text"], [1, "connect-button", 3, "onClick", "isFullWidth", "size", "colorScheme", "data-testid"]],
        template: function AfkRestartScreenLockerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, AfkRestartScreenLockerComponent_Conditional_0_Template, 4, 2, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.isViewportReady() ? 0 : -1);
          }
        },
        dependencies: [NgOptimizedImage, SourceButtonComponent],
        styles: [".preload[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%;text-align:center}.preload[_ngcontent-%COMP%]   .back[_ngcontent-%COMP%]{position:absolute;top:0;left:0;display:flex;justify-content:center;align-items:center;width:100%;height:100%}.preload[_ngcontent-%COMP%]   .back[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%;height:100%;object-fit:cover}.preload[_ngcontent-%COMP%]   .stream-message-wrapper[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%;background-color:transparent;z-index:3;display:flex;align-items:center;justify-content:center}.resume-box[_ngcontent-%COMP%]{padding:16px;position:absolute;bottom:0;left:50%;gap:12px;display:flex;transform:translate(-50%,-50%);flex-direction:column;align-items:center;border-radius:var(--src-border-rounded-parent, 8px);background:var(--src-color-bg-default, #fff);box-shadow:0 26px 80px #0003,0 0 1px #0003}.resume-box[_ngcontent-%COMP%]   .connect-button[_ngcontent-%COMP%]{width:100%}.resume-box__text[_ngcontent-%COMP%]{color:var(--src-color-gray-500, #6b7280);text-align:center;font-family:var(--src-font-family-body);font-size:14px;font-style:normal;font-weight:400;line-height:24px}.preload[_ngcontent-%COMP%]   .message-loader[_ngcontent-%COMP%]{position:absolute;bottom:20px;left:50%;display:block;margin:auto;transform:translate(-50%)}.preload[_ngcontent-%COMP%]   .message-loader[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{margin:0;line-height:1;transition:all ease .35s}.preload[_ngcontent-%COMP%]   .message-loader[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:10px;transition:all ease .35s}@media (min-width: 1900px){.preload[_ngcontent-%COMP%]   .message-loader[_ngcontent-%COMP%]{bottom:40px}}"],
        changeDetection: 0
      });
    }
  }
  return AfkRestartScreenLockerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let StatGraphComponent = /*#__PURE__*/(() => {
  class StatGraphComponent {
    constructor() {
      this.el = inject(ElementRef);
      this.color = input('#417bc9', ...(ngDevMode ? [{
        debugName: "color"
      }] : []));
      this.tickStep = input(3, ...(ngDevMode ? [{
        debugName: "tickStep"
      }] : []));
      this.label = input.required(...(ngDevMode ? [{
        debugName: "label"
      }] : []));
      this.data = [];
      this.max = 0;
      this.min = 0;
      this.current = 0;
    }
    set dataTick(data) {
      this.pushData(data?.value ?? null);
    }
    ngAfterViewInit() {
      this.canvas = this.graph.nativeElement;
      this.ctx = this.canvas.getContext('2d');
    }
    resize() {
      this.draw();
    }
    draw() {
      if (!this.canvas) {
        return;
      }
      const all = this.data.filter(r => r !== null && !isNaN(r));
      this.max = Math.max(...all);
      this.min = Math.min(...all);
      this.scaleY = this.canvas.height / (this.max || 1);
      this.current = all[all.length - 1] || 0;
      this.ctx.save();
      const bounds = this.el.nativeElement.getBoundingClientRect();
      this.canvas.width = bounds.width;
      this.canvas.height = bounds.height - 30; // -p height
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      [...this.data].reverse().forEach((val, index) => {
        const h = (val || 0) * this.scaleY;
        this.ctx.fillStyle = this.getColor(this.color(), h);
        this.ctx.fillRect(index * this.tickStep(), this.canvas.height - h, this.tickStep(), h);
      });
      this.ctx.restore();
    }
    getColor(fillStyle, value = 0) {
      const {
        r,
        g,
        b
      } = HEXtoRGB(fillStyle);
      /* eslint-disable-next-line prefer-const */
      let [h, s, v] = RGBtoHSV(r, g, b);
      v = inverseLerp(0, this.canvas.height, value);
      {
        const [r, g, b] = HSVtoRGB(h, s, v);
        return '#' + RGBtoHEX(r, g, b);
      }
    }
    pushData(value) {
      this.data.push(value);
      if (!this.canvas) {
        return;
      }
      if (this.data.length > this.canvas.width / this.tickStep()) {
        this.data.shift();
      }
      this.draw();
    }
    static {
      this.ɵfac = function StatGraphComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || StatGraphComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: StatGraphComponent,
        selectors: [["app-stat-graph"]],
        viewQuery: function StatGraphComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.graph = _t.first);
          }
        },
        hostBindings: function StatGraphComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("resize", function StatGraphComponent_resize_HostBindingHandler($event) {
              return ctx.resize($event);
            }, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          color: [1, "color"],
          tickStep: [1, "tickStep"],
          label: [1, "label"],
          dataTick: "dataTick"
        },
        decls: 5,
        vars: 4,
        consts: [["graph", ""], [1, "content"], [1, "graph"]],
        template: function StatGraphComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵdomElementStart(0, "div", 1)(1, "p");
            i0.ɵɵtext(2);
            i0.ɵɵdomElementEnd();
            i0.ɵɵdomElement(3, "canvas", 2, 0);
            i0.ɵɵdomElementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate4("", ctx.label(), ": ", ctx.current, " | Min:", ctx.min, " | Max:", ctx.max);
          }
        },
        styles: [".content[_ngcontent-%COMP%]{width:100%;height:100%}.content[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#fff;margin:5px 0 0;height:25px}"],
        changeDetection: 0
      });
    }
  }
  return StatGraphComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let VideoStatsComponent = /*#__PURE__*/(() => {
  class VideoStatsComponent {
    constructor() {
      this.collapsed = false;
      this.store = inject(Store);
      this.videoService = inject(VideoService);
      this.isDevMode = inject(DevModeService).isDevMode;
      this.obs$ = this.videoService.videoStats$;
      this.viewportReady = toSignal(this.store.select(unrealFeature.selectViewportReady));
      this.ssInfo = toSignal(this.store.select(selectSignalingParameters));
      this.fpsTick = toSignal(this.obs$.pipe(map$1((stat, index) => ({
        value: stat.aggregatedStats.framesPerSecond,
        hash: index
      }))));
      this.fpsAvgTick = toSignal(this.obs$.pipe(map$1((stat, index) => ({
        value: stat.aggregatedStats.avgFrameRate,
        hash: index
      }))));
      this.bitrateTick = toSignal(this.obs$.pipe(map$1((stat, index) => ({
        value: stat.aggregatedStats.bitrate,
        hash: index
      }))));
      this.videoQP = toSignal(this.obs$.pipe(map$1((stat, index) => ({
        value: stat.aggregatedStats.VideoEncoderQP,
        hash: index
      }))));
      this.bitrateAverageTick = toSignal(this.obs$.pipe(map$1((stat, index) => ({
        value: stat.aggregatedStats.avgBitrate,
        hash: index
      }))));
      this.videoStatus = toSignal(this.obs$.pipe(map$1(event => this.isDevMode && {
        ...event.aggregatedStats,
        quality: event.quality
      }), filter(Boolean), map$1(data => {
        return this.fields.map(key => {
          return {
            key,
            value: data[key]
          };
        }).filter(r => !this.elementsToShow.includes(r.key));
      })));
      this.graphList = [];
      this.idKey = 'com.source3d.unreal.stat';
      this.elementsToShow = [];
      this.trigger$ = new BehaviorSubject(undefined);
      this.getFields();
    }
    ngOnInit() {
      this.fields = ['kalmanBitrate', 'bitrateDrop', 'runTime', 'pixelRatio', 'frameHeight', 'frameWidth', ':-------------', 'jitter', 'MBytesReceived', 'framesDecoded', 'framesDropped', 'framesReceived', 'keyFramesDecoded', 'currentRoundTripTime', 'packetsLost', ':-------------', 'quality', 'videoCodec', 'kind', 'type', 'codecs'
      //'pliCount',
      //'sliCount',
      //'transportId',
      //'id',
      ];
      this.updateGraph();
    }
    updateGraph() {
      this.graphList = this.fields.map(key => {
        const stat = this.obs$.pipe(map$1((val, index) => {
          const value = val.aggregatedStats[key];
          return {
            value,
            hash: index
          };
        }));
        return {
          key,
          color: Math.floor(Math.random() * 16777216),
          stat
        };
      });
      this.graphList$ = of(this.graphList).pipe(combineLatestWith(this.trigger$), map$1(([graphList]) => graphList.filter(r => this.elementsToShow.includes(r.key))));
    }
    toggle() {
      this.collapsed = !this.collapsed;
      this.writeFields();
    }
    toggleGraph($event, el, value) {
      $event.stopPropagation();
      if (value && typeof value !== 'number' || isNaN(value)) {
        return;
      }
      if (this.elementsToShow.includes(el)) {
        this.elementsToShow = this.elementsToShow.filter(item => item !== el);
      } else {
        this.elementsToShow.push(el);
      }
      this.writeFields();
      this.trigger$.next();
    }
    getFields() {
      try {
        const {
          elements,
          collapsed
        } = JSON.parse(localStorage.getItem(this.idKey)) || [];
        this.elementsToShow = elements || [];
        this.collapsed = collapsed;
      } catch {
        this.elementsToShow = [];
      }
    }
    writeFields() {
      localStorage.setItem(this.idKey, JSON.stringify({
        collapsed: this.collapsed,
        elements: this.elementsToShow
      }));
    }
    static {
      this.ɵfac = function VideoStatsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VideoStatsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VideoStatsComponent,
        selectors: [["app-video-stats"]],
        decls: 1,
        vars: 1,
        consts: [[1, "settings-container"], [1, "gear-button", 3, "click"], ["id", "aggregatedStats", 3, "click"], [1, "forNerds"], [1, "static", 3, "click"], ["label", "FPS (higher is better)", 3, "dataTick"], ["label", "QP (lower is better)", "color", "#D5ff07", 3, "dataTick"], ["label", "Bitrate", "color", "#D57F07", 3, "dataTick"], [1, "graph"], [1, "stat"], [1, "ssInfo", 3, "innerHTML"], [1, "graph", 3, "click"], [3, "label", "dataTick", "color"], [1, "stat", 3, "click"]],
        template: function VideoStatsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, VideoStatsComponent_Conditional_0_Template, 1, 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.videoStatus() ? 0 : -1);
          }
        },
        dependencies: [StatGraphComponent, AsyncPipe, JsonPipe, SafePipe],
        styles: [".settings-container[_ngcontent-%COMP%]{position:absolute;top:65px;left:10px;z-index:1000;bottom:10px}.gear-button[_ngcontent-%COMP%]{left:0;width:50px;position:absolute;background:none;cursor:pointer;font-size:10px;font-weight:500;border:1px solid;border-radius:9px;background:#0162cc;color:#fff;padding:4px}.gear-button[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{color:#fff;filter:drop-shadow(1px 1px 1px rgb(0,0,0))}#aggregatedStats[_ngcontent-%COMP%]{max-height:calc(100% - 25px);overflow-y:auto;margin-top:25px;left:20px;z-index:31;max-width:400px;padding:10px;background-color:#fff3;border:1px solid grey}#aggregatedStats[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{color:#fff;text-shadow:-1px -1px 0 #000,1px -1px 0 #000,-1px 1px 0 #000,1px 1px 0 #000}#aggregatedStats[_ngcontent-%COMP%]:empty{display:none}#aggregatedStats[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{position:absolute;right:5px;top:5px}#aggregatedStats.min[_ngcontent-%COMP%]{display:none}#aggregatedStats[_ngcontent-%COMP%]   .forNerds[_ngcontent-%COMP%]{width:100%}#aggregatedStats[_ngcontent-%COMP%]   .forNerds[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{list-style-type:none;height:60px}#aggregatedStats[_ngcontent-%COMP%]   .forNerds[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   app-stat-graph[_ngcontent-%COMP%]{display:block;width:100%;height:100%}#aggregatedStats[_ngcontent-%COMP%]   .stat[_ngcontent-%COMP%]{cursor:pointer}#aggregatedStats[_ngcontent-%COMP%]   .stat[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-weight:700}#aggregatedStats[_ngcontent-%COMP%]   .graph[_ngcontent-%COMP%]{cursor:pointer}#aggregatedStats[_ngcontent-%COMP%]   .static[_ngcontent-%COMP%]{pointer-events:all}.ssInfo[_ngcontent-%COMP%]{position:absolute;top:0;left:50%;transform:translate(-50%);color:#fff;text-shadow:-1px -1px 0 #000,1px -1px 0 #000,-1px 1px 0 #000,1px 1px 0 #000;text-align:center;width:80%;pointer-events:none}"],
        changeDetection: 0
      });
    }
  }
  return VideoStatsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UnrealStatusComponent = /*#__PURE__*/(() => {
  class UnrealStatusComponent {
    constructor() {
      this.store = inject(Store);
      this.unrealInitialConfig = inject(UNREAL_CONFIG, {
        optional: true
      });
      this.onDisconnect$ = this.store.select(unrealFeature.selectCirrusConnected).pipe(filter(Falsy));
      this.isDevMode = inject(DevModeService).isDevMode;
      this.destroyRef = inject(DestroyRef);
      /**
       * An observable that emits smoothed percentage values from 0 to 100.
       */
      this.messagePercents$ = toSignal(this.onDisconnect$.pipe(switchMap$1(() => this.store.select(selectTotalProgress).pipe(skip(1), startWith(0), clampAndKeepMaxPercents(), floatToSmoothPercents(), combineLatestWith(this.store.select(selectShowLoader)), map$1(([progress, showLoader]) => showLoader ? progress || 0 : null)))));
    }
    ngOnInit() {
      /**
       * A subject that emits null values to trigger nullification.
       */
      const nullify$ = new Subject();
      /**
       * An observable that emits null values with a delay of 2000 milliseconds.
       */
      const nullifyObs$ = nullify$.asObservable().pipe(delay(2000));
      /**
       * An observable that emits the status message from the Unreal feature store.
       */
      const signalingStatus$ = this.store.select(unrealFeature.selectStatusMessage);
      /**
       * An observable that emits connection status messages based on the Cirrus connection state.
       * Then call side effect to nullify the message.
       */
      const cirrusConnected$ = this.store.select(unrealFeature.selectCirrusConnected).pipe(skip(1), switchMap$1(connected => connected ? of('Creating Socket...') : of('Connection closed.').pipe(tap(() => nullify$.next(null)))));
      /**
       * An observable that emits the viewport visibility state.
       */
      const viewportTrigger$ = this.store.select(unrealFeature.selectViewportReady);
      /**
       * An observable that will nullify any message displayed after 500 mSec, when viewport changes its state.
       */
      const streamToggle$ = merge(viewportTrigger$.pipe(filter(Falsy), skip(1)), viewportTrigger$.pipe(filter(Truthy))).pipe(delay(500), map$1(() => null));
      /**
       * A subscription that merges various status observables and emits debounced status via postMessage.
       */
      merge(nullifyObs$, cirrusConnected$, signalingStatus$, streamToggle$).pipe(debounceTime(0), tapLog('STATUS'), takeUntilDestroyed(this.destroyRef)).subscribe(status => this.sendMessageToIndex(status));
    }
    /**
     * Sends a message to the embedded iframe identified by the default value '3dsource_start_screen' ID.
     * This function tries to post a message to the iframe's content window. If the content
     * window is not accessible (e.g., due to cross-origin policies), the function fails silently.
     *
     * @param {string} text The message to be sent to the iframe. This could be a status update
     * or any other relevant information that the iframe needs to process.
     */
    sendMessageToIndex(text) {
      const objectElement = document.getElementById(this.unrealInitialConfig?.screenLockerContainerId || SCREEN_LOCKER_CONTAINER_ID);
      try {
        const objectDocument = objectElement.contentWindow;
        objectDocument?.postMessage(text, '*');
      } catch {
        // Fails silently if the iframe's content window cannot be accessed
      }
    }
    static {
      this.ɵfac = function UnrealStatusComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UnrealStatusComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: UnrealStatusComponent,
        selectors: [["app-unreal-status"]],
        decls: 2,
        vars: 2,
        consts: [[1, "status-box"], [1, "status-box__message"], [3, "size", "backgroundStrokeColor", "progressStrokeColor"]],
        template: function UnrealStatusComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, UnrealStatusComponent_Conditional_0_Template, 4, 4, "div", 0);
            i0.ɵɵconditionalCreate(1, UnrealStatusComponent_Conditional_1_Template, 1, 0, "app-video-stats");
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.messagePercents$() !== null ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isDevMode ? 1 : -1);
          }
        },
        dependencies: [VideoStatsComponent, SourceLoadingComponent],
        styles: ["app-stat-graph[_ngcontent-%COMP%]{height:30px;width:100%}.status-box[_ngcontent-%COMP%]{position:absolute;top:80%;left:50%;transform:translate(-50%,-50%);z-index:101;display:flex;justify-content:center;align-items:center;width:auto;max-width:500px;margin:0;background:var(--src-color-bg-default);border:none;border-radius:var(--src-border-rounded-full, 9999px);box-shadow:0 8px 20px #1718181f,0 3px 6px #17181814;pointer-events:none}.status-box__message[_ngcontent-%COMP%]{display:flex;align-items:center;padding:12px 20px 12px 16px;color:var(--src-color-text-default, #1f2937);font-size:16px;font-weight:400;line-height:24px}.status-box__message[_ngcontent-%COMP%]   .status-box__message_text[_ngcontent-%COMP%]{display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}.status-box__message[_ngcontent-%COMP%]   src-loading[_ngcontent-%COMP%]{margin-right:12px}"],
        changeDetection: 0
      });
    }
  }
  return UnrealStatusComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UnrealSceneComponent = /*#__PURE__*/(() => {
  class UnrealSceneComponent {
    constructor() {
      this.isStudio = input(false, ...(ngDevMode ? [{
        debugName: "isStudio"
      }] : []));
      this.useContainerAsSizeProvider = input(true, ...(ngDevMode ? [{
        debugName: "useContainerAsSizeProvider"
      }] : []));
      this.studioResolutionSize = input({
        width: FULL_HD_WIDTH,
        height: FULL_HD_HEIGHT
      }, ...(ngDevMode ? [{
        debugName: "studioResolutionSize"
      }] : []));
      this.studioResolutionValues = toObservable(computed(() => {
        const values = this.studioResolutionSize();
        return {
          width: values.width,
          height: values.height
        };
      }));
      this.changeMouseOverScene = output();
      this.width = FULL_HD_WIDTH;
      this.height = FULL_HD_HEIGHT;
      this.store = inject(Store);
      this.lightMode = toSignal(this.store.select(unrealFeature.selectLowBandwidth));
      this.isFreezeFrameLoading = toSignal(this.store.select(selectIsFreezeFrameLoading));
      this.aggregatorService = inject(AggregatorService);
      this.commandsSender = inject(UnrealCommunicatorService);
      this.inputService = inject(InputService);
      this.videoService = inject(VideoService);
      this.streamTelemetryService = inject(StreamStatusTelemetryService);
      this.element = inject(ElementRef);
      this.destroyRef = inject(DestroyRef);
    }
    get resizeValues() {
      if (!this.isStudio()) {
        return this.getResizeValuesUniversal();
      }
      return this.getResizeValues();
    }
    get pixelRatio() {
      return window.devicePixelRatio;
    }
    onMouseOver() {
      this.changeMouseOverScene.emit(true);
    }
    onMouseOut() {
      this.changeMouseOverScene.emit(false);
    }
    ngOnInit() {
      this.streamTelemetryService.init();
      this.aggregatorService.init();
      this.inputService.useKeyboardKeys(this.inputService.defaultKeys);
      this.store.dispatch(initSignalling());
    }
    ngAfterViewInit() {
      fromEvent(this.element.nativeElement, 'contextmenu').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => event.preventDefault());
      this.videoService.setContainer(this.container.nativeElement);
      const customSizeInputChanged$ = this.studioResolutionValues.pipe(filter(Truthy), distinctUntilChanged(), filter(({
        width,
        height
      }) => this.width !== width || this.height !== height), map$1(({
        width,
        height
      }) => ({
        width,
        height
      })), tap(({
        width,
        height
      }) => {
        this.width = width;
        this.height = height;
      }));
      const resizeRequired$ = merge(fromSignal(UnrealInternalSignalEvents.OnVideoInitialized), fromEvent(window, 'resize'));
      const videoStreamSizeChanged$ = this.videoService?.videoStats$.pipe(filter(() => !this.isFreezeFrameLoading()), map$1(stats => ({
        w: stats.aggregatedStats.frameWidth || 0,
        h: stats.aggregatedStats.frameHeight || 0
      })), distinctUntilChanged((previous, current) => fpIsASameAsB(previous.w, current.w, SAME_SIZE_THRESHOLD) && fpIsASameAsB(previous.h, current.h, SAME_SIZE_THRESHOLD)));
      merge(customSizeInputChanged$, resizeRequired$, videoStreamSizeChanged$).pipe(debounceTime$1(DEBOUNCE_TO_MANY_RESIZE_CALLS), switchMap$1(() => {
        const key = Math.random();
        // Monitoring the size of the video stream
        return timer(0, 300).pipe(take(3), map$1(() => key));
      }), map$1(key => ({
        key,
        ...this.resizeValues
      })), distinctUntilChanged((previous, current) => fpIsASameAsB(previous.w, current.w, SAME_SIZE_THRESHOLD) && fpIsASameAsB(previous.h, current.h, SAME_SIZE_THRESHOLD) && previous.key === current.key), tap(size => this.adaptVideo(size)), distinctUntilChanged((previous, current) => fpIsASameAsB(previous.w, current.w, SAME_SIZE_THRESHOLD) && fpIsASameAsB(previous.h, current.h, SAME_SIZE_THRESHOLD)), combineLatestWith(this.store.select(unrealFeature.selectDataChannelConnected).pipe(filter(Truthy))), takeUntilDestroyed(this.destroyRef)).subscribe(([size]) => {
        this.store.dispatch(changeStreamResolutionAction({
          width: size.w,
          height: size.h
        }));
        this.sendResize(size);
      });
      fromSignal(UnrealInternalSignalEvents.ForceResizeViewport).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.sendResize(this.resizeValues);
      });
    }
    ngOnDestroy() {
      this.commandsSender.destroy();
      this.store.dispatch(destroyConnectionsAndResetState());
      this.store.dispatch(resetUnrealStateAction());
    }
    adaptVideo(size) {
      const video = this.videoService.video;
      const areaSize = this.resizeValues;
      if (video?.style) {
        const pR = this.pixelRatio;
        video.width = this.makeEven(size.w / pR / areaSize.scale);
        video.height = this.makeEven(size.h / pR / areaSize.scale);
        if (!this.isStudio()) {
          video.style.overflow = 'hidden';
          video.style.objectFit = 'cover';
          video.style.width = `${video.width}px`;
          video.style.height = `${video.height}px`;
        }
      }
      sendSignal(UnrealInternalSignalEvents.VideoAdaptedToContainer);
    }
    /**
     * This method calculates the dimensions for resizing a layout in a configurator stream.
     * It takes into account the pixel ratio of the device's screen and the orientation of the layout.
     * The method uses the `fitIntoRectangle` function to calculate the dimensions that would allow the layout to fit into the maximum space while maintaining its aspect ratio.
     * It also sets the maximum limits for the width and height based on the layout's orientation.
     * If the scale of the fitted dimensions is less than 1, it assigns the fitted dimensions to the output. Otherwise, it sets the scale of the output to 1.
     * @returns {Area} An object of type `Area` that contains the calculated dimensions for resizing the layout.
     */
    getResizeValuesUniversal() {
      const pR = this.pixelRatio;
      let containerW = window.innerWidth || 2;
      let containerH = window.innerHeight || 2;
      if (this.useContainerAsSizeProvider()) {
        containerW = this.container?.nativeElement.offsetWidth || 2;
        containerH = this.container?.nativeElement.offsetHeight || 2;
      }
      const maxSpace = {
        w: containerW * pR,
        h: containerH * pR
      };
      const isVertical = containerW < containerH;
      let maxH = FULL_HD_HEIGHT;
      let maxW = FULL_HD_WIDTH;
      const params = new URLSearchParams(location.search);
      const maxRes = params.get('maxresolution');
      if (Truthy(maxRes)) {
        maxH = FULL_HD_HEIGHT * 2;
        maxW = FULL_HD_WIDTH * 2;
      }
      const maxLimits = isVertical ? {
        w: maxH,
        h: maxW,
        x: 0,
        y: 0
      } : {
        w: maxW,
        h: maxH,
        x: 0,
        y: 0
      };
      const props = fitIntoRectangle({
        x: 0,
        y: 0,
        w: containerW,
        h: containerH
      }, {
        x: 0,
        y: 0,
        ...maxSpace
      });
      let out = {
        ...props
      };
      const fitIntoMax = fitIntoRectangle(props, maxLimits);
      if (fitIntoMax.scale < 1) {
        // If reducing size to 1920x1080 is required, do it
        out = fitIntoMax;
      } else {
        // Otherwise, use the lowest resolution, because layout size is smaller than 1920x1080
        out.scale = 1;
      }
      /**
       * Ensure that the size is always even.
       */
      out.w = this.makeEven(out.w);
      out.h = this.makeEven(out.h);
      return {
        ...out
      };
    }
    getResizeValues() {
      const pR = this.pixelRatio;
      const containerW = pR * (this.container?.nativeElement.offsetWidth || 2);
      const containerH = pR * (this.container?.nativeElement.offsetHeight || 2);
      const maxSpace = {
        w: containerW,
        h: containerH
      };
      const videoSizePixelPerfect = fitIntoRectangle({
        x: 0,
        y: 0,
        w: this.width,
        h: this.height
      }, {
        x: 0,
        y: 0,
        ...maxSpace
      });
      const out = fitIntoRectangle(videoSizePixelPerfect, {
        x: 0,
        y: 0,
        w: Math.min(containerW, FULL_HD_WIDTH),
        h: Math.min(containerH, FULL_HD_HEIGHT)
      });
      /**
       * Ensure that the size is always even.
       */
      out.w = this.makeEven(out.w);
      out.h = this.makeEven(out.h);
      return out;
    }
    sendResize(size) {
      this.commandsSender.sendCommandToUnreal(getChangeResolutionCommand({
        resolution: {
          x: size.w,
          y: size.h
        }
      }));
    }
    makeEven(value) {
      return Math.floor((value + 1) / 2) * 2;
    }
    static {
      this.ɵfac = function UnrealSceneComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UnrealSceneComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: UnrealSceneComponent,
        selectors: [["app-unreal-scene"]],
        viewQuery: function UnrealSceneComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c1, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
          }
        },
        hostBindings: function UnrealSceneComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mouseover", function UnrealSceneComponent_mouseover_HostBindingHandler() {
              return ctx.onMouseOver();
            })("mouseout", function UnrealSceneComponent_mouseout_HostBindingHandler() {
              return ctx.onMouseOut();
            });
          }
        },
        inputs: {
          isStudio: [1, "isStudio"],
          useContainerAsSizeProvider: [1, "useContainerAsSizeProvider"],
          studioResolutionSize: [1, "studioResolutionSize"]
        },
        outputs: {
          changeMouseOverScene: "changeMouseOverScene"
        },
        ngContentSelectors: _c3,
        decls: 11,
        vars: 2,
        consts: [["container", ""], [1, "frame", "unreal-container"], ["id", "player"]],
        template: function UnrealSceneComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c2);
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵelement(1, "div", 2, 0)(3, "app-unreal-status")(4, "app-freeze-frame")(5, "app-clickable-overlay")(6, "app-afk-restart-screen-locker");
            i0.ɵɵprojection(7);
            i0.ɵɵprojection(8, 1);
            i0.ɵɵprojection(9, 2);
            i0.ɵɵprojection(10, 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵclassProp("lightModeCursor", ctx.lightMode());
          }
        },
        dependencies: [AfkRestartScreenLockerComponent, ClickableOverlayComponent, UnrealStatusComponent, FreezeFrameComponent],
        styles: ["#player[_ngcontent-%COMP%]{position:absolute;width:100%;height:100%;display:flex;justify-content:center;align-items:center;overflow:hidden}.unreal-container[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%;background-color:#fff}.unreal-container.select[_ngcontent-%COMP%]{cursor:url('data:image/svg+xml,<svg width=\"24\" height=\"24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15.15 21.375a1.423 1.423 0 0 1-1.15.063 1.487 1.487 0 0 1-.85-.788l-3-6.45-2.325 3.25c-.283.4-.658.525-1.125.375-.467-.15-.7-.466-.7-.95V4.05c0-.417.188-.717.563-.9.375-.183.729-.142 1.062.125l10.1 7.95c.383.284.496.65.337 1.1-.158.45-.479.675-.962.675h-4.2l2.975 6.375c.183.384.204.767.063 1.15a1.487 1.487 0 0 1-.788.85Z\" fill=\"%23000\"/><path d=\"m12.697 20.861.002.005c.237.495.617.852 1.128 1.04.515.191 1.039.16 1.539-.08a1.987 1.987 0 0 0 1.04-1.128 1.922 1.922 0 0 0-.079-1.536v-.003L13.684 13.5H17.1c.32 0 .628-.075.89-.26.263-.184.438-.447.544-.749.106-.3.135-.617.04-.925a1.458 1.458 0 0 0-.545-.738L7.936 2.883a1.51 1.51 0 0 0-.768-.336 1.471 1.471 0 0 0-.825.154 1.495 1.495 0 0 0-.626.547 1.492 1.492 0 0 0-.217.802v12.825c0 .324.08.634.272.897.193.261.467.43.775.53.31.099.632.12.942.016.31-.103.555-.313.743-.578h.001l1.825-2.552 2.639 5.673Z\" stroke=\"%23fff\" stroke-opacity=\".7\"/></svg>') 6 2,auto}.unreal-container.orbit[_ngcontent-%COMP%]{cursor:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\"><path fill=\"%23000\" d=\"M11.998 21.6c-1.966 0-3.737-.53-5.312-1.588-1.575-1.058-2.738-2.437-3.488-4.137a.852.852 0 0 1 .013-.713.867.867 0 0 1 .512-.487.86.86 0 0 1 .688.037c.225.109.387.28.487.513.617 1.35 1.559 2.45 2.825 3.3 1.267.85 2.692 1.275 4.275 1.275 1.384 0 2.646-.33 3.788-.988a7.985 7.985 0 0 0 2.762-2.612h-.85a.873.873 0 0 1-.64-.257.863.863 0 0 1-.26-.638.88.88 0 0 1 .26-.643.864.864 0 0 1 .64-.262h3c.255 0 .47.086.642.259a.87.87 0 0 1 .258.64v3a.874.874 0 0 1-.257.642.863.863 0 0 1-.637.259.88.88 0 0 1-.643-.259.865.865 0 0 1-.263-.641v-.725a9.95 9.95 0 0 1-3.35 2.925c-1.35.733-2.833 1.1-4.45 1.1Zm0-17.4c-1.383 0-2.645.33-3.787.987A7.985 7.985 0 0 0 5.448 7.8h.85c.255 0 .47.086.642.257a.863.863 0 0 1 .258.638.88.88 0 0 1-.258.642.864.864 0 0 1-.642.263h-3a.87.87 0 0 1-.64-.259.87.87 0 0 1-.26-.641v-3c0-.255.086-.469.258-.641a.863.863 0 0 1 .637-.26.88.88 0 0 1 .643.26.864.864 0 0 1 .262.64v.726A9.95 9.95 0 0 1 7.548 3.5c1.35-.733 2.834-1.1 4.45-1.1 2 0 3.788.542 5.363 1.625 1.575 1.083 2.736 2.49 3.482 4.22a.724.724 0 0 1-.045.646.926.926 0 0 1-.525.437.87.87 0 0 1-.687-.04.977.977 0 0 1-.488-.513c-.616-1.35-1.558-2.45-2.825-3.3-1.266-.85-2.691-1.275-4.275-1.275Zm0 10.8a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 8.998 12c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 11.998 9c.834 0 1.542.292 2.125.875.584.583.875 1.292.875 2.125s-.291 1.542-.875 2.125a2.893 2.893 0 0 1-2.125.875Z\"/><path stroke=\"%23fff\" stroke-opacity=\".7\" d=\"m2.739 16.072.002.005c.789 1.788 2.014 3.24 3.666 4.35 1.66 1.116 3.53 1.673 5.591 1.673 1.696 0 3.262-.386 4.69-1.16a10.54 10.54 0 0 0 2.714-2.097c.069.167.171.32.308.454.272.268.613.403.994.403.38 0 .722-.135.992-.406s.402-.614.402-.994v-3c0-.381-.134-.724-.405-.995a1.37 1.37 0 0 0-.995-.405h-3c-.383 0-.727.137-.997.411a1.38 1.38 0 0 0-.403.994c0 .38.135.723.407.992.238.237.532.369.858.397a7.552 7.552 0 0 1-2.027 1.685c-1.062.613-2.237.92-3.538.92-1.488 0-2.815-.397-3.996-1.19-1.19-.798-2.07-1.826-2.647-3.087-.147-.34-.393-.6-.727-.76a1.36 1.36 0 0 0-1.073-.058c-.37.133-.64.397-.8.754a1.351 1.351 0 0 0-.016 1.114Zm4.553-8.37a1.36 1.36 0 0 0-.858-.396A7.552 7.552 0 0 1 8.46 5.62c1.062-.613 2.237-.921 3.537-.921 1.489 0 2.816.398 3.997 1.19 1.19.8 2.07 1.827 2.646 3.088.148.34.394.6.728.76a1.37 1.37 0 0 0 1.068.063c.347-.12.62-.346.799-.668.187-.338.215-.71.072-1.072l-.003-.007-.003-.007c-.784-1.818-2.006-3.298-3.658-4.434C15.982 2.47 14.094 1.9 11.998 1.9c-1.695 0-3.261.385-4.688 1.16a10.536 10.536 0 0 0-2.715 2.096 1.364 1.364 0 0 0-.308-.453 1.38 1.38 0 0 0-.994-.403c-.38 0-.722.135-.992.406s-.403.614-.403.994v3c0 .38.135.724.406.995.27.27.614.405.994.405h3c.384 0 .727-.137.998-.412a1.38 1.38 0 0 0 .402-.993c0-.38-.135-.723-.406-.992ZM9.52 14.48a3.393 3.393 0 0 0 2.478 1.02c.965 0 1.8-.342 2.479-1.02a3.392 3.392 0 0 0 1.021-2.48c0-.963-.343-1.8-1.021-2.478A3.392 3.392 0 0 0 11.998 8.5c-.964 0-1.8.343-2.478 1.021A3.392 3.392 0 0 0 8.498 12c0 .964.344 1.8 1.022 2.479Z\"/></svg>') 12 12,auto}.unreal-container.pan[_ngcontent-%COMP%]{cursor:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\"><path fill=\"%23000\" d=\"M11.997 10.075a1.01 1.01 0 0 1-.738-.313 1.008 1.008 0 0 1-.312-.737V6.15l-.95.95a.998.998 0 0 1-.763.312 1.09 1.09 0 0 1-.763-.337 1.06 1.06 0 0 1-.324-.775c0-.3.108-.558.324-.775l2.776-2.775c.117-.116.237-.2.362-.25a1.04 1.04 0 0 1 .775 0c.125.05.246.134.363.25l2.8 2.8c.216.217.32.47.313.762a1.096 1.096 0 0 1-.338.763 1.058 1.058 0 0 1-.775.325c-.3 0-.558-.108-.775-.325l-.925-.925v2.875c0 .283-.104.53-.312.737a1.01 1.01 0 0 1-.738.313Zm0 11.5a1.04 1.04 0 0 1-.388-.075 1.103 1.103 0 0 1-.362-.25l-2.8-2.8a1.002 1.002 0 0 1-.313-.762c.009-.292.121-.546.337-.763.217-.217.475-.325.775-.325.3 0 .559.108.775.325l.926.925v-2.875c0-.283.104-.529.312-.737a1.01 1.01 0 0 1 .738-.313c.283 0 .529.104.738.313.208.208.312.454.312.737v2.875l.95-.95a.998.998 0 0 1 .762-.312c.292.008.546.12.763.337.216.217.324.475.324.775 0 .3-.108.559-.324.775l-2.775 2.775c-.117.116-.238.2-.363.25a1.04 1.04 0 0 1-.387.075Zm4.925-6.05a1.058 1.058 0 0 1-.326-.774c0-.3.109-.559.326-.776l.925-.925H14.97c-.283 0-.528-.104-.736-.312a1.01 1.01 0 0 1-.313-.738c0-.283.104-.53.313-.738.208-.208.453-.312.737-.312h2.875l-.95-.95a.998.998 0 0 1-.313-.762 1.09 1.09 0 0 1 .338-.764 1.06 1.06 0 0 1 .775-.324c.3 0 .558.108.775.324l2.774 2.776c.117.117.2.238.251.363a1.04 1.04 0 0 1 0 .775c-.05.124-.134.245-.25.362l-2.8 2.8c-.217.216-.471.32-.762.313a1.096 1.096 0 0 1-.763-.337Zm-11.4 0L2.746 12.75a1.103 1.103 0 0 1-.25-.362 1.04 1.04 0 0 1 0-.775c.05-.125.133-.246.25-.363l2.8-2.8c.216-.216.47-.32.762-.313.292.01.546.121.763.337.217.217.325.476.325.776 0 .3-.108.558-.325.775l-.925.925h2.875c.283 0 .529.104.737.312.208.209.313.455.313.738s-.105.53-.313.738a1.008 1.008 0 0 1-.737.312H6.147l.95.95c.217.217.32.471.312.762a1.09 1.09 0 0 1-.337.764 1.06 1.06 0 0 1-.775.324c-.3 0-.559-.108-.776-.324Z\"/><path stroke=\"%23fff\" stroke-opacity=\".7\" d=\"M9.22 7.912c.436.013.821-.15 1.13-.458l.097-.097v1.668c0 .422.16.793.458 1.09.298.299.67.46 1.092.46.422 0 .793-.161 1.091-.46.298-.297.459-.668.459-1.09V7.357l.071.072c.309.308.693.471 1.13.471.435 0 .82-.163 1.128-.471.301-.303.47-.676.483-1.102v-.001a1.501 1.501 0 0 0-.46-1.13l-2.799-2.8a1.6 1.6 0 0 0-.528-.36l-.003-.001a1.54 1.54 0 0 0-1.145 0l-.002.001a1.6 1.6 0 0 0-.529.36L8.118 5.172l-.001.001a1.56 1.56 0 0 0-.47 1.128c0 .435.163.82.47 1.128.303.303.676.472 1.103.484Zm0 0 .014-.5-.015.5Zm-1.311 6.865a1.497 1.497 0 0 0-.458-1.13l-.097-.097h1.668c.421 0 .793-.16 1.09-.458.298-.299.46-.67.46-1.092a1.51 1.51 0 0 0-.46-1.091 1.507 1.507 0 0 0-1.09-.459H7.354l.071-.072c.309-.308.472-.692.472-1.128 0-.436-.163-.82-.472-1.13a1.596 1.596 0 0 0-1.101-.482h-.002a1.501 1.501 0 0 0-1.129.459l-2.8 2.8a1.6 1.6 0 0 0-.36.528l-.001.003a1.54 1.54 0 0 0 0 1.144v.003c.081.2.208.375.362.529l2.774 2.775c.309.308.693.47 1.129.47.435 0 .82-.162 1.128-.47.303-.302.472-.676.484-1.102Zm0 0-.5-.014.5.015v-.001Zm3.038-8.627-.5.5.5.207V6.15Zm.475 15.814.002.001a1.54 1.54 0 0 0 1.145 0h.002c.2-.081.375-.208.53-.362l2.775-2.774a1.56 1.56 0 0 0 .47-1.129c0-.435-.162-.82-.47-1.128a1.589 1.589 0 0 0-1.103-.484 1.497 1.497 0 0 0-1.13.458l-.096.097v-1.668c0-.421-.161-.793-.459-1.09a1.509 1.509 0 0 0-1.091-.46c-.422 0-.794.161-1.092.46a1.507 1.507 0 0 0-.458 1.09v1.668l-.072-.072a1.558 1.558 0 0 0-1.129-.471c-.436 0-.82.163-1.128.471l-.001.001c-.301.302-.47.675-.483 1.101v.001c-.012.437.151.821.46 1.13l2.8 2.8c.153.153.328.28.528.36Zm5.146-6.085c.303.302.676.47 1.102.484a1.5 1.5 0 0 0 1.13-.46l2.8-2.8a1.6 1.6 0 0 0 .36-.528l.002-.003a1.54 1.54 0 0 0 0-1.144l-.001-.003a1.6 1.6 0 0 0-.361-.529l-2.774-2.775h-.001a1.56 1.56 0 0 0-1.128-.47c-.436 0-.82.162-1.128.47h-.001a1.59 1.59 0 0 0-.484 1.102c-.012.437.15.822.459 1.13l.097.097h-1.668c-.422 0-.793.16-1.09.459-.299.298-.46.67-.46 1.091 0 .422.161.793.46 1.092.297.297.668.458 1.09.458h1.668l-.072.072a1.558 1.558 0 0 0-.472 1.129c0 .435.164.82.472 1.128ZM6.147 13.05l.5.5.207-.5h-.707Z\"/></svg>') 12 12,auto}.unreal-container.dolly[_ngcontent-%COMP%]{cursor:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\"><mask id=\"a\" width=\"24\" height=\"24\" x=\"0\" y=\"0\" maskUnits=\"userSpaceOnUse\" style=\"mask-type:alpha\"><path fill=\"%23127392\" d=\"M0 0h24v24H0z\"/></mask><g mask=\"url(%23a)\"><path fill=\"%23000\" d=\"M12.002 20.575a1.026 1.026 0 0 1-.75-.325l-2.55-2.55a.933.933 0 0 1-.287-.713c.008-.275.113-.513.313-.713.2-.2.441-.3.725-.3.283 0 .524.1.724.3l.776.776V6.95l-.8.8c-.2.2-.438.296-.712.288a1.018 1.018 0 0 1-.713-.312c-.2-.2-.3-.442-.3-.726s.1-.525.3-.725l2.524-2.525a1.026 1.026 0 0 1 1.5 0l2.55 2.55c.2.2.296.438.289.713a1.023 1.023 0 0 1-.314.713c-.2.2-.441.3-.724.3a.988.988 0 0 1-.725-.3l-.775-.776v10.1l.8-.8c.2-.2.437-.296.712-.288.275.008.512.112.712.312.2.2.3.442.3.726s-.1.525-.3.725l-2.524 2.525a1.026 1.026 0 0 1-.75.325Z\"/><path stroke=\"%23fff\" stroke-opacity=\".7\" d=\"M13.553 8.153c.28.245.62.373 1 .373.415 0 .784-.153 1.078-.447.287-.287.446-.644.46-1.05v-.002a1.432 1.432 0 0 0-.435-1.08l-2.55-2.55-.354.353.354-.354a1.526 1.526 0 0 0-2.207 0L8.374 5.921A1.487 1.487 0 0 0 7.928 7c0 .416.152.785.446 1.08.288.287.645.446 1.052.457l4.127-.384Zm0 0v7.693m0-7.693a1.667 1.667 0 0 1-.079-.074l-3.021.075v7.693a1.482 1.482 0 0 0-1-.373c-.416 0-.785.153-1.079.447a1.522 1.522 0 0 0-.46 1.05v.002c-.011.417.14.786.435 1.08l2.55 2.55a1.527 1.527 0 0 0 2.207 0l2.525-2.524c.294-.294.446-.663.446-1.079 0-.416-.152-.785-.446-1.08a1.518 1.518 0 0 0-1.052-.457m0 0-.014.5.014-.5Zm0 0a1.424 1.424 0 0 0-1.027.383m0 0a1.583 1.583 0 0 0-.053.05l.354.354m-.3-.404v.104l.3.3m0 0-.3-.3v.6l.3-.3Z\"/></g></svg>') 12 12,auto}.unreal-container.disabled[_ngcontent-%COMP%]:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px)}#playerUI[_ngcontent-%COMP%]{position:absolute;z-index:10;width:100%}#statsContainer[_ngcontent-%COMP%]{display:none;text-align:left;background-color:#000c}#stats[_ngcontent-%COMP%]{padding:6px;font-weight:700;font-size:14px;color:#0f0}canvas[_ngcontent-%COMP%]{position:absolute;image-rendering:crisp-edges}#overlay[_ngcontent-%COMP%]{position:absolute;top:0;right:2%;z-index:100;padding:4px;border-top-width:0;-webkit-border-bottom-right-radius:5px;-moz-border-radius-bottomright:5px;border-bottom-right-radius:5px;-webkit-border-bottom-left-radius:5px;-moz-border-radius-bottomleft:5px;border-bottom-left-radius:5px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none}.overlay[_ngcontent-%COMP%]{font-weight:lighter;font-family:var(--src-font-family-body)}#overlayButton[_ngcontent-%COMP%]:hover{cursor:pointer}#overlayButton[_ngcontent-%COMP%]{font-size:40px;text-align:right}#overlaySettings[_ngcontent-%COMP%]{display:none;width:300px;padding:4px}#videoMessageOverlay[_ngcontent-%COMP%]{position:absolute;z-index:20;width:100%;margin:auto;font-size:1.8em;font-family:var(--src-font-family-body)}#playButton[_ngcontent-%COMP%]{display:inline-block;height:auto}img#playButton[_ngcontent-%COMP%]{width:10%;max-width:241px}#UIInteraction[_ngcontent-%COMP%]{position:fixed}#UIInteractionButtonBoundary[_ngcontent-%COMP%]{padding:2px}#UIInteractionButton[_ngcontent-%COMP%]{cursor:pointer}#hiddenInput[_ngcontent-%COMP%]{position:absolute;left:-10%;width:0;opacity:0}#editTextButton[_ngcontent-%COMP%]{position:absolute;width:40px;height:40px}"],
        changeDetection: 0
      });
    }
  }
  return UnrealSceneComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let VideoLockerComponent = /*#__PURE__*/(() => {
  class VideoLockerComponent {
    constructor() {
      this.store = inject(Store);
      this.destroyRef = inject(DestroyRef);
      this.videoIntroSrc$ = this.store.select(unrealFeature.selectVideoIntroSrc);
      this.imageIntroSrc$ = this.store.select(unrealFeature.selectImageIntroSrc).pipe(map(src => {
        // TODO need for demos site and need to delete this and move to demos
        if (!src) {
          return null;
        }
        const matchAbsolutePath = !!src.match(/.*\.(png|avif|jpg|webp|svg)(\?.*)?$/i);
        if (matchAbsolutePath) {
          return src;
        }
        return src;
      }));
    }
    ngOnInit() {
      combineLatest([this.store.select(unrealFeature.selectViewportReady), this.videoIntroSrc$, this.imageIntroSrc$]).pipe(takeUntilDestroyed(this.destroyRef), filter(([viewportReady, videoSrc, imageSrc]) => viewportReady && (!!videoSrc || !!imageSrc)), first$1()).subscribe(() => this.store.dispatch(resetIntroSrc()));
    }
    ngAfterViewInit() {
      this.videoIntroSrc$.pipe(filter(Truthy), takeUntilDestroyed(this.destroyRef)).subscribe(src => this.createVideo(src));
    }
    createVideo(src) {
      // Select the parent layout where the video will be inserted
      const videoContainer = this.videoElement.nativeElement;
      videoContainer.innerHTML = ''; // This will remove all existing content within the layout
      // Create the video element
      const videoElement = document.createElement('video');
      videoElement.autoplay = true;
      videoElement.muted = true;
      videoElement.loop = true;
      videoElement.poster = `${src}/cover.webp`;
      videoElement.style.position = 'absolute';
      videoElement.style.width = '100%';
      videoElement.style.height = '100%';
      videoElement.style.objectFit = 'cover';
      const sourceElement = document.createElement('source');
      sourceElement.src = `${src}/video.mp4`;
      sourceElement.type = 'video/mp4';
      // Append the source element to the video element
      videoElement.appendChild(sourceElement);
      // Handle browser fallback text
      videoElement.innerHTML += 'Browser not supported';
      // Append the video element to the layout
      videoContainer.appendChild(videoElement);
    }
    static {
      this.ɵfac = function VideoLockerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VideoLockerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: VideoLockerComponent,
        selectors: [["app-video-locker"]],
        viewQuery: function VideoLockerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c4, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.videoElement = _t.first);
          }
        },
        decls: 4,
        vars: 5,
        consts: [["videoPlayerCover", ""], [1, "backImage"], [1, "backVideo"], ["fill", "", "alt", "Loading...", 3, "ngSrc"]],
        template: function VideoLockerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, VideoLockerComponent_Conditional_0_Template, 2, 1, "div", 1);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "async");
            i0.ɵɵconditionalBranchCreate(3, VideoLockerComponent_Conditional_3_Template, 2, 0, "div", 2);
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵconditional((tmp_0_0 = i0.ɵɵpipeBind1(1, 1, ctx.imageIntroSrc$)) ? 0 : i0.ɵɵpipeBind1(2, 3, ctx.videoIntroSrc$) ? 3 : -1, tmp_0_0);
          }
        },
        dependencies: [NgOptimizedImage, AsyncPipe],
        styles: [".backVideo[_ngcontent-%COMP%]{position:absolute;top:0;left:0;display:flex;justify-content:center;align-items:center;width:100%;height:100%}.backVideo[_ngcontent-%COMP%]   video[_ngcontent-%COMP%]{position:absolute;width:100%;height:100%;object-fit:cover}.backImage[_ngcontent-%COMP%]{position:absolute;top:0;left:0;display:flex;justify-content:center;align-items:center;width:100%;height:100%}.backImage[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{position:absolute;width:100%;height:100%;object-fit:cover}"],
        changeDetection: 0
      });
    }
  }
  return VideoLockerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WebrtcErrorModalComponent = /*#__PURE__*/(() => {
  class WebrtcErrorModalComponent {
    constructor() {
      this.dialogRef = inject(DialogRef);
      this.store = inject(Store);
    }
    close() {
      this.dialogRef.close();
    }
    closeModalWithCirrusDisconnect() {
      this.store.select(unrealFeature.selectCirrusConnected).pipe(first()).subscribe(isConnected => {
        if (!isConnected) {
          this.store.dispatch(destroyConnectionsAndResetState());
        }
        this.close();
      });
    }
    static {
      this.ɵfac = function WebrtcErrorModalComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WebrtcErrorModalComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WebrtcErrorModalComponent,
        selectors: [["app-webrtc-error-modal"]],
        decls: 18,
        vars: 4,
        consts: [[1, "src-modal"], [1, "src-modal__header"], [1, "src-modal__title"], [1, "src-modal__body"], [2, "text-align", "left"], ["href", "https://myownconference.com/blog/en/webrtc/", "target", "blank"], [1, "src-modal__footer"], [3, "onClick", "data-testid", "colorScheme"]],
        template: function WebrtcErrorModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "header", 1)(2, "div", 2);
            i0.ɵɵtext(3, " WebRTC error ");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "section", 3)(5, "div", 4);
            i0.ɵɵtext(6, " An internet connection type (WebRTC) appears to be blocked either by your browser settings or your current network. If WebRTC is blocked on your browser you may be able to adjust these settings yourself based on instructions here: ");
            i0.ɵɵelementStart(7, "a", 5);
            i0.ɵɵtext(8, "https://myownconference.com/blog/en/webrtc/");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(9, "br")(10, "br");
            i0.ɵɵtext(11, " Trying a different web browser may help confirm this as well. If WebRTC is blocked by your network, try switching to a different network if possible or contact your network administrator.");
            i0.ɵɵelement(12, "br")(13, "br");
            i0.ɵɵtext(14, " WebRTC is common, safe and increasingly utilised method for streaming real time 3D experiences via a web browser. It typically consumes no more bandwidth than streaming an HD video. ");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(15, "footer", 6)(16, "src-button", 7);
            i0.ɵɵlistener("onClick", function WebrtcErrorModalComponent_Template_src_button_onClick_16_listener() {
              return ctx.closeModalWithCirrusDisconnect();
            });
            i0.ɵɵtext(17, " Ok ");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵattribute("data-testid", "webrtc-error-modal");
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("data-testid", "title");
            i0.ɵɵadvance(14);
            i0.ɵɵproperty("data-testid", "close-webrtc-error-modal")("colorScheme", "primary");
          }
        },
        dependencies: [SourceButtonComponent],
        styles: [".src-modal[_ngcontent-%COMP%]{--modalBodyPadding: 20px 8px 20px 20px;display:grid;grid-template-columns:minmax(0,1fr);grid-template-rows:auto minmax(0,1fr) auto}.src-modal[_ngcontent-%COMP%]     .ng-scroll-content{--_scrollbar-content-width: initial;--_viewport-padding-right: 12px}.src-modal__body[_ngcontent-%COMP%]{width:100%}.src-modal__body[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:var(--src-color-bg-default, #1f2937);font-size:14px;font-style:normal;font-weight:400;line-height:24px;margin-top:0}.src-modal__body[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{word-wrap:break-word;white-space:normal}"],
        changeDetection: 0
      });
    }
  }
  return WebrtcErrorModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FilterSettingsComponent = /*#__PURE__*/(() => {
  class FilterSettingsComponent {
    constructor() {
      this.storageKey = 'LBMFilterSettings';
      this.defaultFilterModel = {
        ...DefaultFilterModel
      };
      this.settings = {
        ...DefaultFilterModel
      };
    }
    ngOnInit() {
      const savedSettings = localStorage.getItem(this.storageKey);
      if (savedSettings) {
        this.dispatch(JSON.parse(savedSettings));
      }
    }
    togglePanel() {
      this.settings.panelOpen = !this.settings.panelOpen;
      this.saveSettings();
    }
    saveSettings() {
      const valid = Object.entries(this.settings).reduce((acc, [key, value]) => {
        return Truthy(value) ? {
          ...acc,
          [key]: value
        } : acc;
      }, {});
      this.dispatch({
        ...DefaultFilterModel,
        ...valid
      });
    }
    dispatch(model) {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(model));
      } catch (e) {
        Logger.error('Storage not available, Error saving filter settings:', e);
      }
      Object.assign(this.settings, model);
      Object.assign(FilterModel, model);
      Signal.broadcast('setKalmanParams', model);
    }
    reset() {
      this.dispatch({
        ...DefaultFilterModel,
        panelOpen: this.settings.panelOpen
      });
    }
    static {
      this.ɵfac = function FilterSettingsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FilterSettingsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FilterSettingsComponent,
        selectors: [["app-filter-settings"]],
        decls: 4,
        vars: 1,
        consts: [[1, "settings-container"], [1, "gear-button", 3, "click"], [1, "settings-panel"], ["type", "number", "name", "monitoringDelayTime", 3, "ngModelChange", "ngModel", "placeholder"], ["type", "number", "name", "minimumBitrate", 3, "ngModelChange", "ngModel", "placeholder"], ["type", "number", "name", "yellowFlag", 3, "ngModelChange", "ngModel", "placeholder"], ["type", "number", "name", "redFlag", 3, "ngModelChange", "ngModel", "placeholder"], ["type", "number", "name", "minimumFps", 3, "ngModelChange", "ngModel", "placeholder"], ["type", "number", "name", "initialBitrateEstimate", 3, "ngModelChange", "ngModel", "placeholder"], ["type", "number", "name", "initialErrorCovariance", 3, "ngModelChange", "ngModel", "placeholder"], ["type", "number", "name", "processNoise", 3, "ngModelChange", "ngModel", "placeholder"], ["type", "number", "name", "measurementNoise", 3, "ngModelChange", "ngModel", "placeholder"], [1, "apply-button-container"], [3, "click"]],
        template: function FilterSettingsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
            i0.ɵɵlistener("click", function FilterSettingsComponent_Template_button_click_1_listener() {
              return ctx.togglePanel();
            });
            i0.ɵɵtext(2, "LBM");
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(3, FilterSettingsComponent_Conditional_3_Template, 43, 18, "div", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.settings.panelOpen ? 3 : -1);
          }
        },
        dependencies: [FormsModule, i1.ɵNgNoValidate, i1.DefaultValueAccessor, i1.NumberValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.NgModel, i1.NgForm],
        styles: [".settings-container[_ngcontent-%COMP%]{position:absolute;top:65px;right:10px;z-index:1000}.gear-button[_ngcontent-%COMP%]{right:0;width:50px;position:absolute;cursor:pointer;font-size:10px;background:none;font-weight:500;border:1px solid;border-radius:9px;background:#0162cc;color:#fff;padding:4px}.gear-button[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{color:#e6f419;filter:drop-shadow(1px 1px 1px rgb(0,0,0))}.settings-panel[_ngcontent-%COMP%]{font-size:13px;background:#fff;border:1px solid #ccc;padding:15px;margin-top:25px;border-radius:4px;box-shadow:0 2px 8px #0003}.settings-panel[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{margin-top:0}.settings-panel[_ngcontent-%COMP%]   form[_ngcontent-%COMP%]{display:flex;flex-direction:column}.settings-panel[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin-bottom:10px;display:flex;flex-direction:column}.settings-panel[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{padding:4px;margin-top:4px;border:1px solid #ccc;border-radius:2px}.apply-button-container[_ngcontent-%COMP%]{position:absolute;bottom:15px;right:15px}.apply-button-container[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:6px 12px;border:none;background-color:#1976d2;color:#fff;border-radius:4px;cursor:pointer;margin:2px}.apply-button-container[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover{background-color:#1565c0}"],
        changeDetection: 0
      });
    }
  }
  return FilterSettingsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LowBandwidthDetectorComponent = /*#__PURE__*/(() => {
  class LowBandwidthDetectorComponent {
    constructor() {
      this.store = inject(Store);
      this.dialog = inject(Dialog);
      this.destroyRef = inject(DestroyRef);
      this.videoService = inject(VideoService);
      this.devModeService = inject(DevModeService);
      this.viewportReady$ = this.store.select(unrealFeature.selectViewportReady);
      this.isLowBandwidth$ = this.store.select(unrealFeature.selectLowBandwidth);
      this.lowBandwidthTrigger$ = this.isLowBandwidth$.pipe(distinctUntilChanged$1(), filter(Truthy));
      this.highBandwidthTrigger$ = this.isLowBandwidth$.pipe(distinctUntilChanged$1(), filter(Falsy));
      this.viewPortDestroyedTrigger$ = this.viewportReady$.pipe(distinctUntilChanged$1(), filter(Falsy));
      this.aggregatedStats$ = this.videoService.videoStats$.pipe(map(data => data.aggregatedStats), share());
      this.nativeQuality$ = this.videoService.videoStats$.pipe(map(data => data.quality));
      this.monitoringTrigger$ = this.viewportReady$.pipe(combineLatestWith(this.isLowBandwidth$), map(([viewPortReady, isLowBandwidth]) => viewPortReady && !isLowBandwidth)).pipe(share());
      this.reTrigger$ = this.monitoringTrigger$.pipe(map(() => ({
        quality: 'lime'
      })));
      this.canSwitchToLowBand$ = this.monitoringTrigger$.pipe(debounceTime$1(100), switchMap$1(canSwitch => concat(of(false), timer(FilterModel.monitoringDelayTime).pipe(map(() => canSwitch))).pipe(take(2), takeUntil$1(this.monitoringTrigger$))), distinctUntilChanged$1(), tapLog('DROP: [LOWBANDWIDTH] Monitoring Active =>'), share());
      this.videoQuality$ = merge(this.nativeQuality$, this.reTrigger$).pipe(share(), takeUntil$1(this.viewPortDestroyedTrigger$));
      this.fps$ = this.aggregatedStats$.pipe(map(data => data.framesPerSecond || 0));
      this.bitrateDrop$ = this.aggregatedStats$.pipe(map(data => data.dataFlowCheckResult), filter(br => br.isDropDetected), takeUntil$1(merge(this.viewPortDestroyedTrigger$, this.reTrigger$)));
      this.fps = toSignal(this.fps$);
      this.nativeQuality = toSignal(this.nativeQuality$);
      this.isLowBandwidth = toSignal(this.isLowBandwidth$);
      this.aggregatedStats = toSignal(this.aggregatedStats$);
      this.isReducedQuality = signal(false, ...(ngDevMode ? [{
        debugName: "isReducedQuality"
      }] : []));
      this.isIndicatorExpanded = signal(false, ...(ngDevMode ? [{
        debugName: "isIndicatorExpanded"
      }] : []));
      this.isIndicatorExpandedTrigger$ = toObservable(this.isIndicatorExpanded).pipe(skip(1), distinctUntilChanged$1(), filter(Falsy));
    }
    ngOnInit() {
      this.lowBandwidthTrigger$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.toggleIndicator(true));
      merge(this.viewPortDestroyedTrigger$, this.highBandwidthTrigger$).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.isReducedQuality.set(false));
      this.canSwitchToLowBand$.pipe(filter(Truthy), tap(() => {
        BITRATE_MONITOR.reset();
        this.isReducedQuality.set(false);
      }), switchMap$1(() => this.bitrateDrop$), tap(this.trySetLowBandwidth.bind(this)), map(dataFlowResult => dataFlowResult?.isDropDetected), distinctUntilChanged$1(), tap(() => {
        this.isReducedQuality.set(true);
      }), switchMap$1(() => this.videoQuality$), filter(quality => quality === 'lime'), tap(() => this.isReducedQuality.set(false)), takeUntilDestroyed(this.destroyRef)).subscribe();
    }
    trySetLowBandwidth(dataFlowResult) {
      // Evaluate FPS and native quality
      const isFpsLow = this.fps() < FilterModel.minimumFps;
      const isNativeQualityRed = this.nativeQuality() === 'red';
      const shouldSwitch = isNativeQualityRed || isFpsLow;
      // Exit if conditions are not met or already in low bandwidth
      if (!shouldSwitch || this.isLowBandwidth()) return;
      const {
        quality,
        activeMedian
      } = dataFlowResult;
      const isQualityRed = quality === 'red';
      const isLowBitrate = activeMedian < FilterModel.minimumBitrate;
      // Final check for red drop or low bitrate, or low FPS
      if (isQualityRed || isLowBitrate || isFpsLow) {
        let reason;
        if (isFpsLow) {
          reason = `FPS < ${FilterModel.minimumFps}`;
        } else if (quality === 'red') {
          reason = `Drop > ${FilterModel.redFlag}%`;
        } else {
          reason = `Speed < ${FilterModel.minimumBitrate}`;
        }
        Logger.info(`LBM DETECTED: ${reason}, switching to low bandwidth; `, dataFlowResult.message);
        this.store.dispatch(changeLowBandwidth({
          lowBandwidth: true,
          stats: {
            dataFlowResult,
            reason,
            triggerTime: this.aggregatedStats()?.runTime ?? 0
          }
        }));
      }
    }
    toggleIndicator(value) {
      this.isIndicatorExpanded.set(value);
      if (value) {
        this.hideIndicatorAfterDelay();
      }
    }
    hideIndicatorAfterDelay() {
      timer(3000).pipe(take(1), takeUntil$1(this.isIndicatorExpandedTrigger$)).subscribe(() => this.toggleIndicator(false));
    }
    openLBMDialog() {
      this.dialog.open(LowBandwidthModalComponent).closed.pipe(filter(Truthy)).subscribe(() => {
        this.toggleIndicator(false);
        this.store.dispatch(changeLowBandwidth({
          lowBandwidth: false
        }));
      });
    }
    static {
      this.ɵfac = function LowBandwidthDetectorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LowBandwidthDetectorComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LowBandwidthDetectorComponent,
        selectors: [["app-low-bandwidth-detector"]],
        decls: 2,
        vars: 2,
        consts: [[1, "lbm-indicator", "freeze-loader", 3, "expanded"], [1, "lbm-indicator", "freeze-loader"], [1, "lbm-icon", 3, "click"], ["xmlns", "http://www.w3.org/2000/svg", "fill", "none", "viewBox", "0 0 20 20"], ["fill", "#85888E", "d", "M7.189 3.605c-.73.145-1.438.35-2.126.614A14.412 14.412 0 0 0 .896 6.666a1.08 1.08 0 0 0-.375.844c0 .34.118.629.354.865s.524.36.865.375c.34.014.65-.09.927-.313a11.89 11.89 0 0 1 3.385-1.916 10.94 10.94 0 0 1 1.235-.375l-.098-2.541ZM7.385 8.708a9.107 9.107 0 0 0-2.906 1.48c-.264.194-.402.464-.416.812-.014.347.104.646.354.896.236.236.524.364.864.385.34.02.664-.073.97-.281.422-.29.878-.53 1.368-.721a2.545 2.545 0 0 1-.166-.814l-.068-1.757ZM12.386 11.267c.094-.25.15-.52.161-.802l.068-1.755a9.019 9.019 0 0 1 2.927 1.52c.264.193.4.46.406.801.007.34-.114.635-.364.885a1.213 1.213 0 0 1-.865.365A1.614 1.614 0 0 1 13.77 12a6.574 6.574 0 0 0-1.385-.733ZM12.713 6.146l.098-2.542c.73.146 1.438.351 2.127.615 1.541.59 2.93 1.406 4.166 2.447.25.223.379.5.386.834.007.333-.115.625-.365.875a1.253 1.253 0 0 1-.864.375c-.34.014-.65-.09-.927-.313a11.892 11.892 0 0 0-3.386-1.916 10.94 10.94 0 0 0-1.235-.375ZM8.813 16.187c.32.32.715.48 1.187.48.472 0 .868-.16 1.188-.48.32-.32.479-.715.479-1.187 0-.473-.16-.868-.48-1.188-.319-.32-.715-.479-1.187-.479-.472 0-.868.16-1.187.48-.32.319-.48.714-.48 1.187 0 .472.16.868.48 1.187Z"], ["fill", "#fff", "fill-rule", "evenodd", "d", "M10 .833c-.91 0-1.637.756-1.602 1.665l.304 7.92a1.299 1.299 0 0 0 2.596 0l.305-7.92A1.604 1.604 0 0 0 10 .833ZM8.813 16.187c.32.32.715.48 1.187.48.472 0 .868-.16 1.188-.48.32-.32.479-.715.479-1.187 0-.473-.16-.868-.48-1.188-.319-.32-.715-.479-1.187-.479-.472 0-.868.16-1.187.48-.32.319-.48.714-.48 1.187 0 .472.16.868.48 1.187Z", "clip-rule", "evenodd"], [1, "lbm-message"], [1, "lbm-description"], ["type", "button", 1, "lbm-learn-more", 3, "click"], ["type", "button", 1, "lbm-close", 3, "click"], ["xmlns", "http://www.w3.org/2000/svg", "width", "20", "height", "20", "viewBox", "0 0 20 20", "fill", "none"], ["d", "M10.0001 11.2289L6.68618 14.5428C6.51951 14.7095 6.31818 14.7895 6.08218 14.7828C5.84618 14.7755 5.64485 14.6885 5.47818 14.5218C5.31151 14.3552 5.22818 14.1505 5.22818 13.9078C5.22818 13.6645 5.31151 13.4595 5.47818 13.2928L8.77107 9.99992L5.45718 6.68603C5.29051 6.51936 5.21051 6.3147 5.21718 6.07203C5.22451 5.8287 5.31151 5.6237 5.47818 5.45703C5.64485 5.29036 5.84951 5.20703 6.09218 5.20703C6.33551 5.20703 6.54051 5.29036 6.70718 5.45703L10.0001 8.77092L13.314 5.45703C13.4806 5.29036 13.6853 5.20703 13.928 5.20703C14.1713 5.20703 14.3763 5.29036 14.543 5.45703C14.7096 5.6237 14.793 5.8287 14.793 6.07203C14.793 6.3147 14.7096 6.51936 14.543 6.68603L11.2291 9.99992L14.543 13.3138C14.7096 13.4805 14.793 13.6818 14.793 13.9178C14.793 14.1538 14.7096 14.3552 14.543 14.5218C14.3763 14.6885 14.1713 14.7718 13.928 14.7718C13.6853 14.7718 13.4806 14.6885 13.314 14.5218L10.0001 11.2289Z", "fill", "white"]],
        template: function LowBandwidthDetectorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, LowBandwidthDetectorComponent_Conditional_0_Template, 13, 6, "div", 0);
            i0.ɵɵconditionalCreate(1, LowBandwidthDetectorComponent_Conditional_1_Template, 1, 0, "app-filter-settings");
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.isReducedQuality() || ctx.isLowBandwidth() ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.devModeService.isDevMode ? 1 : -1);
          }
        },
        dependencies: [FilterSettingsComponent],
        styles: [".freeze-loader[_ngcontent-%COMP%], .lbm-indicator[_ngcontent-%COMP%]{--lbmPositionTop: 18px;--lbmPositionLeft: 18px;--lbmPositionRight: 18px;--lbmIndicatorSize: 36px;--lbmIndicatorBorderRadius: 8px;--lbmIndicatorCloseSize: 20px;--lbmPadding: 10px;--lbmTextSize: 13px;--lbmLineHeight: 20px;--lbmTextColor: #ffffff;--lbmBackgroundColor: rgba(17, 24, 39, .7);position:absolute;top:var(--lbmPositionTop);left:var(--lbmPositionLeft);z-index:6;display:flex;justify-content:center;align-items:flex-start;min-width:var(--lbmIndicatorSize);min-height:var(--lbmIndicatorSize);overflow:hidden}.freeze-loader.expanded[_ngcontent-%COMP%], .lbm-indicator.expanded[_ngcontent-%COMP%]{--lbmPositionTop: 8px;--lbmPositionLeft: 8px;--lbmPositionRight: 8px;width:auto;max-width:calc(100% - var(--lbmPositionLeft) - var(--lbmPositionRight));padding:var(--lbmPadding);background:var(--lbmBackgroundColor);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);border-radius:var(--lbmIndicatorBorderRadius);gap:12px}.freeze-loader[_ngcontent-%COMP%]   .lbm-icon[_ngcontent-%COMP%], .lbm-indicator[_ngcontent-%COMP%]   .lbm-icon[_ngcontent-%COMP%]{display:flex;width:var(--lbmIndicatorSize);height:var(--lbmIndicatorSize);padding:8px;color:#fff;background-color:var(--lbmBackgroundColor);border-radius:50%;flex-shrink:0;cursor:pointer}.freeze-loader[_ngcontent-%COMP%]   .lbm-icon[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], .freeze-loader[_ngcontent-%COMP%]   .lbm-icon[_ngcontent-%COMP%]   img[_ngcontent-%COMP%], .lbm-indicator[_ngcontent-%COMP%]   .lbm-icon[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], .lbm-indicator[_ngcontent-%COMP%]   .lbm-icon[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%;height:100%}.freeze-loader[_ngcontent-%COMP%]   .lbm-close[_ngcontent-%COMP%], .lbm-indicator[_ngcontent-%COMP%]   .lbm-close[_ngcontent-%COMP%]{position:absolute;top:0;right:0;width:var(--lbmIndicatorCloseSize);height:var(--lbmIndicatorCloseSize);background-color:transparent;border:none;padding:0;cursor:pointer}.freeze-loader[_ngcontent-%COMP%]   .lbm-message[_ngcontent-%COMP%], .lbm-indicator[_ngcontent-%COMP%]   .lbm-message[_ngcontent-%COMP%]{position:relative;opacity:0;height:0;max-width:0;padding-right:24px;pointer-events:none;visibility:hidden;animation:_ngcontent-%COMP%_closeMessage .3s forwards}.freeze-loader[_ngcontent-%COMP%]   .lbm-message--open[_ngcontent-%COMP%], .lbm-indicator[_ngcontent-%COMP%]   .lbm-message--open[_ngcontent-%COMP%]{position:relative;visibility:visible;display:flex;align-items:center;align-self:center;pointer-events:all;gap:12px;max-width:fit-content;height:auto;opacity:1;animation:_ngcontent-%COMP%_openMessage .3s forwards}.freeze-loader[_ngcontent-%COMP%]   .lbm-description[_ngcontent-%COMP%], .lbm-indicator[_ngcontent-%COMP%]   .lbm-description[_ngcontent-%COMP%]{margin:0;font-size:var(--lbmTextSize);font-weight:400;line-height:var(--lbmLineHeight);color:var(--lbmTextColor)}.freeze-loader[_ngcontent-%COMP%]   .lbm-learn-more[_ngcontent-%COMP%], .lbm-indicator[_ngcontent-%COMP%]   .lbm-learn-more[_ngcontent-%COMP%]{display:inline-flex;padding:0;font-size:var(--lbmTextSize);font-weight:400;line-height:var(--lbmLineHeight);color:var(--lbmTextColor);-webkit-text-decoration-line:underline;text-decoration-line:underline;background-color:transparent;border:none;cursor:pointer}.freeze-loader[_ngcontent-%COMP%]   .lbm-learn-more[_ngcontent-%COMP%]:hover, .lbm-indicator[_ngcontent-%COMP%]   .lbm-learn-more[_ngcontent-%COMP%]:hover{text-decoration:none}@keyframes _ngcontent-%COMP%_openMessage{0%{opacity:0;max-width:0;height:0}10%{height:auto;max-width:fit-content}to{opacity:1;height:auto;max-width:fit-content}}@keyframes _ngcontent-%COMP%_closeMessage{0%{opacity:1;max-width:fit-content}to{opacity:0;max-width:0}}"],
        changeDetection: 0
      });
    }
  }
  return LowBandwidthDetectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AFKService, AfkRestartScreenLockerComponent, AggregatorService, AnswerHandler, CONSOLE_COMMAND_DISABLE_MESSAGES, CONSOLE_COMMAND_ENABLE_MESSAGES, CONSOLE_COMMAND_PIXEL_QUALITY, ClickableOverlayComponent, CommandTelemetryService, ConfigHandler, ConsoleExtensionsService, DATA_CHANNEL_CONNECTION_TIMEOUT, DEBOUNCE_TO_MANY_RESIZE_CALLS, DEFAULT_AFK_TIMEOUT, DEFAULT_AFK_TIMEOUT_PERIOD, DataFlowMonitor, DevModeService, DisconnectReason, EControlSchemeType, EMessageType, EToClientMessageType, FULL_HD_HEIGHT, FULL_HD_WIDTH, FilterSettingsComponent, FreezeFrameComponent, FreezeFrameService, IceCandidateHandler, InputOptions, InputService, InstanceReadyHandler, InstanceReservedHandler, KalmanFilter1D, LatencyTimings, LowBandwidthDetectorComponent, LowBandwidthModalComponent, MINIMAL_FPS, MouseButton, MouseButtonsMask, OnCloseHandler, OnErrorHandler, OnMessageHandler, OnOpenHandler, OrchestrationMessageTypes, PingHandler, PlayerCountHandler, RegionsPingService, ResetTelemetry, SAME_SIZE_THRESHOLD, SCREEN_LOCKER_CONTAINER_ID, SIGNALLING_PERCENT_VALUE, SSInfoHandler, STREAMING_VIDEO_ID, SafePipe, SignallingService, SpecialKeyCodes, StatGraphComponent, StreamStatusTelemetryService, SubService, TelemetryStart, TelemetryStop, UNREAL_CONFIG, UnrealCommunicatorService, UnrealEffects, UnrealInternalSignalEvents, UnrealSceneComponent, UnrealStatusMessage, VideoLockerComponent, VideoRecorder, VideoService, VideoStatsComponent, WSCloseCode_NORMAL_AFK_TIMEOUT, WSCloseCode_NORMAL_CIRRUS_CLOSED, WSCloseCode_NORMAL_CLOSURE, WSCloseCode_NORMAL_MANUAL_DISCONNECT, WSCloseCodes, WS_OPEN_STATE, WS_TIMEOUT, WebRtcPlayerService, WebrtcErrorModalComponent, alignProductsToPlaneCommand, changeLowBandwidth, changeStatusMainVideoOnScene, changeStreamResolutionAction, changeStreamResolutionSuccessAction, clampAndKeepMaxPercents, clampPanToProductsCommand, commandCompleted, commandStarted, decodeData, destroyConnectionsAndResetState, destroyRemoteConnections, dispatchResize, floatToSmoothPercents, forceResizeUnrealVideo, fromResizeObserver, fromSignal, fromUnrealCallBackSignal, getActiveUrl, getApplyCameraPresetCommand, getApplyZoomCommand, getCameraBoxCommand, getCameraRecenterCommand, getCameraSettingsCommand, getChangeGizmoTypeCommand, getChangeResolutionCommand, getClickSnapCommand, getControlSensitivityCommand, getDebugModeCommand, getDragCommand, getDragSequenceCommand, getDropCommand, getEnableComposureCommand, getEnableControlsCommand, getEnableSceneStateCallbackCommand, getEnableSpinnerModeCommand, getEnableTeleportCommand, getExecuteConsoleCommand, getFitToObjectsCommand, getFreezeFrameCommand, getFreezeFrameNative, getImageFromVideoStream, getInitSequenceByObjectNameCommand, getJumpToSequenceCommand, getLoadLevelCommand, getLoadProductCommand, getLoadSceneStateCommand, getLoopBackCommand, getMoveSelectedCommand, getPauseSequenceCommand, getPlaySequenceCommand, getRequestCameraPresetCommand, getResetControlClampsCommand, getRotateSelectedCommand, getRtcErrorMessage, getSelectProductByObjectNameCommand, getSetCameraControlClampsCommand, getSetControlCameraModeCommand, getSetFpsCommand, getSetMaterialCommand, getSetPawnMovementModeCommand, getSetSettingsSequenceCommand, getStopSequenceCommand, getTakeRenderCommand, getTakeSpinnerRenderCommand, getTakeSpinnerRenderPreviewCommand, getUnLoadAllProductsCommand, getUnLoadProductByObjectNameCommand, getUnfreezeFrameNative, getUnselectAllProductsCommand, getWeatherCommand, initSignalling, initialState, mapQpToQuality, observeCommandResponse, removeExileCommands, resetAfk, resetAfkAction, resetConfig, resetIntroSrc, resetUnrealState, resetUnrealStateAction, resetWarnTimeout, selectCommandProgress, selectCommandsInProgress, selectFreezeFrameCombinedDataUrl, selectFreezeFrameDataUrl, selectFreezeFrameDataUrlFromVideo, selectFreezeFrameProgressMessageFromVideo, selectIsAutostart, selectIsFreezeFrameLoading, selectIsVideoPlayingAndDataChannelConnected, selectLastCommandInProgress, selectLoaderCommands, selectMatchUrls, selectShowLoader, selectShowReconnectPopup, selectSignalingParameters, selectStreamConfig, selectTotalProgress, selectWarnTimeout, selectWsUrl, sendSignal, setAwsInstance, setCirrusConnected, setCirrusDisconnected, setConfig, setDataChannelConnected, setErrorMessage, setEstablishingConnection, setFreezeFrame, setFreezeFrameFromVideo, setIntroImageSrc, setIntroVideoSrc, setLoadingImageSrc, setLoopBackCommandIsCompleted, setMatchUrls, setMaxFps, setProductsLocationCommand, setSignalingName, setStatusMessage, setStatusPercentSignallingServer, setStreamClientCompanyId, setStreamViewId, setViewportReady, showUnrealErrorMessage, smoothTransition, trackMixpanelEvent, unLoadAllLevelsCommand, unrealFeature, unrealReducer, updateCirrusInfo };
